var common =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _blocksTrackerTracker = __webpack_require__(140);
	
	var _blocksTrackerTracker2 = _interopRequireDefault(_blocksTrackerTracker);
	
	var _blocksTrackerEvents = __webpack_require__(131);
	
	var _blocksTrackerEvents2 = _interopRequireDefault(_blocksTrackerEvents);
	
	var functions = __webpack_require__(166);
	
	__webpack_require__(357);
	__webpack_require__(360);
	__webpack_require__(371);
	__webpack_require__(373);
	__webpack_require__(375);
	__webpack_require__(377);
	__webpack_require__(379);
	__webpack_require__(381);
	__webpack_require__(383);
	__webpack_require__(385);
	__webpack_require__(387);
	__webpack_require__(390);
	__webpack_require__(392);
	__webpack_require__(393);
	__webpack_require__(396);
	__webpack_require__(399);
	__webpack_require__(401);
	__webpack_require__(404);
	__webpack_require__(411);
	__webpack_require__(414);
	__webpack_require__(416);
	__webpack_require__(424);
	__webpack_require__(427);
	__webpack_require__(430);
	__webpack_require__(433);
	__webpack_require__(436);
	__webpack_require__(293);
	__webpack_require__(438);
	__webpack_require__(318);
	__webpack_require__(441);
	__webpack_require__(442);
	__webpack_require__(454);
	
	__webpack_require__(457);
	__webpack_require__(463);
	__webpack_require__(309);
	__webpack_require__(467);
	__webpack_require__(469);
	__webpack_require__(306);
	
	__webpack_require__(337);
	__webpack_require__(470);
	__webpack_require__(471);
	
	__webpack_require__(475);
	__webpack_require__(477);
	
	/* Для корректногй работы popup-карточки на любой странице */
	__webpack_require__(478);
	//require('./blocks/product-card/product-card');
	__webpack_require__(483);
	__webpack_require__(485);
	__webpack_require__(222);
	/* Popup корзина необходима на любой странице */
	
	__webpack_require__(443);
	__webpack_require__(488);
	__webpack_require__(490);
	
	__webpack_require__(492);
	__webpack_require__(498);
	__webpack_require__(499);
	__webpack_require__(500);
	__webpack_require__(501);
	__webpack_require__(502);
	__webpack_require__(503);
	__webpack_require__(504);
	__webpack_require__(506);
	
	__webpack_require__(130);
	
	__webpack_require__(508);
	window.picturefill();
	
	var trackers = new _blocksTrackerTracker2['default']();
	var events = new _blocksTrackerEvents2['default']();
	events.init();
	
	jQuery(function ($) {
	    //это нужно чтобы на ай-осях клик срабатывал.
	    //на боди кликаем когда хотим закрыть что-нибудь выпадающее
	    if (functions.isIOS()) $('body').css('cursor', 'pointer');
	
	    var $mainContainer = $('.main-container');
	    $mainContainer.append('<div class="overlay" id="overlay" />');
	
	    $('.js-scroll-link').click(function (e) {
	        var $this = $(this);
	        var target = this.hash;
	
	        var $clickedTarget = $(e.target);
	
	        if (!$this.is('a, button')) {
	            if ($clickedTarget.is('a, button') || $clickedTarget.closest('a, button').length > 0) return;
	
	            target = '#' + $this.data('href');
	        }
	        e.preventDefault();
	        var $target = $(target);
	        var top = $target.offset().top - 10;
	
	        $('html, body').stop().animate({
	            scrollTop: top
	        }, 700, 'swing', function () {
	            //window.location.hash = target;
	        });
	    });
	    $('.js-consult-button').click(function () {
	        trackers.onAdviserWindow();
	    });
	    $('#carrotquest-messenger-reply-button').click(function () {
	        trackers.onAdviserReply();
	    });
	    $(document).on('click', '#js-carrotquest-clicker', function () {
	        //$('#carrotquest-messenger-collapsed').click();
	        $('.b24-widget-button-wrapper').click();
	    });
	    /**
	     *  Событие на отправку сообщение в чат bitrix 24
	     *  Добавляем Google Client Id
	     */
	    window.addEventListener('onBitrixLiveChat', function (event) {
	        // Проверяем корректность параметров события
	        if (!event || !event.detail || !event.detail.widget) {
	            return;
	        }
	        var widget = event.detail.widget;
	        var ga = 'GoogleAnalyticsUserID=' + functions.getCookie('_ga');
	        widget.setCustomData(ga);
	    });
	    window.addEventListener('b24:form:init', function (event) {
	        var form = event.detail.object;
	        form.setProperty('_ym_uid', functions.getCookie('_ym_uid'));
	        form.setProperty("uf_lead_utm_campaign_hidden_form", functions.getCookie('utm_campaign'));
	        form.setProperty("uf_lead_utm_medium_hidden_form", functions.getCookie('utm_medium'));
	        form.setProperty("uf_lead_utm_source_hidden_form", functions.getCookie('utm_source'));
	    });
	    trackers.backendPageViewed();
	    trackers.clientTimeSite();
	});
	// Полифилл для closest
	(function () {
	    if (!Element.prototype.closest) {
	        Element.prototype.closest = function (css) {
	            var node = this;
	            while (node) {
	                if (node.matches(css)) return node;else node = node.parentElement;
	            }
	            return null;
	        };
	    }
	})();
	(function (doc, win) {
	    $(doc).ready(function () {
	        var searchForm = document.querySelector('.simple-search-form form');
	        if (!searchForm) {
	            return;
	        }
	        searchForm.onsubmit = function () {
	            trackers.onSearch({
	                fbpixel: {
	                    content_name: this.firstElementChild.value
	                }
	            });
	        };
	        trackers.onContentView({ fbpixel: win.location.pathname.split('/')[1] });
	    });
	})(document, window);
	$('body').on('click', '.subscribe__form .follow-by-email-submit', function () {
	    var email = $('.subscribe__form input[name="sf_EMAIL"]').val();
	    var emailPattern = /^([a-z0-9_.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
	
	    if (emailPattern.test(email)) {
	        $.ajax({
	            type: 'POST',
	            url: '/ajax/action/subscribe_form/subscribe/',
	            data: {
	                email: email
	            },
	            success: function success(response) {
	                if (response.message == 'ok') {
	                    $('.subscribe__form .flex-row-email.block-email').html('Вы успешно подписаны!');
	                    $('.subscribe__form .flex-row-email.block-email').addClass('success');
	                    $('.block-email-fotter').css('display', 'none');
	                    trackers.onSubscriptionDone();
	                } else {
	                    $('.subscribe__form .flex-row-email.block-email .subscribe-form__error').html(response.message + '!');
	                }
	            },
	            dataType: 'json'
	        });
	    }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(50);
	
	jQuery(function () {
	    module.exports.params = {
	        infinite: true,
	        adaptiveHeight: true,
	        slidesToScroll: 1,
	        speed: 400
	    };
	
	    module.exports.paramsCssAnim = {
	        cssEase: 'ease',
	        useTransform: true,
	        speed: 600
	    };
	});

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    // Returns a function, that, as long as it continues to be invoked, will not
	    // be triggered. The function will be called after it stops being called for
	    // N milliseconds. If `immediate` is passed, trigger the function on the
	    // leading edge, instead of the trailing.
	    debounce: function debounce(func, wait, immediate) {
	        var timeout;
	        return function () {
	            var context = this,
	                args = arguments;
	            var later = function later() {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    },
	
	    setResizeDebounce: function setResizeDebounce(func, wait, immediate) {
	        wait = wait || 250;
	        immediate = immediate || false;
	        var thisD = this;
	        var debouncedFunc = thisD.debounce(func, wait, immediate);
	        $(window).resize(debouncedFunc);
	    }
	};

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$defineProperties = __webpack_require__(56)['default'];
	
	module.exports = _Object$defineProperties({}, {
	    defaultFontSize: {
	        get: function get() {
	            var defaultFontSize = parseInt($('html').css('font-size'));
	            if (isNaN(defaultFontSize)) defaultFontSize = 16;
	            return defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobile: {
	        get: function get() {
	            return 20 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobileBig: {
	        get: function get() {
	            return 28 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tablet: {
	        get: function get() {
	            return 48 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tabletBig: {
	        get: function get() {
	            return 60 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    desktop: {
	        get: function get() {
	            return 76.5 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    }
	});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(57), __esModule: true };

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(58);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperties: __webpack_require__(75) });


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var core = __webpack_require__(61);
	var ctx = __webpack_require__(62);
	var hide = __webpack_require__(64);
	var has = __webpack_require__(74);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(63);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var createDesc = __webpack_require__(73);
	module.exports = __webpack_require__(69) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var IE8_DOM_DEFINE = __webpack_require__(68);
	var toPrimitive = __webpack_require__(72);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(69) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(69) && !__webpack_require__(70)(function () {
	  return Object.defineProperty(__webpack_require__(71)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(70)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	var document = __webpack_require__(60).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(67);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var anObject = __webpack_require__(66);
	var getKeys = __webpack_require__(76);
	
	module.exports = __webpack_require__(69) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(77);
	var enumBugKeys = __webpack_require__(90);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(74);
	var toIObject = __webpack_require__(78);
	var arrayIndexOf = __webpack_require__(82)(false);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(79);
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(80);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(78);
	var toLength = __webpack_require__(83);
	var toAbsoluteIndex = __webpack_require__(85);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(84);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(87)('keys');
	var uid = __webpack_require__(89);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(61);
	var global = __webpack_require__(60);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(88) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(112);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(113);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(114), __esModule: true };

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperty: __webpack_require__(65).f });


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(117);

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(119);

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	__webpack_require__(121);
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var PreLoader = (function () {
	    function PreLoader(options) {
	        _classCallCheck(this, PreLoader);
	
	        var defaults = PreLoader.getDefaultOptions();
	        this.options = _jquery2['default'].isPlainObject(options) ? _jquery2['default'].extend(true, defaults, options) : defaults;
	        this.$element = (0, _jquery2['default'])(this.options.selector);
	        this.$loader = (0, _jquery2['default'])(this.options.block);
	        this.$loader.addClass(this.options['class']);
	    }
	
	    _createClass(PreLoader, [{
	        key: 'show',
	        value: function show(speed) {
	            speed = this.speed(speed);
	            this.$element.append(this.$loader);
	            this.$loader.stop(true).fadeIn(speed);
	        }
	    }, {
	        key: 'hide',
	        value: function hide(speed) {
	            speed = this.speed(speed);
	            var loader = this.$loader;
	            loader.stop(true).fadeOut(speed, function () {
	                loader.detach();
	            });
	        }
	    }, {
	        key: 'speed',
	        value: function speed(_speed) {
	            return _jquery2['default'].isNumeric(_speed) ? parseInt(_speed) | 0 : this.options.speed;
	        }
	    }], [{
	        key: 'getDefaultOptions',
	        value: function getDefaultOptions() {
	            return {
	                speed: 200,
	                selector: 'body',
	                block: '<div class="maximaster-preloader"></div>',
	                'class': ''
	            };
	        }
	    }, {
	        key: 'isString',
	        value: function isString(variable, noEmpty) {
	            var answer = !!(variable === '' || variable && variable.split);
	            if (noEmpty === true) {
	                answer = answer && variable.length > 0;
	            }
	
	            return answer;
	        }
	    }]);
	
	    return PreLoader;
	})();
	
	exports['default'] = PreLoader;
	module.exports = exports['default'];

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports) {

	module.exports = $;

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerEvents = __webpack_require__(131);
	
	var _trackerEvents2 = _interopRequireDefault(_trackerEvents);
	
	__webpack_require__(147);
	__webpack_require__(149);
	
	var event = new _trackerEvents2['default']();
	event.onShowProductCard();
	
	$('#toogle_open').click(function () {
	    $('.li_toogle').css('display', 'list-item');
	    $('.li_toogle').addClass('li_toogle_close');
	    $('#toogle_open').css('display', 'none');
	    $('#toogle_close').css('display', 'block');
	});
	$('#toogle_close').click(function () {
	    $('.li_toogle').css('display', 'none');
	    $('.li_toogle').removeClass('li_toogle_close');
	    $('#toogle_open').css('display', 'block');
	    $('#toogle_close').css('display', 'none');
	});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _tracker = __webpack_require__(140);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	Element.prototype.parents = function (selector) {
	    var elements = [];
	    var elem = this;
	    var ishaveselector = selector !== undefined;
	
	    while ((elem = elem.parentElement) !== null) {
	        if (elem.nodeType !== Node.ELEMENT_NODE) {
	            continue;
	        }
	
	        if (!ishaveselector || elem.matches(selector)) {
	            elements.push(elem);
	        }
	    }
	
	    return elements;
	};
	
	var Events = (function () {
	    function Events() {
	        _classCallCheck(this, Events);
	
	        this.searchData = [];
	    }
	
	    _createClass(Events, [{
	        key: 'init',
	        value: function init() {
	            var self = this;
	            this.onClickSoc();
	            this.onClickCity();
	            this.onClickSocIcon();
	            this.onClickProductTabs();
	            this.onClickProductPdf();
	            this.onClickPhone();
	            this.onClickTabs();
	            this.showMainBanner();
	            this.showSpecBanner();
	            this.onClickMainPromo();
	            this.onShowWatched();
	            this.onShowAnalog();
	            this.onClickProductCatalogBlock();
	            this.onClickWatched();
	            this.onClickAnalog();
	            this.onShowCatalogProducts();
	
	            setTimeout(function () {
	                self.onShowNewProducts();
	                self.onClickNewProducts();
	            }, 1000);
	        }
	    }, {
	        key: 'onClickSoc',
	        value: function onClickSoc() {
	            $('body').on('click', '.footer__column--social a', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickTabs',
	        value: function onClickTabs() {
	            $('body').on('click', '.tabs__tab--cloud', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickPhone',
	        value: function onClickPhone() {
	            $('body').on('click', '.city-data-block__phones-link', function (e) {
	                var trackers = new _tracker2['default']();
	                trackers.onPMbtnTel();
	            });
	        }
	    }, {
	        key: 'onClickProductTabs',
	        value: function onClickProductTabs() {
	            $('body').on('click', '.product-card__tabs .tabs__tab', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickProductPdf',
	        value: function onClickProductPdf() {
	            $('body').on('click', '.product-card__previews-item--pdf', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickPdf(data);
	            });
	        }
	    }, {
	        key: 'onClickSocIcon',
	        value: function onClickSocIcon() {
	            $('body').on('click', '.bottom-menu__text-contacts-icon', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent(data);
	            });
	        }
	    }, {
	        key: 'onClickCity',
	        value: function onClickCity() {
	            $('body').on('click', '.cities-list .cities-list__item a', function (e) {
	                var data = this.dataset;
	                var trackers = new _tracker2['default']();
	                trackers.onClickEvent({
	                    event: 'PMbtnSelectCity',
	                    param: data.code
	                });
	            });
	        }
	
	        /**
	         * ловим события баннера на главной странице
	         */
	    }, {
	        key: 'showMainBanner',
	        value: function showMainBanner() {
	            var localBanners = [];
	            var self = this;
	            $('.js-slick-fullwidth-slider').on('init', function (event, slick) {
	                var activeBanner = document.querySelectorAll('.fullwidth-slider .slick-track .slick-active');
	                var bannerId = self.sendItemBanner(localBanners, activeBanner[0].dataset, 'indexTopSlider');
	                localBanners.push(bannerId);
	            }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
	                var activeBanner = document.querySelectorAll('.fullwidth-slider .slick-track .slick-active');
	                var bannerId = self.sendItemBanner(localBanners, activeBanner[0].dataset, 'indexTopSlider');
	                localBanners.push(bannerId);
	            });
	        }
	    }, {
	        key: 'showSpecBanner',
	        value: function showSpecBanner() {
	            var localBanners = [];
	            var specBanners = document.querySelectorAll('.block-list--promos a.tiles__item--promo');
	            var self = this;
	
	            specBanners.forEach(function (element, index) {
	                var banner = {
	                    id: element.dataset.id,
	                    name: element.dataset.name,
	
	                    position: 'slot' + index
	                };
	                var bannerId = self.sendItemBanner(localBanners, banner, 'indexBannerSpec');
	                localBanners.push(bannerId);
	            });
	        }
	    }, {
	        key: 'sendItemBanner',
	        value: function sendItemBanner(localBanners, activeBanner, name) {
	            if (activeBanner !== undefined) {
	                if (localBanners.indexOf(activeBanner.id) === -1) {
	                    var _trackers = new _tracker2['default']();
	                    _trackers.onViewPromo({
	                        promoView: {
	                            promotions: [{
	                                id: activeBanner.id,
	                                name: name,
	                                creative: activeBanner.name,
	                                position: activeBanner.position
	                            }]
	                        }
	                    });
	                    localBanners.push(activeBanner.id);
	                    return activeBanner.id;
	                }
	            }
	        }
	    }, {
	        key: 'onClickMainPromo',
	        value: function onClickMainPromo() {
	            $('body').on('click', '.block-list.block-list--promos a', function (e) {
	                var dataId = this.getAttribute('data-id');
	                var dataName = this.getAttribute('data-name');
	                var trackers = new _tracker2['default']();
	                var dataNumber = 0;
	                if (this.parentNode.classList.contains('tiles__item--action-content')) {
	                    dataNumber = parseInt($(this.parentNode.parentNode).index()) + 1;
	                } else {
	                    dataNumber = parseInt($(this).index()) + 1;
	                }
	                trackers.onClickPromo({
	                    promoClick: {
	                        promotions: [{
	                            id: dataId,
	                            name: dataName,
	                            creative: 'banner' + dataNumber,
	                            position: 'slot' + dataNumber
	                        }]
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'onShowNewProducts',
	        value: function onShowNewProducts() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.products-slider .products-slider__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'newProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowNewProducts({
	                    impressions: productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowWatched',
	        value: function onShowWatched() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.also-viewed .grid__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'WatchedProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowWatchedProducts({
	                    impressions: productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowAnalog',
	        value: function onShowAnalog() {
	            var productData = [];
	            var self = this;
	            var products = document.querySelectorAll('.site-block .tabs__content .grid__item');
	            products.forEach(function (item, index) {
	                var productsData = self.prepareData(item);
	                var product = _extends({
	                    list: 'AnalogProducts',
	                    position: index
	                }, productsData);
	
	                productData.push(product);
	            });
	
	            var trackers = new _tracker2['default']();
	
	            if (productData.length > 0) {
	                trackers.onShowAnalogProducts({
	                    impressions: productData
	                });
	            }
	        }
	
	        /**
	         * отображение каталога, отправляем пачками по 8 элементов. Когда появляется 1ый из группы
	         */
	    }, {
	        key: 'onShowCatalogProducts',
	        value: function onShowCatalogProducts() {
	            var products = [];
	            var productNodes = document.querySelectorAll('.catalog #catalog__products .grid__item');
	            var self = this;
	
	            productNodes.forEach(function (item, index) {
	                if (index % 8 === 0) {
	                    new Waypoint.Inview({
	                        element: item,
	                        enter: function enter() {
	                            if (products.indexOf(index) === -1) {
	                                (function () {
	                                    var productsArr = Array.prototype.slice.call(productNodes).slice(index, index + 8);
	                                    var productsList = [];
	
	                                    products.push(index);
	
	                                    productsArr.forEach(function (elem, i) {
	                                        var productData = self.prepareData(elem);
	                                        productsList.push(_extends({
	                                            list: 'catalogProducts',
	                                            position: index + i + 1
	                                        }, productData));
	                                    });
	                                    var trackers = new _tracker2['default']();
	
	                                    if (productsList.length > 0) {
	                                        trackers.onShowcatalogProducts({
	                                            impressions: productsList
	                                        });
	                                    }
	                                })();
	                            }
	                        }
	                    });
	                }
	            });
	        }
	
	        /**
	         * отображение каталога в поиске, отправляем пачками по 10 элементов. Когда появляется 1ый из группы
	         */
	    }, {
	        key: 'onShowSearchProducts',
	        value: function onShowSearchProducts() {
	            var productNodes = document.querySelectorAll('.search_container #catalog__products .grid__item');
	            var self = this;
	
	            productNodes.forEach(function (item, index) {
	                if (index % 10 === 0) {
	                    new Waypoint.Inview({
	                        element: item,
	                        enter: function enter() {
	                            if (self.searchData.indexOf(index) === -1) {
	                                (function () {
	                                    var productsArr = Array.prototype.slice.call(productNodes).slice(index, index + 10);
	                                    var productsList = [];
	
	                                    self.searchData.push(index);
	
	                                    productsArr.forEach(function (elem, i) {
	                                        var productData = self.prepareData(elem);
	                                        productsList.push(_extends({
	                                            list: 'searchProducts',
	                                            position: index + i + 1
	                                        }, productData));
	                                    });
	                                    var trackers = new _tracker2['default']();
	
	                                    if (productsList.length > 0) {
	                                        trackers.onShowcatalogProducts({
	                                            impressions: productsList
	                                        });
	                                    }
	                                })();
	                            }
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'onClickProductCatalogBlock',
	        value: function onClickProductCatalogBlock() {
	            var self = this;
	
	            $('.grid.catalog .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('#catalog__products .grid__item') + 1;
	                var product = _extends({
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'catalogProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickCatalogProducts({
	                    click: {
	                        actionField: {
	                            list: 'catalogProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickProductSearchBlock',
	        value: function onClickProductSearchBlock() {
	            var self = this;
	            $('.search_container .grid .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('#catalog__products .grid__item') + 1;
	                var product = _extends({
	                    list: 'searchProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'searchProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickCatalogProducts({
	                    click: {
	                        actionField: {
	                            list: 'searchProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickWatched',
	        value: function onClickWatched() {
	            var self = this;
	            $('.also-viewed.grid .product').on('click', 'a, img', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('.also-viewed .grid__item') + 1;
	                var product = _extends({
	                    list: 'WatchedProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'WatchedProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickWatched({
	                    click: {
	                        actionField: {
	                            list: 'WatchedProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickAnalog',
	        value: function onClickAnalog() {
	            var self = this;
	            $('.site-block .tabs__content .grid__item .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.grid__item')[0]).index('.site-block .tabs__content .grid__item') + 1;
	                var product = _extends({
	                    list: 'AnalogProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'AnalogProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickAnalog({
	                    click: {
	                        actionField: {
	                            list: 'AnalogProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onClickNewProducts',
	        value: function onClickNewProducts() {
	            var self = this;
	            $('.products-slider .products-slider__item .product').on('click', 'a', function () {
	                var productDom = $(this).parents('.product')[0];
	                var productData = self.prepareData(productDom);
	                var position = $($(this).parents('.products-slider__item')[0]).index('.products-slider .products-slider__item') + 1;
	                var product = _extends({
	                    list: 'newProducts',
	                    position: position
	                }, productData);
	                localStorage.setItem('list', 'newProducts');
	                var trackers = new _tracker2['default']();
	                trackers.onClickNewProducts({
	                    click: {
	                        actionField: {
	                            list: 'newProducts'
	                        }
	                    },
	                    products: [product]
	                });
	            });
	        }
	    }, {
	        key: 'onShowProductCard',
	        value: function onShowProductCard() {
	            var self = this;
	            if ($('.product-card').length > 0) {
	                var productDom = $('.product-card')[0];
	                var _productData = self.prepareData(productDom);
	                var product = _extends({}, _productData);
	
	                var _trackers2 = new _tracker2['default']();
	                _trackers2.onShowProductCard({
	                    detail: {
	                        actionField: {
	                            list: localStorage.getItem('list')
	                        }
	                    },
	                    products: [product]
	                });
	            }
	        }
	    }, {
	        key: 'onShowProductCardPopup',
	        value: function onShowProductCardPopup() {
	            var self = this;
	            var productDom = $('.product-card')[0];
	            var productData = self.prepareData(productDom);
	            var product = _extends({}, productData);
	
	            var trackers = new _tracker2['default']();
	            trackers.onShowProductCardPopup({
	                detail: {
	                    actionField: {
	                        list: localStorage.getItem('list')
	                    }
	                },
	                products: [product]
	            });
	        }
	    }, {
	        key: 'onAddToCardProduct',
	        value: function onAddToCardProduct(elem) {
	            //проверяем откуда клик на добавление в корзину (карточка, списки)
	            if (elem.hasClass('product-card__btn')) {
	                this.addToCardFromCard(elem);
	            } else {
	                this.addToCardFromList(elem);
	            }
	        }
	    }, {
	        key: 'addToCardFromCard',
	        value: function addToCardFromCard(elem) {
	            var self = this;
	            var productDom = elem.parents('.product-card')[0];
	            var productData = self.prepareData(productDom);
	            var product = _extends({
	                quantity: 1
	            }, productData);
	            var trackers = new _tracker2['default']();
	            trackers.addToCardFromCard({
	                add: {
	                    products: [product]
	                }
	            });
	        }
	    }, {
	        key: 'addToCardFromList',
	        value: function addToCardFromList(elem) {
	            var self = this;
	            var productDom = elem.parents('.product')[0];
	            var position = 0;
	            var list = '';
	            var productData = self.prepareData(productDom);
	
	            if (elem.parents('.catalog #catalog__products').length > 0) {
	                list = 'catalogProducts';
	                position = $(elem.parents('.grid__item')).index('#catalog__products .grid__item') + 1;
	            } else if (elem.parents('.slick-track').length > 0) {
	                list = 'newProducts';
	                position = $(elem.parents('.products-slider__item')).index('.slick-track .products-slider__item') + 1;
	            } else if (elem.parents('div[data-tab="analogs"]').length > 0) {
	                list = 'AnalogProducts';
	                position = $(elem.parents('.grid__item')).index('div[data-tab="analogs"] .grid__item') + 1;
	            } else if (elem.parents('.also-viewed').length > 0) {
	                list = 'WatchedProducts';
	                position = $(elem.parents('.grid__item')).index('.also-viewed .grid__item') + 1;
	            } else if (elem.parents('.search_container').length > 0) {
	                list = 'searchProducts';
	                position = $(elem.parents('.grid__item')).index('.search_container .grid__item') + 1;
	            }
	            var trackers = new _tracker2['default']();
	
	            var product = _extends({
	                list: list,
	                position: position
	            }, productData);
	
	            trackers.onClickCatalogProducts({
	                click: {
	                    actionField: {
	                        list: list
	                    }
	                },
	                products: [product]
	            });
	
	            product = _extends({}, productData);
	
	            trackers.onShowProductCard({
	                detail: {
	                    actionField: {
	                        list: list
	                    }
	                },
	                products: [product]
	            });
	
	            product = _extends({
	                quantity: 1
	            }, productData);
	
	            trackers.addToCardFromList({
	                add: {
	                    products: [product]
	                }
	            });
	        }
	    }, {
	        key: 'onClickCartAddProduct',
	        value: function onClickCartAddProduct(dataProductId, quantityOld, quantityChange) {
	            var product = document.querySelectorAll('div[data-product-id="' + dataProductId + '"]');
	
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var dataName = product[0].getAttribute('data-product-name');
	            var dataPrice = product[0].getAttribute('data-product-price');
	            var dataBrand = product[0].getAttribute('data-product-brand');
	            var dataCategory = product[0].getAttribute('data-product-category');
	
	            var products = {
	                name: dataName,
	                id: dataProductId,
	                price: dataPrice,
	                brand: dataBrand,
	                category: dataCategory,
	                quantity: quantityChange - quantityOld
	            };
	
	            productData.push(products);
	
	            if (productData.length > 0) {
	                trackers.onClickAddProduct({
	                    add: {
	                        products: productData
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'onClickCartRemoveProduct',
	        value: function onClickCartRemoveProduct(dataProductId, quantityOld, quantityChange) {
	            var product = document.querySelectorAll('div[data-product-id="' + dataProductId + '"]');
	
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var dataName = product[0].getAttribute('data-product-name');
	            var dataPrice = product[0].getAttribute('data-product-price');
	            var dataBrand = product[0].getAttribute('data-product-brand');
	            var dataCategory = product[0].getAttribute('data-product-category');
	
	            var products = {
	                name: dataName,
	                id: dataProductId,
	                price: dataPrice,
	                brand: dataBrand,
	                category: dataCategory,
	                quantity: quantityOld - quantityChange
	            };
	
	            productData.push(products);
	
	            if (productData.length > 0) {
	                trackers.onClickRemoveProduct({
	                    remove: productData
	                });
	            }
	        }
	    }, {
	        key: 'onShowOrderCartStep1',
	        value: function onShowOrderCartStep1(data) {
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            for (var productItem in data.PRODUCTS) {
	                var item = data.PRODUCTS[productItem];
	
	                var product = {
	                    name: item.NAME,
	                    id: item.ID,
	                    price: item.PRICE,
	                    brand: data.BRANDS[item.PROPERTY_BREND_VALUE],
	                    category: item.CATEGORY,
	                    quantity: item.QUANTITY
	                };
	                productData.push(product);
	            }
	            if (productData.length > 0) {
	                trackers.onShowOrderCartStep1({
	                    checkout: {
	                        actionField: {
	                            step: 1
	                        },
	                        products: productData
	                    }
	                });
	            }
	        }
	
	        /**
	         * подгоовка данных
	         * @param elem
	         * @returns {{price: number, name: string, category: number, brand: number}}
	         */
	    }, {
	        key: 'prepareData',
	        value: function prepareData(elem) {
	            var name = '';
	            if (elem.querySelector('[data-name]') !== null && elem.querySelector('[data-name]').dataset.name !== undefined) {
	                name = elem.querySelector('[data-name]').dataset.name;
	            }
	
	            var productId = '';
	            if (elem.querySelector('[data-product-id]') !== null && elem.querySelector('[data-product-id]').dataset.productId !== undefined) {
	                productId = elem.querySelector('[data-product-id]').dataset.productId;
	            }
	
	            var price = 0;
	            if (elem.querySelector('[data-price]') !== null && elem.querySelector('[data-price]').dataset.price !== undefined) {
	                price = elem.querySelector('[data-price]').dataset.price;
	            }
	
	            var brand = 0;
	            if (elem.querySelector('[data-brand]') !== null && elem.querySelector('[data-brand]').dataset.brand !== undefined) {
	                brand = elem.querySelector('[data-brand]').dataset.brand;
	            }
	
	            var category = 0;
	            if (elem.querySelector('[data-category]') !== null && elem.querySelector('[data-category]').dataset.category !== undefined) {
	                category = elem.querySelector('[data-category]').dataset.category;
	            }
	
	            return {
	                name: name,
	                price: price,
	                brand: brand,
	                category: category,
	                id: productId
	            };
	            for (var productItem in data.PRODUCTS) {
	                var item = data.PRODUCTS[productItem];
	
	                var product = {
	                    name: item.NAME,
	                    id: item.ID,
	                    price: item.PRICE,
	                    brand: data.BRANDS[item.PROPERTY_BREND_VALUE],
	                    category: item.CATEGORY,
	                    quantity: item.QUANTITY
	                };
	                productData.push(product);
	            }
	            if (productData.length > 0) {
	                trackers.onShowOrderCartStep1({
	                    checkout: {
	                        actionField: {
	                            step: 1
	                        },
	                        products: productData
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'onShowOrderStep',
	        value: function onShowOrderStep(param) {
	            var step = 1;
	            if (param) {
	                step = param;
	            }
	            var productData = [];
	            var trackers = new _tracker2['default']();
	
	            var products = document.querySelectorAll('.cart .cart__item.basket__cart__item.cart__item--checkout');
	            products.forEach(function (item, index) {
	                var name = '';
	                if (item.getAttribute('data-product-name') !== null && item.getAttribute('data-product-name') !== undefined) {
	                    name = item.getAttribute('data-product-name');
	                }
	
	                var price = 0;
	                if (item.getAttribute('data-product-price') !== null && item.getAttribute('data-product-price') !== undefined) {
	                    price = item.getAttribute('data-product-price');
	                }
	
	                var brand = 0;
	                if (item.getAttribute('data-product-brand') !== null && item.getAttribute('data-product-brand') !== undefined) {
	                    brand = item.getAttribute('data-product-brand');
	                }
	
	                var category = 0;
	                if (item.getAttribute('data-product-category') !== null && item.getAttribute('data-product-category') !== undefined) {
	                    category = item.getAttribute('data-product-category');
	                }
	
	                var quantity = 0;
	                if (item.querySelectorAll('.quantity__value')[0].value !== null && item.querySelectorAll('.quantity__value')[0].value !== undefined) {
	                    quantity = item.querySelectorAll('.quantity__value')[0].value;
	                }
	
	                var product = {
	                    name: name,
	                    id: item.getAttribute('data-product-id'),
	                    price: price,
	                    brand: brand,
	                    category: category,
	                    quantity: quantity
	                };
	
	                productData.push(product);
	            });
	
	            if (productData.length > 0) {
	                trackers.onShowOrderStep({
	                    checkout: {
	                        actionField: {
	                            step: step
	                        },
	                        products: productData
	                    }
	                });
	            }
	        }
	    }]);
	
	    return Events;
	})();
	
	exports['default'] = Events;
	module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(133);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(135);
	module.exports = __webpack_require__(61).Object.assign;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(59);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(136) });


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(69);
	var getKeys = __webpack_require__(76);
	var gOPS = __webpack_require__(137);
	var pIE = __webpack_require__(138);
	var toObject = __webpack_require__(139);
	var IObject = __webpack_require__(79);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(70)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _gtm = __webpack_require__(141);
	
	var _gtm2 = _interopRequireDefault(_gtm);
	
	var _fbpixel = __webpack_require__(142);
	
	var _fbpixel2 = _interopRequireDefault(_fbpixel);
	
	var _mailru = __webpack_require__(143);
	
	var _yandexMetrika = __webpack_require__(144);
	
	//import { MindboxTracker } from '../../modules/mindbox/mindbox-tracker';
	
	__webpack_require__(145);
	__webpack_require__(146);
	
	var Trackers = (function () {
	    function Trackers() {
	        var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	        _classCallCheck(this, Trackers);
	
	        this.data = arg;
	        this.yandexMetrika = new _yandexMetrika.YandexMetrika();
	        this.instances = {
	            gtm: new _gtm2['default'](),
	            fbpixel: new _fbpixel2['default']()
	        };
	        if (!arg.onlyTrackers) {
	            return;
	        }
	
	        for (var track in this.instances) {
	            if (arg.onlyTrackers.indexOf(track) === -1 && this.instances.hasOwnProperty(track)) {
	                delete this.instances[track];
	            }
	        }
	    }
	
	    _createClass(Trackers, [{
	        key: 'backendPageViewed',
	        value: function backendPageViewed() {
	            this.mailru = new _mailru.MailRuTracker();
	            var route = $('.main-container').data('route');
	
	            switch (route) {
	                case 'index':
	                    this.indexPageViewed();
	                    break;
	                case 'catalog.section':
	                    this.categoryPageViewed();
	                    break;
	                case 'catalog.product':
	                    this.productPageViewed();
	                    break;
	                case 'cart':
	                    this.basketPageViewed();
	                    break;
	                case 'order':
	                    this.orderPageViewed();
	                    break;
	                case 'search':
	                    this.searchPageViewed();
	                    break;
	                default:
	                    this.otherPageViewed();
	                    break;
	            }
	        }
	    }, {
	        key: 'userAuthorized',
	        value: function userAuthorized(user) {
	            this.yandexMetrika.userAuthorized(user);
	        }
	    }, {
	        key: 'clientTimeSite',
	        value: function clientTimeSite() {
	            var time = arguments.length <= 0 || arguments[0] === undefined ? 190000 : arguments[0];
	
	            var _self = this;
	            setTimeout(function () {
	                _self.yandexMetrika.timeClient();
	            }, time);
	        }
	    }, {
	        key: 'trigger',
	        value: function trigger(evType, arg) {
	            for (var instName in this.instances) {
	                if (typeof this.instances[instName][evType] === 'function' && this.instances.hasOwnProperty(instName)) {
	                    this.instances[instName][evType](arg[instName]);
	                }
	            }
	        }
	    }, {
	        key: 'getTracker',
	        value: function getTracker(tracker) {
	            return this.instances[tracker];
	        }
	    }, {
	        key: 'onAddToCart',
	        value: function onAddToCart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAddToCart', arg);
	        }
	    }, {
	        key: 'onAddToFav',
	        value: function onAddToFav() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAddToFav', arg);
	        }
	    }, {
	        key: 'onSearch',
	        value: function onSearch() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSearch', arg);
	        }
	    }, {
	        key: 'onContentView',
	        value: function onContentView() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onContentView', arg);
	        }
	    }, {
	        key: 'onSignUp',
	        value: function onSignUp() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSignUp', arg);
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSignUpEnd', arg);
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCheckoutStart', arg);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCheckoutEnd', arg);
	        }
	    }, {
	        key: 'onAdviserWindow',
	        value: function onAdviserWindow() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAdviserWindow', arg);
	        }
	    }, {
	        key: 'onAdviserReply',
	        value: function onAdviserReply() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAdviserReply', arg);
	        }
	    }, {
	        key: 'onFeedbackSend',
	        value: function onFeedbackSend() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('claimButton', arg);
	        }
	    }, {
	        key: 'onTabClick',
	        value: function onTabClick() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onTabClick', arg);
	        }
	    }, {
	        key: 'onSubscribe',
	        value: function onSubscribe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSubscribe', arg);
	        }
	    }, {
	        key: 'onSubscriptionDone',
	        value: function onSubscriptionDone() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSubscriptionDone', arg);
	            this.trigger('onPMfrmSubscribe', arg);
	        }
	    }, {
	        key: 'onCallBackFormShow',
	        value: function onCallBackFormShow() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackFormShow', arg);
	        }
	    }, {
	        key: 'onCallBackButton',
	        value: function onCallBackButton() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackButton', arg);
	        }
	    }, {
	        key: 'onCallBackRequestSend',
	        value: function onCallBackRequestSend() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackRequestSend', arg);
	        }
	    }, {
	        key: 'onBasketRefresh',
	        value: function onBasketRefresh() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onBasketRefresh', arg);
	        }
	    }, {
	        key: 'onOneClickBuyButton',
	        value: function onOneClickBuyButton() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onOneClickBuyButton', arg);
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onOneClickBuyEnd', arg);
	        }
	    }, {
	        key: 'onPMbtnTel',
	        value: function onPMbtnTel() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnTel', arg);
	        }
	    }, {
	        key: 'onPMbtnFilter',
	        value: function onPMbtnFilter() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFilter', arg);
	        }
	    }, {
	        key: 'onClickEvent',
	        value: function onClickEvent() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger(arg.event, { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onClickPdf',
	        value: function onClickPdf() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger(arg.event, { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMbtnFavorite',
	        value: function onPMbtnFavorite() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFavorite', { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onPMbtnAddToCart',
	        value: function onPMbtnAddToCart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnAddToCart', { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onPMbtn1Click',
	        value: function onPMbtn1Click() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtn1Click', { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMfrm1Click',
	        value: function onPMfrm1Click() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrm1Click', { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMbtnFAQ',
	        value: function onPMbtnFAQ() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFAQ', arg);
	        }
	    }, {
	        key: 'onPMfrmCallMeContact',
	        value: function onPMfrmCallMeContact() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmCallMeContact', arg);
	        }
	    }, {
	        key: 'onPMfrmFAQ',
	        value: function onPMfrmFAQ() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmFAQ', arg);
	        }
	    }, {
	        key: 'onPMbtnCallMe',
	        value: function onPMbtnCallMe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnCallMe', arg);
	        }
	    }, {
	        key: 'onPMfrmCallMe',
	        value: function onPMfrmCallMe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmCallMe', arg);
	        }
	    }, {
	        key: 'onPMfrmReg',
	        value: function onPMfrmReg() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmReg', arg);
	        }
	    }, {
	        key: 'onPMbtnReg',
	        value: function onPMbtnReg() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnReg', arg);
	        }
	    }, {
	        key: 'onPMbtnComment',
	        value: function onPMbtnComment() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnComment', arg);
	        }
	    }, {
	        key: 'onPMfrmComment',
	        value: function onPMfrmComment() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmComment', arg);
	        }
	    }, {
	        key: 'onPMbtnAskQuestion',
	        value: function onPMbtnAskQuestion() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnAskQuestion', arg);
	        }
	    }, {
	        key: 'onPMfrmAskQuestion',
	        value: function onPMfrmAskQuestion() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmAskQuestion', arg);
	        }
	    }, {
	        key: 'onClickPromo',
	        value: function onClickPromo() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommercePromoClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onViewPromo',
	        value: function onViewPromo() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommercePromoView', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowNewProducts',
	        value: function onShowNewProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowWatchedProducts',
	        value: function onShowWatchedProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowAnalogProducts',
	        value: function onShowAnalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickAddProduct',
	        value: function onClickAddProduct() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickRemoveProduct',
	        value: function onClickRemoveProduct() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceRemove', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowOrderCartStep1',
	        value: function onShowOrderCartStep1() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceCheckout', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowOrderStep',
	        value: function onShowOrderStep() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceCheckout', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowcatalogProducts',
	        value: function onShowcatalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickCatalogProducts',
	        value: function onClickCatalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickWatched',
	        value: function onClickWatched() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickAnalog',
	        value: function onClickAnalog() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickNewProducts',
	        value: function onClickNewProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowProductCard',
	        value: function onShowProductCard() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceDetail', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowProductCardPopup',
	        value: function onShowProductCardPopup() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceDetail', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'addToCardFromCard',
	        value: function addToCardFromCard() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'addToCardFromList',
	        value: function addToCardFromList() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'completeRegistration',
	        value: function completeRegistration() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('CompleteRegistration', arg);
	        }
	    }, {
	        key: 'indexPageViewed',
	        value: function indexPageViewed() {
	            this.mailru.indexPageView();
	        }
	    }, {
	        key: 'categoryPageViewed',
	        value: function categoryPageViewed() {
	            this.mailru.categoryPageView();
	            //this.mindboxTracker.categoryView(this.data.category);
	        }
	    }, {
	        key: 'productPageViewed',
	        value: function productPageViewed() {
	            this.mailru.productPageView($('.product-detail__action-btn').data('product-id'), $('.product-detail__price-sum').data('price'));
	            //this.mindboxTracker.productView($('.js-vendor-code').data('vendor-code'));
	        }
	    }, {
	        key: 'otherPageViewed',
	        value: function otherPageViewed() {
	            this.mailru.otherPageView();
	        }
	    }, {
	        key: 'searchPageViewed',
	        value: function searchPageViewed() {
	            this.mailru.searchPageView();
	        }
	    }, {
	        key: 'orderPageViewed',
	        value: function orderPageViewed() {
	            this.mailru.orderPageView();
	        }
	    }, {
	        key: 'basketPageViewed',
	        value: function basketPageViewed() {
	            var ids = [];
	            var products = document.querySelectorAll('.cart__item .cart__item-content');
	            products.forEach(function (product) {
	                ids.push(product.getAttribute('data-product-id'));
	            });
	
	            this.mailru.basketPageView(ids, $('.basket-final-price').html());
	        }
	    }]);
	
	    return Trackers;
	})();
	
	exports['default'] = Trackers;
	module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var GTMEvents = (function () {
	    function GTMEvents() {
	        _classCallCheck(this, GTMEvents);
	
	        this.events = {
	            registrationDone: 'Registration_Done',
	            subscriptionButton: 'Subscription_Button',
	            subscriptionDone: 'Subscription_Done',
	            PMfrmSubscribe: 'PMfrmSubscribe',
	            add2CartButton: 'Add2Cart_Button',
	            oneClickBuyButton: 'oneClick_buy_Button',
	            accessoriesTab: 'accessories_tab',
	            faqTab: 'faq_tab',
	            reviewsTab: 'reviews_tab',
	            descriptionTab: 'description_tab',
	            onlineConsultant: 'online_consultant',
	            onlineConsultantButton: 'online_consultant_button',
	            onlineConsultantSent: 'online_consultant_sent',
	            backcall: 'backcall',
	            backcallButton: 'backcall_button',
	            backcallSent: 'backcall_sent',
	            claimButton: 'claim_button',
	            claimDone: 'claim_Done',
	            basketRefresh: 'basket_refresh',
	            basketOrder: 'basket_order',
	            contactLogin: 'contact_login',
	            contact1clickBuy: 'contact_1clickBuy',
	            contactRegistration: 'contact_registration',
	            contactRegistrationContinue: 'contact_registration_continue',
	            contactLoginContinue: 'contact_login_continue',
	            contact1clickBuyContinue: 'contact_1clickBuy_continue',
	            confirmOrder: 'confirm_order',
	            PMbtnSocial: 'PMbtnSocial',
	            PMbtnFAQ: 'PMbtnFAQ',
	            PMfrmFAQ: 'PMfrmFAQ',
	            PMbtnCallMe: 'PMbtnCallMe',
	            PMfrmCallMe: 'PMfrmCallMe',
	            PMbtnReg: 'PMbtnReg',
	            PMfrmReg: 'PMfrmReg',
	            PMbtnSelectCity: 'PMbtnSelectCity',
	            PMbtnTellAbout: 'PMbtnTellAbout',
	            PMbtnContact: 'PMbtnContact',
	            PMbtnComment: 'PMbtnComment',
	            PMfrmComment: 'PMfrmComment',
	            PMbtnAskQuestion: 'PMbtnAskQuestion',
	            PMfrmAskQuestion: 'PMfrmAskQuestion',
	            PMbtn1Click: 'PMbtn1Click',
	            PMfrm1Click: 'PMfrm1Click',
	            PMbtnFavorite: 'PMbtnFavorite',
	            PMbtnAddToCart: 'PMbtnAddToCart',
	            PMbtnTabs: 'PMbtnTabs',
	            PMbtnTel: 'PMbtnTel',
	            PMfrmCallMeContact: 'PMfrmCallMeContact',
	            PMbtnVariant: 'PMbtnVariant',
	            PMbtnFilter: 'PMbtnFilter',
	            ecommercePromoClick: 'ecommercePromoClick',
	            ecommercePromoView: 'ecommercePromoView',
	            ecommerceImpressions: 'ecommerceImpressions',
	            ecommerceClick: 'ecommerceClick',
	            ecommerceDetail: 'ecommerceDetail',
	            ecommerceAdd: 'ecommerceAdd',
	            ecommerceRemove: 'ecommerceRemove',
	            ecommerceCheckout: 'ecommerceCheckout',
	            completeRegistration: 'CompleteRegistration'
	        };
	    }
	
	    _createClass(GTMEvents, [{
	        key: 'onAddToCart',
	        value: function onAddToCart(arg) {
	            if (arg) {
	                this.push(_extends({
	                    event: 'addToCart'
	                }, arg));
	                return;
	            }
	            this.pushEvent('add2CartButton');
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd(event) {
	            this.pushEvent(event);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd() {
	            this.pushEvent('confirmOrder');
	        }
	    }, {
	        key: 'onAdviserWindow',
	        value: function onAdviserWindow() {
	            this.pushEvent('onlineConsultant');
	        }
	    }, {
	        key: 'onAdviserReply',
	        value: function onAdviserReply() {
	            this.pushEvent('onlineConsultantButton');
	        }
	    }, {
	        key: 'onFeedbackSend',
	        value: function onFeedbackSend() {
	            this.pushEvent('claimButton');
	        }
	    }, {
	        key: 'onTabClick',
	        value: function onTabClick(tab) {
	            var tabMap = {
	                descr: 'descriptionTab',
	                reviews: 'reviewsTab',
	                faq: 'faqTab',
	                login: 'contactLogin',
	                reg: 'contactRegistration',
	                oneclick: 'contact1clickBuy'
	            };
	
	            if (!tabMap[tab]) {
	                return;
	            }
	
	            this.pushEvent(tabMap[tab]);
	        }
	    }, {
	        key: 'onSubscribe',
	        value: function onSubscribe() {
	            this.pushEvent('subscriptionButton');
	        }
	    }, {
	        key: 'onSubscriptionDone',
	        value: function onSubscriptionDone() {
	            this.pushEvent('subscriptionDone');
	        }
	    }, {
	        key: 'onPMfrmSubscribe',
	        value: function onPMfrmSubscribe() {
	            this.pushEvent('PMfrmSubscribe');
	        }
	    }, {
	        key: 'PMbtnTel',
	        value: function PMbtnTel() {
	            this.pushEvent('PMbtnTel');
	        }
	    }, {
	        key: 'onCallBackFormShow',
	        value: function onCallBackFormShow() {
	            this.pushEvent('backcall');
	        }
	    }, {
	        key: 'onCallBackButton',
	        value: function onCallBackButton() {
	            this.pushEvent('backcallButton');
	        }
	    }, {
	        key: 'onCallBackRequestSend',
	        value: function onCallBackRequestSend() {
	            this.pushEvent('backcallSent');
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart() {
	            this.pushEvent('basketOrder');
	        }
	    }, {
	        key: 'onBasketRefresh',
	        value: function onBasketRefresh() {
	            this.pushEvent('basketRefresh');
	        }
	    }, {
	        key: 'onOneClickBuyButton',
	        value: function onOneClickBuyButton() {
	            this.pushEvent('oneClickBuyButton');
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd() {
	            this.pushEvent('contact1clickBuyContinue');
	        }
	    }, {
	        key: 'PMbtnSocial',
	        value: function PMbtnSocial(arg) {
	            this.push(_extends({
	                event: 'PMbtnSocial'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnVariant',
	        value: function PMbtnVariant(arg) {
	            this.push(_extends({
	                event: 'PMbtnVariant'
	            }, arg));
	        }
	    }, {
	        key: 'PMfrmCallMeContact',
	        value: function PMfrmCallMeContact(arg) {
	            this.push(_extends({
	                event: 'PMfrmCallMeContact'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnTabs',
	        value: function PMbtnTabs(arg) {
	            this.push(_extends({
	                event: 'PMbtnTabs'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnAddToCart',
	        value: function PMbtnAddToCart(arg) {
	            this.push(_extends({
	                event: 'PMbtnAddToCart'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnSelectCity',
	        value: function PMbtnSelectCity(arg) {
	            this.push(_extends({
	                event: 'PMbtnSelectCity'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnTellAbout',
	        value: function PMbtnTellAbout(arg) {
	            this.push(_extends({
	                event: 'PMbtnTellAbout'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtn1Click',
	        value: function PMbtn1Click() {
	            this.push({
	                event: 'PMbtn1Click'
	            });
	        }
	    }, {
	        key: 'PMfrm1Click',
	        value: function PMfrm1Click(arg) {
	            this.push(_extends({
	                event: 'PMfrm1Click'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnFavorite',
	        value: function PMbtnFavorite(arg) {
	            this.push(_extends({
	                event: 'PMbtnFavorite'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnContact',
	        value: function PMbtnContact(arg) {
	            this.push(_extends({
	                event: 'PMbtnContact'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnFAQ',
	        value: function PMbtnFAQ() {
	            this.push({
	                event: 'PMbtnFAQ'
	            });
	        }
	    }, {
	        key: 'PMfrmFAQ',
	        value: function PMfrmFAQ() {
	            this.push({
	                event: 'PMfrmFAQ'
	            });
	        }
	    }, {
	        key: 'PMbtnCallMe',
	        value: function PMbtnCallMe() {
	            this.push({
	                event: 'PMbtnCallMe'
	            });
	        }
	    }, {
	        key: 'PMfrmCallMe',
	        value: function PMfrmCallMe() {
	            this.push({
	                event: 'PMfrmCallMe'
	            });
	        }
	    }, {
	        key: 'PMbtnFilter',
	        value: function PMbtnFilter() {
	            this.push({
	                event: 'PMbtnFilter'
	            });
	        }
	    }, {
	        key: 'PMbtnReg',
	        value: function PMbtnReg() {
	            this.push({
	                event: 'PMbtnReg'
	            });
	        }
	    }, {
	        key: 'PMfrmReg',
	        value: function PMfrmReg() {
	            this.push({
	                event: 'PMfrmReg'
	            });
	        }
	    }, {
	        key: 'PMbtnComment',
	        value: function PMbtnComment() {
	            this.push({
	                event: 'PMbtnComment'
	            });
	        }
	    }, {
	        key: 'PMfrmComment',
	        value: function PMfrmComment() {
	            this.push({
	                event: 'PMfrmComment'
	            });
	        }
	    }, {
	        key: 'PMbtnAskQuestion',
	        value: function PMbtnAskQuestion() {
	            this.push({
	                event: 'PMbtnAskQuestion'
	            });
	        }
	    }, {
	        key: 'PMfrmAskQuestion',
	        value: function PMfrmAskQuestion() {
	            this.push({
	                event: 'PMfrmAskQuestion'
	            });
	        }
	    }, {
	        key: 'pushEvent',
	        value: function pushEvent(eventName) {
	            if (this.events[eventName] !== undefined) {
	                this.push({
	                    event: this.events[eventName]
	                });
	            }
	        }
	    }, {
	        key: 'ecommercePromoClick',
	        value: function ecommercePromoClick(arg) {
	            this.push(_extends({
	                event: 'ecommercePromoClick'
	            }, arg));
	        }
	    }, {
	        key: 'ecommercePromoView',
	        value: function ecommercePromoView(arg) {
	            this.push(_extends({
	                event: 'ecommercePromoView'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceImpressions',
	        value: function ecommerceImpressions(arg) {
	            this.push(_extends({
	                event: 'ecommerceImpressions'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceClick',
	        value: function ecommerceClick(arg) {
	            this.push(_extends({
	                event: 'ecommerceClick'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceDetail',
	        value: function ecommerceDetail(arg) {
	            this.push(_extends({
	                event: 'ecommerceDetail'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceAdd',
	        value: function ecommerceAdd(arg) {
	            this.push(_extends({
	                event: 'ecommerceAdd'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceRemove',
	        value: function ecommerceRemove(arg) {
	            this.push(_extends({
	                event: 'ecommerceRemove'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceCheckout',
	        value: function ecommerceCheckout(arg) {
	            this.push(_extends({
	                event: 'ecommerceCheckout'
	            }, arg));
	        }
	    }, {
	        key: 'push',
	        value: function push(params) {
	            window.dataLayer.push(params);
	        }
	    }]);
	
	    return GTMEvents;
	})();
	
	exports['default'] = GTMEvents;
	module.exports = exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var FBPixel = (function () {
	    function FBPixel() {
	        _classCallCheck(this, FBPixel);
	
	        var pageTitle = document.querySelector('h1');
	        this.title = pageTitle ? pageTitle.textContent : '';
	    }
	
	    _createClass(FBPixel, [{
	        key: 'track',
	        value: function track(type, args) {
	            if (typeof window.fbq !== 'function') {
	                return;
	            }
	            window.fbq('track', type, args);
	        }
	    }, {
	        key: 'onContentView',
	        value: function onContentView(location) {
	            var locations = ['categories', 'product', 'articles'];
	
	            if (locations.indexOf(location) === -1) {
	                return;
	            }
	
	            this.track('ViewContent', {
	                content_name: this.title
	            });
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart(args) {
	            this.withCurrency('InitiateCheckout', args);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd(args) {
	            this.withCurrency('Purchase', args);
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd(args) {
	            this.onCheckoutEnd(args);
	        }
	    }, {
	        key: 'onSearch',
	        value: function onSearch(args) {
	            this.track('Search', args);
	        }
	    }, {
	        key: 'onSignUp',
	        value: function onSignUp() {
	            this.track('Lead');
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd() {
	            this.withCurrency('CompleteRegistration', {
	                value: 100
	            });
	        }
	    }, {
	        key: 'onAddToCart',
	        value: function onAddToCart(args) {
	            this.withCurrency('AddToCart', args);
	        }
	    }, {
	        key: 'onAddToFav',
	        value: function onAddToFav(args) {
	            this.withCurrency('AddToWishlist', _extends({}, args, {
	                content_name: this.title
	            }));
	        }
	    }, {
	        key: 'withCurrency',
	        value: function withCurrency(type) {
	            var args = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	            this.track(type, _extends({}, args, {
	                currency: 'RUB'
	            }));
	        }
	    }]);
	
	    return FBPixel;
	})();
	
	exports['default'] = FBPixel;
	module.exports = exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _Object$assign = __webpack_require__(133)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var MailRuTracker = (function () {
	    function MailRuTracker() {
	        _classCallCheck(this, MailRuTracker);
	
	        this.init();
	    }
	
	    _createClass(MailRuTracker, [{
	        key: 'init',
	        value: function init() {
	            window._tmr = window._tmr || [];
	            return window._tmr;
	        }
	    }, {
	        key: 'push',
	        value: function push(query) {
	            window._tmr.push(query);
	        }
	    }, {
	        key: 'indexPageView',
	        value: function indexPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), { pagetype: 'home' }));
	        }
	    }, {
	        key: 'otherPageView',
	        value: function otherPageView() {
	            this.push(this.getQueryTemplate());
	        }
	    }, {
	        key: 'categoryPageView',
	        value: function categoryPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'category',
	                productid: '',
	                totalvalue: ''
	            }));
	        }
	    }, {
	        key: 'basketPageView',
	        value: function basketPageView(ids, totalPrice) {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'cart',
	                productid: ids,
	                totalvalue: totalPrice
	            }));
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView(id, price) {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'product',
	                productid: id,
	                totalvalue: parseFloat(price)
	            }));
	        }
	    }, {
	        key: 'orderPageView',
	        value: function orderPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'purchase'
	            }));
	        }
	    }, {
	        key: 'searchPageView',
	        value: function searchPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'searchresults'
	            }));
	        }
	    }, {
	        key: 'getQueryTemplate',
	        value: function getQueryTemplate() {
	            return {
	                id: '3241057',
	                type: 'itemView',
	                productid: '',
	                pagetype: 'other',
	                totalvalue: '',
	                list: '3'
	            };
	        }
	    }]);
	
	    return MailRuTracker;
	})();

	exports.MailRuTracker = MailRuTracker;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var YandexMetrika = (function () {
	    function YandexMetrika() {
	        _classCallCheck(this, YandexMetrika);
	    }
	
	    _createClass(YandexMetrika, [{
	        key: 'track',
	        value: function track(code, eventCode) {
	            try {
	                window.ym(911516, code, eventCode);
	            } catch (e) {
	                //console.log('Ошибка ' + e.name + ':' + e.message + '\n' + e.stack);
	            }
	        }
	    }, {
	        key: 'timeClient',
	        value: function timeClient() {
	            this.track('reachGoal', 'time_more_than_x');
	        }
	    }, {
	        key: 'orderComplete',
	        value: function orderComplete() {
	            this.track('reachGoal', 'order_complete');
	        }
	    }, {
	        key: 'notFountPage',
	        value: function notFountPage() {
	            this.track('reachGoal', 'mn_error_404');
	        }
	    }, {
	        key: 'userAuthorized',
	        value: function userAuthorized(user) {
	            var userParams = { userId: user.USER_ID };
	            this.track('userParams', userParams);
	            this.track('params', userParams);
	            this.track('setUserID', user.USER_ID);
	        }
	    }]);
	
	    return YandexMetrika;
	})();

	exports.YandexMetrika = YandexMetrika;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	/*!
	Waypoints - 4.0.1
	Copyright © 2011-2016 Caleb Troughton
	Licensed under the MIT license.
	https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
	*/
	!function(){"use strict";function t(o){if(!o)throw new Error("No options passed to Waypoint constructor");if(!o.element)throw new Error("No element option passed to Waypoint constructor");if(!o.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,o),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=o.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var o in i)e.push(i[o]);for(var n=0,r=e.length;r>n;n++)e[n][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.Context.refreshAll();for(var e in i)i[e].enabled=!0;return this},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=n.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,o[t.waypointContextKey]=this,i+=1,n.windowContext||(n.windowContext=!0,n.windowContext=new e(window)),this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,o={},n=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical),i=this.element==this.element.window;t&&e&&!i&&(this.adapter.off(".waypoints"),delete o[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,n.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||n.isTouch)&&(e.didScroll=!0,n.requestAnimationFrame(t))})},e.prototype.handleResize=function(){n.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var o=e[i],n=o.newScroll>o.oldScroll,r=n?o.forward:o.backward;for(var s in this.waypoints[i]){var a=this.waypoints[i][s];if(null!==a.triggerPoint){var l=o.oldScroll<a.triggerPoint,h=o.newScroll>=a.triggerPoint,p=l&&h,u=!l&&!h;(p||u)&&(a.queueTrigger(r),t[a.group.id]=a.group)}}}for(var c in t)t[c].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?n.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?n.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var o=0,n=t.length;n>o;o++)t[o].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),o={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var a in this.waypoints[r]){var l,h,p,u,c,d=this.waypoints[r][a],f=d.options.offset,w=d.triggerPoint,y=0,g=null==w;d.element!==d.element.window&&(y=d.adapter.offset()[s.offsetProp]),"function"==typeof f?f=f.apply(d):"string"==typeof f&&(f=parseFloat(f),d.options.offset.indexOf("%")>-1&&(f=Math.ceil(s.contextDimension*f/100))),l=s.contextScroll-s.contextOffset,d.triggerPoint=Math.floor(y+l-f),h=w<s.oldScroll,p=d.triggerPoint>=s.oldScroll,u=h&&p,c=!h&&!p,!g&&u?(d.queueTrigger(s.backward),o[d.group.id]=d.group):!g&&c?(d.queueTrigger(s.forward),o[d.group.id]=d.group):g&&s.oldScroll>=d.triggerPoint&&(d.queueTrigger(s.forward),o[d.group.id]=d.group)}}return n.requestAnimationFrame(function(){for(var t in o)o[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in o)o[t].refresh()},e.findByElement=function(t){return o[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},n.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},n.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),o[this.axis][this.name]=this}var o={vertical:{},horizontal:{}},n=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var o=this.triggerQueues[i],n="up"===i||"left"===i;o.sort(n?e:t);for(var r=0,s=o.length;s>r;r+=1){var a=o[r];(a.options.continuous||r===o.length-1)&&a.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints),o=i===this.waypoints.length-1;return o?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=n.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return o[t.axis][t.name]||new i(t)},n.Group=i}(),function(){"use strict";function t(t){this.$element=e(t)}var e=window.jQuery,i=window.Waypoint;e.each(["innerHeight","innerWidth","off","offset","on","outerHeight","outerWidth","scrollLeft","scrollTop"],function(e,i){t.prototype[i]=function(){var t=Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element,t)}}),e.each(["extend","inArray","isEmptyObject"],function(i,o){t[o]=e[o]}),i.adapters.push({name:"jquery",Adapter:t}),i.Adapter=t}(),function(){"use strict";function t(t){return function(){var i=[],o=arguments[0];return t.isFunction(arguments[0])&&(o=t.extend({},arguments[1]),o.handler=arguments[0]),this.each(function(){var n=t.extend({},o,{element:this});"string"==typeof n.context&&(n.context=t(this).closest(n.context)[0]),i.push(new e(n))}),i}}var e=window.Waypoint;window.jQuery&&(window.jQuery.fn.waypoint=t(window.jQuery)),window.Zepto&&(window.Zepto.fn.waypoint=t(window.Zepto))}();

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/*!
	Waypoints Inview Shortcut - 4.0.1
	Copyright © 2011-2016 Caleb Troughton
	Licensed under the MIT license.
	https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
	*/
	(function() {
	  'use strict'
	
	  function noop() {}
	
	  var Waypoint = window.Waypoint
	
	  /* http://imakewebthings.com/waypoints/shortcuts/inview */
	  function Inview(options) {
	    this.options = Waypoint.Adapter.extend({}, Inview.defaults, options)
	    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
	    this.waypoints = []
	    this.element = this.options.element
	    this.createWaypoints()
	  }
	
	  /* Private */
	  Inview.prototype.createWaypoints = function() {
	    var configs = {
	      vertical: [{
	        down: 'enter',
	        up: 'exited',
	        offset: '100%'
	      }, {
	        down: 'entered',
	        up: 'exit',
	        offset: 'bottom-in-view'
	      }, {
	        down: 'exit',
	        up: 'entered',
	        offset: 0
	      }, {
	        down: 'exited',
	        up: 'enter',
	        offset: function() {
	          return -this.adapter.outerHeight()
	        }
	      }],
	      horizontal: [{
	        right: 'enter',
	        left: 'exited',
	        offset: '100%'
	      }, {
	        right: 'entered',
	        left: 'exit',
	        offset: 'right-in-view'
	      }, {
	        right: 'exit',
	        left: 'entered',
	        offset: 0
	      }, {
	        right: 'exited',
	        left: 'enter',
	        offset: function() {
	          return -this.adapter.outerWidth()
	        }
	      }]
	    }
	
	    for (var i = 0, end = configs[this.axis].length; i < end; i++) {
	      var config = configs[this.axis][i]
	      this.createWaypoint(config)
	    }
	  }
	
	  /* Private */
	  Inview.prototype.createWaypoint = function(config) {
	    var self = this
	    this.waypoints.push(new Waypoint({
	      context: this.options.context,
	      element: this.options.element,
	      enabled: this.options.enabled,
	      handler: (function(config) {
	        return function(direction) {
	          self.options[config[direction]].call(self, direction)
	        }
	      }(config)),
	      offset: config.offset,
	      horizontal: this.options.horizontal
	    }))
	  }
	
	  /* Public */
	  Inview.prototype.destroy = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].destroy()
	    }
	    this.waypoints = []
	  }
	
	  Inview.prototype.disable = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].disable()
	    }
	  }
	
	  Inview.prototype.enable = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].enable()
	    }
	  }
	
	  Inview.defaults = {
	    context: window,
	    enabled: true,
	    enter: noop,
	    entered: noop,
	    exit: noop,
	    exited: noop
	  }
	
	  Waypoint.Inview = Inview
	}())
	;

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */,
/* 149 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    isIOS: function isIOS() {
	        return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
	    },
	    getBodyScrollTop: function getBodyScrollTop() {
	        return self.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop;
	    },
	    getBodyMiddlePos: function getBodyMiddlePos() {
	        return this.getBodyScrollTop() + document.documentElement.clientHeight * 0.5;
	    },
	    //узнать настоящую полную высоту блока с заданным max-height
	    getTrueHeight: function getTrueHeight($block) {
	        var el = $block.clone().css({
	            height: 'auto',
	            width: $block.width(),
	            overflow: 'hidden',
	            'max-height': 'none'
	        }).insertAfter($block);
	
	        var trueHeight = el.outerHeight(true);
	        el.remove();
	
	        return trueHeight;
	    },
	    number_format: __webpack_require__(167),
	
	    setMaskedPhone: function setMaskedPhone($element) {
	        $element.mask('+7(999)999-99-99', { autoclear: false });
	    },
	    setMaskedPhoneCity: function setMaskedPhoneCity($element) {
	        $element.mask('+7(999)999-99-99 (городской)', { autoclear: false });
	    },
	    setMaskedPhoneMobile: function setMaskedPhoneMobile($element) {
	        $element.mask('+7(999)999-99-99 (мобильный)', { autoclear: false });
	    },
	
	    getCookie: function getCookie(name) {
	        var matches = document.cookie.match('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)');
	        return matches ? decodeURIComponent(matches[1]) : undefined;
	    },
	
	    setCookie: function setCookie(name, value, options) {
	        options = options || {};
	
	        var expires = options.expires;
	
	        if (typeof expires == 'number' && expires) {
	            var d = new Date();
	            d.setTime(d.getTime() + expires * 1000);
	            expires = options.expires = d;
	        }
	        if (expires && expires.toUTCString) {
	            options.expires = expires.toUTCString();
	        }
	
	        value = encodeURIComponent(value);
	
	        var updatedCookie = name + '=' + value;
	
	        for (var propName in options) {
	            updatedCookie += '; ' + propName;
	            var propValue = options[propName];
	            if (propValue !== true) {
	                updatedCookie += '=' + propValue;
	            }
	        }
	
	        document.cookie = updatedCookie;
	    },
	    deleteCookie: function deleteCookie(name) {
	        var cookie_date = new Date();
	        cookie_date.setTime(cookie_date.getTime() - 1);
	        document.cookie = name += "=; expires=" + cookie_date.toGMTString();
	    }
	};
	var initDadata = function initDadata() {
	    var streetInput = document.getElementById("street");
	    var cityInput = document.getElementById("city").value;
	    var token = 'b574f61916aa7f16b0ed0aaa318da372bfe05254';
	    var type = 'address';
	    var createSuggestions = window.Dadata.createSuggestions;
	
	    var regionSuggestions = createSuggestions(streetInput, {
	        token: token,
	        type: 'address',
	        hint: false,
	        count: 15,
	        params: {
	            from_bound: { value: 'street' },
	            to_bound: { value: 'street' },
	            locations: {
	                city: cityInput
	            },
	            language: 'ru', // Язык результатов
	            strict: true // Строгий поиск по точному совпадению
	        }
	    });
	    var citySuggestions = createSuggestions('', {
	        token: token,
	        type: type,
	        hint: false,
	        params: { from_bound: { value: "city" }, to_bound: { value: "settlement" } }
	    }, regionSuggestions);
	};

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function number_format(number, decimals, decPoint, thousandsSep) {
	  // eslint-disable-line camelcase
	  //  discuss at: https://locutus.io/php/number_format/
	  // original by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
	  // improved by: Kevin van Zonneveld (https://kvz.io)
	  // improved by: davook
	  // improved by: Brett Zamir (https://brett-zamir.me)
	  // improved by: Brett Zamir (https://brett-zamir.me)
	  // improved by: Theriault (https://github.com/Theriault)
	  // improved by: Kevin van Zonneveld (https://kvz.io)
	  // bugfixed by: Michael White (https://getsprink.com)
	  // bugfixed by: Benjamin Lupton
	  // bugfixed by: Allan Jensen (https://www.winternet.no)
	  // bugfixed by: Howard Yeend
	  // bugfixed by: Diogo Resende
	  // bugfixed by: Rival
	  // bugfixed by: Brett Zamir (https://brett-zamir.me)
	  //  revised by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
	  //  revised by: Luke Smith (https://lucassmith.name)
	  //    input by: Kheang Hok Chin (https://www.distantia.ca/)
	  //    input by: Jay Klehr
	  //    input by: Amir Habibi (https://www.residence-mixte.com/)
	  //    input by: Amirouche
	  //   example 1: number_format(1234.56)
	  //   returns 1: '1,235'
	  //   example 2: number_format(1234.56, 2, ',', ' ')
	  //   returns 2: '1 234,56'
	  //   example 3: number_format(1234.5678, 2, '.', '')
	  //   returns 3: '1234.57'
	  //   example 4: number_format(67, 2, ',', '.')
	  //   returns 4: '67,00'
	  //   example 5: number_format(1000)
	  //   returns 5: '1,000'
	  //   example 6: number_format(67.311, 2)
	  //   returns 6: '67.31'
	  //   example 7: number_format(1000.55, 1)
	  //   returns 7: '1,000.6'
	  //   example 8: number_format(67000, 5, ',', '.')
	  //   returns 8: '67.000,00000'
	  //   example 9: number_format(0.9, 0)
	  //   returns 9: '1'
	  //  example 10: number_format('1.20', 2)
	  //  returns 10: '1.20'
	  //  example 11: number_format('1.20', 4)
	  //  returns 11: '1.2000'
	  //  example 12: number_format('1.2000', 3)
	  //  returns 12: '1.200'
	  //  example 13: number_format('1 000,50', 2, '.', ' ')
	  //  returns 13: '100 050.00'
	  //  example 14: number_format(1e-8, 8, '.', '')
	  //  returns 14: '0.00000001'
	
	  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	  var n = !isFinite(+number) ? 0 : +number;
	  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	  var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
	  var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
	  var s = '';
	
	  var toFixedFix = function toFixedFix(n, prec) {
	    if (('' + n).indexOf('e') === -1) {
	      return +(Math.round(n + 'e+' + prec) + 'e-' + prec);
	    } else {
	      var arr = ('' + n).split('e');
	      var sig = '';
	      if (+arr[1] + prec > 0) {
	        sig = '+';
	      }
	      return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec);
	    }
	  };
	
	  // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
	  s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.');
	  if (s[0].length > 3) {
	    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	  }
	  if ((s[1] || '').length < prec) {
	    s[1] = s[1] || '';
	    s[1] += new Array(prec - s[1].length + 1).join('0');
	  }
	
	  return s.join(dec);
	};
	//# sourceMappingURL=number_format.js.map

/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	__webpack_require__(223);
	var functions = __webpack_require__(166);
	
	var Basket = (function () {
	    /**
	     * В конструктор передается изменямый элемент
	     * @param element {HTMLElement}
	     */
	
	    function Basket(element) {
	        _classCallCheck(this, Basket);
	
	        this.element = $(element);
	        this.curItem = this.element.closest('.cart__item');
	        this.alsoItems = this.curItem.find('.cart__also-items');
	    }
	
	    /**
	     * Анимация показать сопуствующие товары
	     */
	
	    _createClass(Basket, [{
	        key: 'animateShowAlso',
	        value: function animateShowAlso() {
	            var $alsoItems = this.alsoItems;
	            this.alsoItems.css('max-height', 0).addClass('cart__also-items--visible');
	
	            var trueHeight = functions.getTrueHeight(this.alsoItems);
	
	            this.alsoItems.css('max-height', trueHeight);
	
	            setTimeout(function () {
	                $alsoItems.addClass('no-transition').css('max-height', 'none');
	            }, 550);
	
	            this.curItem.find('.js-cart-show-also-items').addClass('cart__also-link--hidden');
	            this.curItem.find('.js-cart-hide-also-items').removeClass('cart__also-link--hidden');
	        }
	
	        /**
	         * Анимация скрыть сопуствующие товары
	         */
	    }, {
	        key: 'animateHideAlso',
	        value: function animateHideAlso() {
	            var $alsoItems = this.alsoItems;
	            this.alsoItems.css('max-height', this.alsoItems.height() + 'px');
	
	            setTimeout(function () {
	                $alsoItems.removeClass('no-transition').css('max-height', 0);
	            }, 25);
	
	            setTimeout(function () {
	                $alsoItems.removeClass('cart__also-items--visible');
	            }, 550);
	
	            this.curItem.find('.js-cart-show-also-items').removeClass('cart__also-link--hidden');
	            this.curItem.find('.js-cart-hide-also-items').addClass('cart__also-link--hidden');
	        }
	
	        /**
	         * Анимация удалить товар
	         */
	    }, {
	        key: 'animateDeleteProduct',
	        value: function animateDeleteProduct() {
	            var $curItem = this.curItem;
	            var $to = $('<div class="cart__item cart__item--empty" />').insertAfter(this.curItem);
	
	            this.curItem.width(this.curItem.width());
	
	            $to.height(this.curItem.height());
	            this.curItem.css('top', this.curItem.position().top).addClass('cart__item--abs cart__item--deleting');
	            $curItem.remove();
	            $to.animate({ height: 0 }, 350, function () {
	                $to.remove();
	            });
	        }
	
	        /**
	         * Ajax запрос на обновление количества товара в корзине
	         * @param productId {number} - Ид товара
	         * @param quantity {number} Количество
	         * @param parentProductId {number} Ид товара родителя у связанных товаров
	         */
	    }, {
	        key: 'updateProductQuantity',
	        value: function updateProductQuantity(productId, quantity, parentProductId) {
	            if (parentProductId == undefined) {
	                parentProductId = 0;
	            }
	            return $.ajax({
	                url: '/ajax/action/basket_add_popup/add_to_basket_ajax/',
	                data: 'PRODUCT_ID=' + productId + '&QUANTITY=' + quantity + '&PARENT_PRODUCT_ID=' + parentProductId
	            }).then(function (result) {
	                $('input[name="QUANTITY_' + productId + '"]').val(result.data['QUANTITY']);
	                window.updateMiniBasket();
	            });
	        }
	    }]);
	
	    return Basket;
	})();
	
	module.exports = Basket;
	
	jQuery(function () {
	    $(document).on('click', '.js-cart-show-also-items', function (e) {
	        e.preventDefault();
	        var basket = new Basket(this);
	        basket.animateShowAlso();
	    });
	
	    $(document).on('click', '.js-cart-hide-also-items', function (e) {
	        e.preventDefault();
	        var basket = new Basket(this);
	        basket.animateHideAlso();
	    });
	
	    $(document).on('click', '.js-delete-cart-item', function (e) {
	        e.preventDefault();
	        var basket = new Basket(this);
	        basket.animateDeleteProduct();
	    });
	});

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(237);

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(238);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(239), __esModule: true };

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(240);
	__webpack_require__(251);
	module.exports = __webpack_require__(61).Array.from;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(241)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(242)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84);
	var defined = __webpack_require__(81);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(88);
	var $export = __webpack_require__(59);
	var redefine = __webpack_require__(243);
	var hide = __webpack_require__(64);
	var Iterators = __webpack_require__(244);
	var $iterCreate = __webpack_require__(245);
	var setToStringTag = __webpack_require__(248);
	var getPrototypeOf = __webpack_require__(250);
	var ITERATOR = __webpack_require__(249)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(64);


/***/ }),
/* 244 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(246);
	var descriptor = __webpack_require__(73);
	var setToStringTag = __webpack_require__(248);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(64)(IteratorPrototype, __webpack_require__(249)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(66);
	var dPs = __webpack_require__(75);
	var enumBugKeys = __webpack_require__(90);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(71)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(247).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(60).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(65).f;
	var has = __webpack_require__(74);
	var TAG = __webpack_require__(249)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(87)('wks');
	var uid = __webpack_require__(89);
	var Symbol = __webpack_require__(60).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(74);
	var toObject = __webpack_require__(139);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(62);
	var $export = __webpack_require__(59);
	var toObject = __webpack_require__(139);
	var call = __webpack_require__(252);
	var isArrayIter = __webpack_require__(253);
	var toLength = __webpack_require__(83);
	var createProperty = __webpack_require__(254);
	var getIterFn = __webpack_require__(255);
	
	$export($export.S + $export.F * !__webpack_require__(257)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(66);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(244);
	var ITERATOR = __webpack_require__(249)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(65);
	var createDesc = __webpack_require__(73);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(256);
	var ITERATOR = __webpack_require__(249)('iterator');
	var Iterators = __webpack_require__(244);
	module.exports = __webpack_require__(61).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(80);
	var TAG = __webpack_require__(249)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(249)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(259), __esModule: true };

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(260);
	__webpack_require__(240);
	__webpack_require__(261);
	__webpack_require__(265);
	__webpack_require__(278);
	__webpack_require__(279);
	module.exports = __webpack_require__(61).Promise;


/***/ }),
/* 260 */
/***/ (function(module, exports) {



/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(262);
	var global = __webpack_require__(60);
	var hide = __webpack_require__(64);
	var Iterators = __webpack_require__(244);
	var TO_STRING_TAG = __webpack_require__(249)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(263);
	var step = __webpack_require__(264);
	var Iterators = __webpack_require__(244);
	var toIObject = __webpack_require__(78);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(242)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(88);
	var global = __webpack_require__(60);
	var ctx = __webpack_require__(62);
	var classof = __webpack_require__(256);
	var $export = __webpack_require__(59);
	var isObject = __webpack_require__(67);
	var aFunction = __webpack_require__(63);
	var anInstance = __webpack_require__(266);
	var forOf = __webpack_require__(267);
	var speciesConstructor = __webpack_require__(268);
	var task = __webpack_require__(269).set;
	var microtask = __webpack_require__(271)();
	var newPromiseCapabilityModule = __webpack_require__(272);
	var perform = __webpack_require__(273);
	var userAgent = __webpack_require__(274);
	var promiseResolve = __webpack_require__(275);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(249)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(276)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(248)($Promise, PROMISE);
	__webpack_require__(277)(PROMISE);
	Wrapper = __webpack_require__(61)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(257)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 266 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(62);
	var call = __webpack_require__(252);
	var isArrayIter = __webpack_require__(253);
	var anObject = __webpack_require__(66);
	var toLength = __webpack_require__(83);
	var getIterFn = __webpack_require__(255);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(66);
	var aFunction = __webpack_require__(63);
	var SPECIES = __webpack_require__(249)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(62);
	var invoke = __webpack_require__(270);
	var html = __webpack_require__(247);
	var cel = __webpack_require__(71);
	var global = __webpack_require__(60);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(80)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 270 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var macrotask = __webpack_require__(269).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(80)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(63);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 273 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var isObject = __webpack_require__(67);
	var newPromiseCapability = __webpack_require__(272);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(64);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(60);
	var core = __webpack_require__(61);
	var dP = __webpack_require__(65);
	var DESCRIPTORS = __webpack_require__(69);
	var SPECIES = __webpack_require__(249)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(59);
	var core = __webpack_require__(61);
	var global = __webpack_require__(60);
	var speciesConstructor = __webpack_require__(268);
	var promiseResolve = __webpack_require__(275);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(59);
	var newPromiseCapability = __webpack_require__(272);
	var perform = __webpack_require__(273);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debounce = __webpack_require__(52);
	__webpack_require__(294);
	
	var functions = __webpack_require__(166);
	
	jQuery(function ($) {
	    var checkHeightLimitBlock = function checkHeightLimitBlock($block) {
	        if ($block == undefined) $block = $('.js-height-limit');
	
	        //блок должен быть Jquery объектом а не какой-то левой фигней
	        if ($block.bind !== $.prototype.bind) $block = $('.js-height-limit');
	
	        if ($block.length == 0) return;
	
	        if (!$block.hasClass('js-height-limit')) return;
	
	        $block.each(function () {
	            var $this = $(this);
	            if ($this.hasClass('height-limit--full')) return;
	
	            if (!$this.is(':visible')) return;
	
	            var maxHeight = parseInt($this.css('max-height'));
	            $this.removeClass('height-limit--visible');
	
	            if ($this.innerHeight() < maxHeight) $this.addClass('height-limit--visible');
	        });
	    };
	
	    $(document).on('click', '.js-height-limit-more', function (e) {
	        e.preventDefault();
	        var $block = $(this).closest('.height-limit');
	        var trueHeight = functions.getTrueHeight($block);
	
	        if ($block.hasClass('height-limit--full')) {
	            $block.css('max-height', trueHeight);
	
	            setTimeout(function () {
	                $block.removeAttr('style');
	                $block.removeClass('no-transition');
	            }, 25);
	
	            setTimeout(function () {
	                $block.removeClass('height-limit--full');
	            }, 400);
	        } else {
	            $block.css('max-height', trueHeight);
	
	            setTimeout(function () {
	                $block.addClass('height-limit--full no-transition').css('max-height', 'none');
	            }, 400);
	        }
	    });
	
	    debounce.setResizeDebounce(checkHeightLimitBlock);
	
	    module.exports.checkHeightLimitBlock = checkHeightLimitBlock;
	});

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var YandexSmartCaptcha = (function () {
	    /*
	    пример контейнера для капчи
	    есть виджет maximaster:widget.yandex.smart.captcha.container
	    <div
	        id="aut_reg_smart_captcha"
	        style="min-width: auto; margin-top: 20px"
	        data-sitekey="ysc1_7Gfc5vSRT9kf7nBgpNatfxUWcZciH0nCpf9gTEidb2202d43"
	        data-widget-id=""
	    ></div>
	    */
	
	    /**
	     * @param elementId - ID контейнера (id="aut_reg_smart_captcha")
	     */
	
	    function YandexSmartCaptcha(elementId) {
	        _classCallCheck(this, YandexSmartCaptcha);
	
	        this.smartCaptcha = window.smartCaptcha || undefined;
	        this.container = $('#' + elementId);
	
	        console.log(elementId);
	    }
	
	    _createClass(YandexSmartCaptcha, [{
	        key: 'init',
	        value: function init() {
	            if (!this.smartCaptcha) {
	                throw new Error('YandexSmartCaptcha error init');
	            }
	
	            var widgetId = this.getWidgetId();
	            if (!widgetId) {
	                console.log('YandexSmartCaptcha: new init');
	
	                if (this.container.length > 0 && this.container[0]) {
	                    widgetId = this.smartCaptcha.render(this.container[0], {
	                        sitekey: this.getSiteKey()
	                    });
	                } else {
	                    console.error('Контейнер капчи не найден:', this.container);
	                }
	                /*let widgetId = this.smartCaptcha.render(this.container[0], {
	                    sitekey: this.getSiteKey()
	                });*/
	
	                this.setWidgetId(widgetId);
	            } else {
	                console.log('YandexSmartCaptcha: reset init');
	                window.smartCaptcha.reset(widgetId);
	            }
	        }
	    }, {
	        key: 'getWidgetId',
	        value: function getWidgetId() {
	            return this.container.attr('data-widget-id');
	        }
	    }, {
	        key: 'setWidgetId',
	        value: function setWidgetId(widgetId) {
	            return this.container.attr('data-widget-id', widgetId);
	        }
	    }, {
	        key: 'getSiteKey',
	        value: function getSiteKey() {
	            return this.container.attr('data-sitekey');
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.container.hide();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.container.show();
	        }
	    }, {
	        key: 'getToken',
	        value: function getToken() {
	            return this.container.find('[name="smart-token"]').val();
	        }
	    }]);
	
	    return YandexSmartCaptcha;
	})();

	exports.YandexSmartCaptcha = YandexSmartCaptcha;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(301);
	__webpack_require__(302);
	
	var dropFile = __webpack_require__(306);
	var styledSelect = __webpack_require__(309);
	var ratingStars = __webpack_require__(315);
	var functions = __webpack_require__(166);
	
	jQuery(function () {
	    $.prompt.setDefaults({
	        promptspeed: 0,
	        overlayspeed: 300,
	        opacity: 0.5,
	        closeText: 'Закрыть',
	        loaded: function loaded() {
	            var $jqi = $('.jqi');
	            $jqi.addClass('shown');
	        },
	        beforeclose: function beforeclose(e) {
	            var $box = $(e.target);
	            $box.find('.jqi').removeClass('shown');
	        },
	        statechanging: function statechanging() {
	            var $form = $('.jqiform');
	
	            //выключить валидатор, чтоб не глючил в момент переключения состояний
	            $form.off('.validate').removeData('validator').find('.validate-equalTo-blur').off('.validate-equalTo').removeClass('validate-equalTo-blur');
	        },
	        statechanged: function statechanged(event, toStateName) {
	            var $jqi = $('.jqi');
	            var $form = $('.jqiform');
	            var $styledSelects = $jqi.find('.js-styled-select:visible');
	            styledSelect.styleSelects($styledSelects);
	            functions.setMaskedPhone($('.js-masked-phone'));
	
	            if ($form.find('.js-rating-stars').length > 0) {
	                ratingStars.setStars($form.find('.js-rating-stars'));
	            }
	
	            $form.find('.form__input--error').removeClass('form__input--error');
	            $form.find('.form__error-msg').remove();
	
	            if (toStateName == 'regFormStep3_specialist') dropFile.setDropFile($('#diploma-dropfile'));
	
	            if (toStateName == 'regFormStep2_organization') dropFile.setDropFile($('#requisites-dropfile'));
	        },
	        closeDelay: 350,
	        buttons: {}
	    });
	
	    $.prompt.setStateDefaults({
	        buttons: {}
	    });
	});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(124)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			factory(root.jQuery);
		}
	}(this, function($) {
		'use strict';
	
		// ########################################################################
		// Base object
		// ########################################################################
	
		/**
		* Imp - Impromptu object - passing no params will not open, only return the instance
		* @param message String/Object - String of html or Object of states
		* @param options Object - Options to set the prompt
		* @return Imp - the instance of this Impromptu object
		*/
		var Imp = function(message, options){
			var t = this;
			t.id = Imp.count++;
	
			Imp.lifo.push(t);
	
			if(message){
				t.open(message, options);
			}
			return t;
		};
	
		// ########################################################################
		// static properties and methods
		// ########################################################################
	
		/**
		* defaults - the default options
		*/
		Imp.defaults = {
			prefix:'jqi',
			classes: {
				box: '',
				fade: '',
				prompt: '',
				form: '',
				close: '',
				title: '',
				message: '',
				buttons: '',
				button: '',
				defaultButton: ''
			},
			title: '',
			closeText: '&times;',
			buttons: {
				Ok: true
			},
			buttonTimeout: 1000,
			loaded: function(e){},
			submit: function(e,v,m,f){},
			close: function(e,v,m,f){},
			beforeclose: function(e,v,m,f){},
			statechanging: function(e, from, to){},
			statechanged: function(e, to){},
			opacity: 0.6,
			zIndex: 999,
			overlayspeed: 'slow',
			promptspeed: 'fast',
			show: 'fadeIn',
			hide: 'fadeOut',
			focus: 0,
			defaultButton: 0,
			useiframe: false,
			top: '15%',
			position: {
				container: null,
				x: null,
				y: null,
				arrow: null,
				width: null
			},
			persistent: true,
			timeout: 0,
			closeDelay: 10,
			states: {},
			initialState: 0,
			state: {
				name: null,
				title: '',
				html: '',
				buttons: {
					Ok: true
				},
				focus: 0,
				defaultButton: 0,
				position: {
					container: null,
					x: null,
					y: null,
					arrow: null,
					width: null
				},
				submit: function(e,v,m,f){
					return true;
				}
			}
		};
	
		/**
		* setDefaults - Sets the default options
		* @param o Object - Options to set as defaults
		* @return void
		*/
		Imp.setDefaults = function(o) {
			Imp.defaults = $.extend({}, Imp.defaults, o);
		};
	
		/**
		* setStateDefaults - Sets the default options for a state
		* @param o Object - Options to set as defaults
		* @return void
		*/
		Imp.setStateDefaults = function(o) {
			Imp.defaults.state = $.extend({}, Imp.defaults.state, o);
		};
	
		/**
		* @var Int - A counter used to provide a unique ID for new prompts
		*/
		Imp.count = 0;
	
		/**
		* @var Array - An array of Impromptu intances in a LIFO queue (last in first out)
		*/
		Imp.lifo = [];
	
		/**
		* getLast - get the last element from the queue (doesn't pop, just returns)
		* @return Imp - the instance of this Impromptu object or false if queue is empty
		*/
		Imp.getLast = function(){
			var l = Imp.lifo.length;
			return (l > 0)? Imp.lifo[l-1] : false;
		};
	
		/**
		* removeFromStack - remove an element from the lifo stack by its id
		* @param id int - id of the instance to remove
		* @return api - The api of the element removed from the stack or void
		*/
		Imp.removeFromStack = function(id){
			for(var i=Imp.lifo.length-1; i>=0; i--){
				if(Imp.lifo[i].id === id){
					return Imp.lifo.splice(i,1)[0];
				}
			}
		};
	
		// ########################################################################
		// extend our object instance properties and methods
		// ########################################################################
		Imp.prototype = {
	
			/**
			* @var Int - A unique id, simply an autoincremented number
			*/
			id: null,
	
			/**
			* open - Opens the prompt
			* @param message String/Object - String of html or Object of states
			* @param options Object - Options to set the prompt
			* @return Imp - the instance of this Impromptu object
			*/
			open: function(message, options) {
				var t = this;
	
				t.options = $.extend(true,{},Imp.defaults,options);
	
				// Be sure any previous timeouts are destroyed
				if(t.timeout){
					clearTimeout(t.timeout);
				}
				t.timeout = false;
	
				var opts = t.options,
					$body = $(document.body),
					$window = $(window);
	
				//build the box and fade
				var msgbox = '<div class="'+ opts.prefix +'box '+ opts.classes.box +'">';
				if(opts.useiframe && ($('object, applet').length > 0)) {
					msgbox += '<iframe src="javascript:false;" class="'+ opts.prefix +'fade '+ opts.classes.fade +'"></iframe>';
				} else {
					msgbox += '<div class="'+ opts.prefix +'fade '+ opts.classes.fade +'"></div>';
				}
				msgbox += '<div class="'+ opts.prefix +' '+ opts.classes.prompt +'">'+
							'<form action="#" class="'+ opts.prefix +'form '+ opts.classes.form +'">'+
								'<div class="'+ opts.prefix +'close '+ opts.classes.close +'">'+ opts.closeText +'</div>'+
								'<div class="'+ opts.prefix +'states"></div>'+
							'</form>'+
						'</div>'+
					'</div>';
	
				t.jqib = $(msgbox).appendTo($body);
				t.jqi = t.jqib.children('.'+ opts.prefix);
				t.jqif = t.jqib.children('.'+ opts.prefix +'fade');
	
				//if a string was passed, convert to a single state
				if(message.constructor === String){
					message = {
						state0: {
							title: opts.title,
							html: message,
							buttons: opts.buttons,
							position: opts.position,
							focus: opts.focus,
							defaultButton: opts.defaultButton,
							submit: opts.submit
						}
					};
				}
	
				//build the states
				t.options.states = {};
				var k,v;
				for(k in message){
					v = $.extend({},Imp.defaults.state,{name:k},message[k]);
					t.addState(v.name, v);
	
					if(t.currentStateName === ''){
						t.currentStateName = v.name;
					}
				}
	
				//Events
				t.jqi.on('click', '.'+ opts.prefix +'buttons button', function(e){
					var $t = $(this),
						$state = $t.parents('.'+ opts.prefix +'state'),
						statename = $state.data('jqi-name'),
						stateobj = t.options.states[statename],
						msg = $state.children('.'+ opts.prefix +'message'),
						clicked = stateobj.buttons[$t.text()] || stateobj.buttons[$t.html()],
						forminputs = {};
	
					// disable for a moment to prevent multiple clicks
					if(t.options.buttonTimeout > 0){
						t.disableStateButtons(statename);
						setTimeout(function(){
							t.enableStateButtons(statename);
						}, t.options.buttonTimeout);
					}
	
					// if for some reason we couldn't get the value
					if(clicked === undefined){
						for(var i in stateobj.buttons){
							if(stateobj.buttons[i].title === $t.text() || stateobj.buttons[i].title === $t.html()){
								clicked = stateobj.buttons[i].value;
							}
						}
					}
	
					if (clicked === undefined)
					{
						clicked = $t.val();
					}
	
					//collect all form element values from all states.
					$.each(t.jqi.children('form').serializeArray(),function(i,obj){
						if (forminputs[obj.name] === undefined) {
							forminputs[obj.name] = obj.value;
						} else if (typeof forminputs[obj.name] === Array || typeof forminputs[obj.name] === 'object') {
							forminputs[obj.name].push(obj.value);
						} else {
							forminputs[obj.name] = [forminputs[obj.name],obj.value];
						}
					});
	
					// trigger an event
					var promptsubmite = new $.Event('impromptu:submit');
					promptsubmite.stateName = stateobj.name;
					promptsubmite.state = $state;
					$state.trigger(promptsubmite, [clicked, msg, forminputs]);
	
					if(!promptsubmite.isDefaultPrevented()){
						t.close(true, clicked,msg,forminputs);
					}
				});
	
				// if the fade is clicked blink the prompt
				var fadeClicked = function(){
					if(opts.persistent){
						var offset = (opts.top.toString().indexOf('%') >= 0? ($window.height()*(parseInt(opts.top,10)/100)) : parseInt(opts.top,10)),
							top = parseInt(t.jqi.css('top').replace('px',''),10) - offset;
	
						//$window.scrollTop(top);
						$('html,body').animate({ scrollTop: top }, 'fast', function(){
							var i = 0;
							t.jqib.addClass(opts.prefix +'warning');
							var intervalid = setInterval(function(){
								t.jqib.toggleClass(opts.prefix +'warning');
								if(i++ > 1){
									clearInterval(intervalid);
									t.jqib.removeClass(opts.prefix +'warning');
								}
							}, 100);
						});
					}
					else {
						t.close(true);
					}
				};
	
				// listen for esc or tab keys
				var keyDownEventHandler = function(e){
					var key = (window.event) ? event.keyCode : e.keyCode;
	
					//escape key closes
					if(key === 27) {
						fadeClicked();
					}
	
					//enter key pressed trigger the default button if its not on it, ignore if it is a textarea
					if(key === 13){
						var $defBtn = t.getCurrentState().find('.'+ opts.prefix +'defaultbutton');
						var $tgt = $(e.target);
	
						if($tgt.is('textarea,.'+opts.prefix+'button') === false && $defBtn.length > 0){
							e.preventDefault();
							$defBtn.click();
						}
					}
	
					//constrain tabs, tabs should iterate through the state and not leave
					if (key === 9){
						var $inputels = $('input,select,textarea,button',t.getCurrentState());
						var fwd = !e.shiftKey && e.target === $inputels[$inputels.length-1];
						var back = e.shiftKey && e.target === $inputels[0];
						if (fwd || back) {
							setTimeout(function(){
								if (!$inputels){
									return;
								}
								var el = $inputels[back===true ? $inputels.length-1 : 0];
	
								if (el){
									el.focus();
								}
							},10);
							return false;
						}
					}
				};
	
				t.position();
				t.style();
	
				// store copy of the window resize function for interal use only
				t._windowResize = function(e){
					t.position(e);
				};
				$window.resize({ animate: false }, t._windowResize);
	
				t.jqif.click(fadeClicked);
				t.jqi.find('.'+ opts.prefix +'close').click(function(){ t.close(); });
				t.jqi.find('.'+ opts.prefix +'form').submit(function(){ return false; });
				t.jqib.on("keydown",keyDownEventHandler)
							.on('impromptu:loaded', opts.loaded)
							.on('impromptu:beforeclose', opts.beforeclose)
							.on('impromptu:close', opts.close)
							.on('impromptu:statechanging', opts.statechanging)
							.on('impromptu:statechanged', opts.statechanged);
	
				// Show it
				t.jqif[opts.show](opts.overlayspeed);
				t.jqi[opts.show](opts.promptspeed, function(){
	
					t.goToState(
						isNaN(opts.initialState) ? opts.initialState : 
							t.jqi.find('.'+ opts.prefix +'states .'+ opts.prefix +'state').eq(opts.initialState).data('jqi-name')
					);
	
					t.jqib.trigger('impromptu:loaded');
				});
	
				// Timeout
				if(opts.timeout > 0){
					t.timeout = setTimeout(function(){ t.close(true); },opts.timeout);
				}
	
				return t;
			},
	
			/**
			* close - Closes the prompt
			* @param callCallback Function - called when the transition is complete
			* @param clicked String - value of the button clicked (only used internally)
			* @param msg jQuery - The state message body (only used internally)
			* @param formvals Object - key/value pairs of all form field names and values (only used internally)
			* @return Imp - the instance of this Impromptu object
			*/
			close: function(callCallback, clicked, msg, formvals){
				var t = this;
				t.jqib.trigger('impromptu:beforeclose', [clicked,msg,formvals]);
	
				if(t.timeout){
					clearTimeout(t.timeout);
					t.timeout = false;
				}
				Imp.removeFromStack(t.id);
	
				setTimeout(function(){
					if(t.jqib){
	
						t.jqib[t.options.hide](t.options.promptspeed,function(){
	
							t.jqib.trigger('impromptu:close', [clicked,msg,formvals]);
	
							t.jqib.remove();
	
							$(window).off('resize', t._windowResize);
	
							if(typeof callCallback === 'function'){
								callCallback();
							}
						});
					}
	
				}, t.options.closeDelay);
	
				t.currentStateName = "";
				return t;
			},
	
			/**
			* addState - Injects a state into the prompt
			* @param statename String - Name of the state
			* @param stateobj Object - options for the state
			* @param afterState String - selector of the state to insert after
			* @return jQuery - the newly created state
			*/
			addState: function(statename, stateobj, afterState) {
				var t = this,
					state = '',
					$state = null,
					arrow = '',
					title = '',
					opts = t.options,
					pos = $.isFunction(stateobj.position) ? stateobj.position() : stateobj.position,
					$jqistates = t.jqi.find('.'+ opts.prefix +'states'),
					buttons = [],
					showHtml,defbtn,k,v,l,i=0;
	
				stateobj = $.extend({},Imp.defaults.state, {name:statename}, stateobj);
	
				if($.isPlainObject(pos) && pos.arrow !== null){
					arrow = '<div class="'+ opts.prefix + 'arrow '+ opts.prefix + 'arrow'+ pos.arrow +'"></div>';
				}
				if(stateobj.title && stateobj.title !== ''){
					title = '<div class="lead '+ opts.prefix + 'title '+ opts.classes.title +'">'+  stateobj.title +'</div>';
				}
	
				showHtml = stateobj.html;
				if (typeof stateobj.html === 'function') {
					showHtml = 'Error: html function must return text';
				}
	
				state += '<div class="'+ opts.prefix + 'state" data-jqi-name="'+ statename +'">'+
							arrow + title +
							'<div class="'+ opts.prefix +'message '+ opts.classes.message +'">' + showHtml +'</div>'+
							'<div class="'+ opts.prefix +'buttons'+ ($.isEmptyObject(stateobj.buttons)? 'hide ':' ') + opts.classes.buttons +'">';
	
				// state buttons may be in object or array, lets convert objects to arrays
				if($.isArray(stateobj.buttons)){
					buttons = stateobj.buttons;
				}
				else if($.isPlainObject(stateobj.buttons)){
					for(k in stateobj.buttons){
						if(stateobj.buttons.hasOwnProperty(k)){
							buttons.push({ title: k, value: stateobj.buttons[k] });
						}
					}
				}
	
				// iterate over each button and create them
				for(i=0, l=buttons.length; i<l; i++){
					v = buttons[i],
					defbtn = stateobj.focus === i || (isNaN(stateobj.focus) && stateobj.defaultButton === i) ? (opts.prefix + 'defaultbutton ' + opts.classes.defaultButton) : '';
	
					state += '<button class="'+ opts.classes.button +' '+ opts.prefix + 'button '+ defbtn;
	
					if(typeof v.classes !== "undefined"){
						state += ' '+ ($.isArray(v.classes)? v.classes.join(' ') : v.classes) + ' ';
					}
	
					state += '" name="' + opts.prefix + '_' + statename + '_button' + v.title.replace(/[^a-z0-9]+/gi,'') + '" value="' + v.value + '">' + v.title + '</button>';
				}
				
				state += '</div></div>';
	
				$state = $(state).css({display:'none'});
	
				$state.on('impromptu:submit', stateobj.submit);
	
				if(afterState !== undefined){
					t.getState(afterState).after($state);
				}
				else{
					$jqistates.append($state);
				}
	
				t.options.states[statename] = stateobj;
	
				return $state;
			},
	
			/**
			* removeState - Removes a state from the prompt
			* @param state String - Name of the state
			* @param newState String - Name of the state to transition to
			* @return Boolean - returns true on success, false on failure
			*/
			removeState: function(state, newState) {
				var t = this,
					$state = t.getState(state),
					rm = function(){ $state.remove(); };
	
				if($state.length === 0){
					return false;
				}
	
				// transition away from it before deleting
				if($state.css('display') !== 'none'){
					if(newState !== undefined && t.getState(newState).length > 0){
						t.goToState(newState, false, rm);
					}
					else if($state.next().length > 0){
						t.nextState(rm);
					}
					else if($state.prev().length > 0){
						t.prevState(rm);
					}
					else{
						t.close();
					}
				}
				else{
					$state.slideUp('slow', rm);
				}
	
				return true;
			},
	
			/**
			* getApi - Get the api, so you can extract it from $.prompt stack
			* @return jQuery - the prompt
			*/
			getApi: function() {
				return this;
			},
	
			/**
			* getBox - Get the box containing fade and prompt
			* @return jQuery - the prompt
			*/
			getBox: function() {
				return this.jqib;
			},
	
			/**
			* getPrompt - Get the prompt
			* @return jQuery - the prompt
			*/
			getPrompt: function() {
				return this.jqi;
			},
	
			/**
			* getState - Get the state by its name
			* @param statename String - Name of the state
			* @return jQuery - the state
			*/
			getState: function(statename) {
				return this.jqi.find('[data-jqi-name="'+ statename +'"]');
			},
	
			/**
			* getCurrentState - Get the current visible state
			* @return jQuery - the current visible state
			*/
			getCurrentState: function() {
				return this.getState(this.getCurrentStateName());
			},
	
			/**
			* getCurrentStateName - Get the name of the current visible state/substate
			* @return String - the current visible state's name
			*/
			getCurrentStateName: function() {
				return this.currentStateName;
			},
	
			/**
			* disableStateButtons - Disables the buttons in a state
			* @param statename String - Name of the state containing buttons
			* @param buttons Array - Array of button values to disable. By default all are disabled
			* @param enable Boolean - True to enable the buttons instead of disabling (internally use only)
			* @return Void
			*/
			disableStateButtons: function(statename, buttons, enable) {
				var t = this;
	
				if($.isArray(statename)){
					buttons = statename;
					statename = null;
				}
				
				t.getState(statename || t.getCurrentStateName()).find('.'+ t.options.prefix + 'button').each(function(i,btn){
					if(buttons === undefined || $.inArray(btn.value, buttons) !== -1){
						btn.disabled = !enable;
					}
				});
			},
	
			/**
			* enableStateButtons - Enables the buttons in a state
			* @param statename String - Name of the state containing buttons. Defaults to current state
			* @param buttons Array - Array of button values to enable. By default all are enabled
			* @return Void
			*/
			enableStateButtons: function(statename, buttons) {
				this.disableStateButtons(statename, buttons, true);
			},
	
			/**
			* position - Repositions the prompt (Used internally)
			* @return void
			*/
			position: function(e){
				var t = this,
					restoreFx = $.fx.off,
					$state = t.getCurrentState(),
					stateObj = t.options.states[$state.data('jqi-name')],
					pos = stateObj ? $.isFunction(stateObj.position) ? stateObj.position() : stateObj.position : undefined,
					$window = $(window),
					bodyHeight = document.body.scrollHeight, //$(document.body).outerHeight(true),
					windowHeight = $(window).height(),
					documentHeight = $(document).height(),
					height = (bodyHeight > windowHeight) ? bodyHeight : windowHeight,
					scrollTop = parseInt($window.scrollTop(),10),
					top = scrollTop + (t.options.top.toString().indexOf('%') >= 0?
							(windowHeight*(parseInt(t.options.top,10)/100)) : parseInt(t.options.top,10));
	
				// when resizing the window turn off animation
				if(e !== undefined && e.data.animate === false){
					$.fx.off = true;
				}
	
				t.jqib.css({
					position: "absolute",
					height: height,
					width: "100%",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				});
				t.jqif.css({
					position: "fixed",
					height: height,
					width: "100%",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				});
	
				// tour positioning
				if(pos && pos.container){
					var offset = $(pos.container).offset(),
						hasScrolled = false;
						
					if($.isPlainObject(offset) && offset.top !== undefined){
						top = (offset.top + pos.y) - (t.options.top.toString().indexOf('%') >= 0? (windowHeight*(parseInt(t.options.top,10)/100)) : parseInt(t.options.top,10));
	
						t.jqi.css({
							position: "absolute"
						});
						t.jqi.animate({
							top: offset.top + pos.y,
							left: offset.left + pos.x,
							marginLeft: 0,
							width: (pos.width !== undefined)? pos.width : null
						}, function(){
							// if it didn't scroll before, check that the bottom is within view. Since width 
							// is animated we must use the callback before we know the height
							if(!hasScrolled && (offset.top + pos.y + t.jqi.outerHeight(true)) > (scrollTop + windowHeight)){
								$('html,body').animate({ scrollTop: top }, 'slow', 'swing', function(){});
								hasScrolled = true;
							}
						});
	
						// scroll if the top is out of the viewing area
						if(top < scrollTop || top > scrollTop + windowHeight){
							$('html,body').animate({ scrollTop: top }, 'slow', 'swing', function(){});
							hasScrolled = true;
						}
					}
				}
				// custom state width animation
				else if(pos && pos.width){
					t.jqi.css({
							position: "absolute",
							left: '50%'
						});
					t.jqi.animate({
							top: pos.y || top,
							left: pos.x || '50%',
							marginLeft: ((pos.width/2)*-1),
							width: pos.width
						});
				}
				// standard prompt positioning
				else{
					t.jqi.css({
						position: "absolute",
						top: top,
						left: '50%',//$window.width()/2,
						marginLeft: ((t.jqi.outerWidth(false)/2)*-1)
					});
				}
	
				// restore fx settings
				if(e !== undefined && e.data.animate === false){
					$.fx.off = restoreFx;
				}
			},
	
			/**
			* style - Restyles the prompt (Used internally)
			* @return void
			*/
			style: function(){
				var t = this;
				
				t.jqif.css({
					zIndex: t.options.zIndex,
					display: "none",
					opacity: t.options.opacity
				});
				t.jqi.css({
					zIndex: t.options.zIndex+1,
					display: "none"
				});
				t.jqib.css({
					zIndex: t.options.zIndex
				});
			},
	
			/**
			* goToState - Goto the specified state
			* @param state String - name of the state to transition to
			* @param subState Boolean - true to be a sub state within the currently open state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			goToState: function(state, subState, callback) {
				var t = this,
					$jqi = t.jqi,
					jqiopts = t.options,
					$state = t.getState(state),
					stateobj = jqiopts.states[$state.data('jqi-name')],
					promptstatechanginge = new $.Event('impromptu:statechanging'),
					opts = t.options;
	
				if(stateobj !== undefined){
	
	
					if (typeof stateobj.html === 'function') {
						var contentLaterFunc = stateobj.html;
						$state.find('.' + opts.prefix +'message ').html(contentLaterFunc());
					}
	
					// subState can be ommitted
					if(typeof subState === 'function'){
						callback = subState;
						subState = false;
					}
	
					t.jqib.trigger(promptstatechanginge, [t.getCurrentStateName(), state]);
	
					if(!promptstatechanginge.isDefaultPrevented() && $state.length > 0){
						t.jqi.find('.'+ opts.prefix +'parentstate').removeClass(opts.prefix +'parentstate');
	
						if(subState){ // hide any open substates
							// get rid of any substates
							t.jqi.find('.'+ opts.prefix +'substate').not($state)
								.slideUp(jqiopts.promptspeed)
								.removeClass('.'+ opts.prefix +'substate')
								.find('.'+ opts.prefix +'arrow').hide();
	
							// add parent state class so it can be visible, but blocked
							t.jqi.find('.'+ opts.prefix +'state:visible').addClass(opts.prefix +'parentstate');
	
							// add substate class so we know it will be smaller
							$state.addClass(opts.prefix +'substate');
						}
						else{ // hide any open states
							t.jqi.find('.'+ opts.prefix +'state').not($state)
								.slideUp(jqiopts.promptspeed)
								.find('.'+ opts.prefix +'arrow').hide();
						}
						t.currentStateName = stateobj.name;
	
						$state.slideDown(jqiopts.promptspeed,function(){
							var $t = $(this);
							t.enableStateButtons();
							
							// if focus is a selector, find it, else its button index
							if(typeof(stateobj.focus) === 'string'){
								$t.find(stateobj.focus).eq(0).focus();
							}
							else{
								$t.find('.'+ opts.prefix +'defaultbutton').focus();
							}
	
							$t.find('.'+ opts.prefix +'arrow').show(jqiopts.promptspeed);
	
							if (typeof callback === 'function'){
								t.jqib.on('impromptu:statechanged', callback);
							}
							t.jqib.trigger('impromptu:statechanged', [state]);
							if (typeof callback === 'function'){
								t.jqib.off('impromptu:statechanged', callback);
							}
						});
						if(!subState){
							t.position();
						}
					} // end isDefaultPrevented()	
				}// end stateobj !== undefined
	
				return $state;
			},
	
			/**
			* nextState - Transition to the next state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			nextState: function(callback) {
				var t = this,
					$next = t.getCurrentState().next();
				if($next.length > 0){
					t.goToState( $next.data('jqi-name'), callback );
				}
				return $next;
			},
	
			/**
			* prevState - Transition to the previous state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			prevState: function(callback) {
				var t = this,
					$prev = t.getCurrentState().prev();
				if($prev.length > 0){
					t.goToState( $prev.data('jqi-name'), callback );
				}
				return $prev;
			}
	
		};
	
		// ########################################################################
		// $.prompt will manage a queue of Impromptu instances
		// ########################################################################
	
		/**
		* $.prompt create a new Impromptu instance and push it on the stack of instances
		* @param message String/Object - String of html or Object of states
		* @param options Object - Options to set the prompt
		* @return jQuery - the jQuery object of the prompt within the modal
		*/
		$.prompt = function(message, options){
			var api = new Imp(message, options);
			return api.jqi;
		};
	
		/**
		* Copy over static methods
		*/
		$.each(Imp, function(k,v){
			$.prompt[k] = v;
		});
	
		/**
		* Create a proxy for accessing all instance methods. The close method pops from queue.
		*/
		$.each(Imp.prototype, function(k,v){
			$.prompt[k] = function(){
				var api = Imp.getLast(); // always use the last instance on the stack
	
				if(api && typeof api[k] === "function"){
					return api[k].apply(api, arguments);
				}
			};
		});
	
		// ########################################################################
		// jQuery Plugin and public access
		// ########################################################################
	
		/**
		* Enable using $('.selector').prompt({});
		* This will grab the html within the prompt as the prompt message
		*/
		$.fn.prompt = function(options){
			if(options === undefined){
				options = {};
			}
			if(options.withDataAndEvents === undefined){
				options.withDataAndEvents = false;
			}
	
			$.prompt($(this).clone(options.withDataAndEvents).html(),options);
		};
	
		/**
		* Export it as Impromptu and $.prompt
		* Can be used from here forth as new Impromptu(states, opts)
		*/
		window.Impromptu = Imp;
	
	}));


/***/ }),
/* 302 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(307);
	
	// reference: https://css-tricks.com/drag-and-drop-file-uploading/
	
	jQuery(function () {
	    // feature detection for drag&drop upload
	    var isAdvancedUpload = (function () {
	        var div = document.createElement('div');
	        return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
	    })();
	
	    module.exports.setDropFile = function ($dropContainer) {
	        // applying the effect for every form
	        $dropContainer.each(function () {
	            var $this = $(this),
	                $input = $this.find('input[type="file"]'),
	                $textContainer = $this.find('.drop-file__text'),
	
	            //$errorMsg	 = $this.find( '.box__error span' ),
	            droppedFiles = false,
	                showFiles = function showFiles(files) {
	                var $fileName = $textContainer.find('.drop-file__filename');
	                if ($fileName.length == 0) {
	                    $textContainer.append('<div class="drop-file__filename" />');
	                    $fileName = $textContainer.find('.drop-file__filename');
	                }
	
	                $fileName.text(files.length > 1 ? ($input.attr('data-multiple-caption') || '').replace('{count}', files.length) : files[0].name);
	            };
	
	            // letting the server side to know we are going to make an Ajax request
	            //$this.append( '<input type="hidden" name="ajax" value="1" />' );
	
	            // automatically submit the form on file select
	            $input.on('change', function (e) {
	                showFiles(e.target.files);
	            });
	
	            // drag&drop files if the feature is available
	            if (isAdvancedUpload) {
	                $this.addClass('has-advanced-upload') // letting the CSS part to know drag&drop is supported by the browser
	                .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
	                    // preventing the unwanted behaviours
	                    e.preventDefault();
	                    e.stopPropagation();
	                }).on('dragover dragenter', function () //
	                {
	                    $this.addClass('is-dragover');
	                }).on('dragleave dragend drop', function () {
	                    $this.removeClass('is-dragover');
	                }).on('drop', function (e) {
	                    droppedFiles = e.originalEvent.dataTransfer.files; // the files that were dropped
	                    showFiles(droppedFiles);
	                });
	            }
	        });
	    };
	});

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */,
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(310);
	__webpack_require__(312);
	
	var styleSelects = function styleSelects($select) {
	    var overwriteOption = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    $select.each(function () {
	        var $this = $(this);
	
	        var options = {
	            language: 'ru',
	            minimumResultsForSearch: Infinity,
	            dropdownParent: $this.parent()
	        };
	
	        if (!$.isEmptyObject(overwriteOption)) {
	            options = overwriteOption;
	            options.dropdownParent = $this.parent();
	        }
	
	        $this.select2(options).on('select2:open', function () {
	            var $options = $this.parent().find('.select2-container--default .select2-results > .select2-results__options');
	
	            $options.mCustomScrollbar('destroy');
	            $options.mCustomScrollbar('update');
	
	            setTimeout(function () {
	                $options.mCustomScrollbar({
	                    axis: 'y',
	                    scrollbarPosition: 'inside',
	                    advanced: {
	                        updateOnContentResize: true
	                    },
	                    live: true
	                });
	            }, 0);
	        });
	    });
	};
	
	module.exports.styleSelects = styleSelects;

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */,
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(313);

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */,
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(316);
	
	jQuery(function () {
	    var setStars = function setStars($ratingStars) {
	        if ($ratingStars == undefined) $ratingStars = $('.js-rating-stars');
	
	        var $elementRate = $ratingStars.find('.rating-stars__star-yellow');
	        var curSelectedValElementRate = $elementRate.filter('.rating-stars__star-yellow--filled').length;
	
	        $ratingStars.each(function () {
	            var $this = $ratingStars;
	            var $stars = $this.find('.rating-stars__star');
	            var $input = $this.find('.rating-stars__hidden-value');
	
	            var curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
	            if (curSelectedVal >= 1) curSelectedVal -= 1;
	
	            $stars.hover(function () {
	                var $curStar = $(this);
	                $stars.removeClass('rating-stars__star--filled');
	                $curStar.prevAll('.rating-stars__star').andSelf().addClass('rating-stars__star--hover');
	            }, function () {
	                $stars.removeClass('rating-stars__star--hover');
	                $stars.slice(0, curSelectedVal).addClass('rating-stars__star--filled');
	            });
	
	            $stars.click(function () {
	                var $curStar = $(this);
	                $curStar.prevAll('.rating-stars__star').andSelf().addClass('rating-stars__star--filled');
	
	                curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
	                $input.val(curSelectedVal);
	            });
	
	            if (curSelectedValElementRate >= 1) curSelectedValElementRate -= 1;
	
	            $elementRate.hover(function () {
	                var $curStar = $(this);
	                $elementRate.removeClass('rating-stars__star-yellow--filled');
	                $curStar.prevAll('.rating-stars__star-yellow').andSelf().addClass('rating-stars__star-yellow--hover');
	            }, function () {
	                $elementRate.removeClass('rating-stars__star-yellow--hover');
	                $elementRate.slice(0, curSelectedValElementRate).addClass('rating-stars__star-yellow--filled');
	            });
	        });
	    };
	
	    setStars();
	
	    module.exports.setStars = setStars;
	});
	
	/* При клике на звездочку устаналиваем оценку для элемента */
	$('.js-rating-stars').find('.rating-stars__star-yellow').one('click', function () {
	    var $curStar = $(this);
	    $curStar.prevAll('.rating-stars__star-yellow').andSelf().addClass('rating-stars__star-yellow--filled');
	    $.ajax({
	        url: '/ajax/action/element_rate/add/',
	        data: 'rating=' + $('.js-rating-stars').find('.rating-stars__star-yellow').filter('.rating-stars__star-yellow--filled').length + '&element_id=' + $('input[name="rate_element_id"]').val() + '&entity_id=' + $('input[name="rate_entity_id"]').val(),
	        success: function success() {
	            $.ajax({
	                url: '/ajax/component/maximaster:element.rate/element/',
	                data: 'ENTITY_ID=' + $('input[name="rate_entity_id"]').val() + '&ELEMENT_ID=' + $('input[name="rate_element_id"]').val(),
	                success: function success(result) {
	                    $('.product-card__element_rate-container').html(result.html);
	                }
	            });
	        }
	    });
	});
	
	/* Вызываем окно авторизации, если кликает не авторизированный пользователь */
	$(document).on('click', '.js-rating-show-auth', function () {
	    if (!$('.jqi').hasClass('shown')) {
	        $('.js-jqi-show-login').trigger('click');
	    }
	});

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(319);
	var functions = __webpack_require__(166);
	
	jQuery(function () {
	    module.exports.formValidateDefaults = {
	        errorPlacement: function errorPlacement(error, element) {
	            element.addClass('form__input--error');
	            element.removeClass('form__input--correct');
	            var $elParent = element.parent();
	            $elParent.removeClass('icon-field--correct');
	            error.addClass('form__error-msg');
	
	            if (element.attr('type') == 'checkbox' || element.attr('type') == 'radio' || element.attr('type') == 'file') {
	                var $formField = element.closest('.form__field');
	                var $headlabel = $formField.find('.prompt__head-label').first();
	                error.addClass('form__error-msg--custom');
	
	                if ($headlabel.length > 0) {
	                    error.insertAfter($headlabel);
	                } else {
	                    $formField.prepend(error);
	                }
	            } else {
	                error.insertBefore($elParent);
	            }
	        },
	        focusInvalid: false,
	        onkeyup: false,
	        success: function success(label, element) {
	            label.remove();
	            var $el = $(element).removeClass('form__input--error');
	            $el.addClass('form__input--correct');
	            var $elParent = $el.parent();
	            $elParent.addClass('icon-field--correct');
	        },
	        errorElement: 'div',
	        onclick: false
	    };
	
	    functions.setMaskedPhone($('.js-masked-phone'));
	    functions.setMaskedPhoneCity($('.js-masked-phone-city'));
	    functions.setMaskedPhoneMobile($('.js-masked-phone-mobile'));
	});

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(358);
	
	jQuery(function () {
	    var container = document.querySelector('.cookie-access');
	    if (container) {
	        if (document.cookie.indexOf("cookie-access") != -1) {
	            container.classList.remove('cookie-access--active');
	        } else {
	            container.classList.add('cookie-access--active');
	            setTimeout(function () {
	                $('#retailcrm-consultant-app').addClass('retailcrm-consultant-app--position-150');
	            }, 1000);
	        }
	        var apply = container.querySelectorAll('.js-agree');
	        apply.forEach(function (button) {
	            button.addEventListener('click', function () {
	                container.classList.remove('cookie-access--active');
	                $('#retailcrm-consultant-app').addClass('retailcrm-consultant-app--position-0');
	                $('#retailcrm-consultant-app').removeClass('retailcrm-consultant-app--position-150');
	                document.cookie = 'cookie-access=true; max-age=2592000; path=/';
	                return false;
	            });
	        });
	    }
	});

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */,
/* 360 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */,
/* 373 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */,
/* 375 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */,
/* 377 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */,
/* 379 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */,
/* 381 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */,
/* 383 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */,
/* 385 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */,
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(388);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    $('.js-show-auth-links-block').click(function () {
	        if (window.innerWidth >= size.desktop) {
	            var $this = $(this);
	            var $links = $this.find('.personal-block__links');
	
	            $links.show();
	            setTimeout(function () {
	                $this.addClass('personal-block--hover');
	            }, 100);
	        }
	    });
	
	    $(document).click(function (e) {
	        var $personalBlock = $('.js-show-auth-links-block');
	        var $links = $personalBlock.find('.personal-block__links');
	
	        var $target = $(e.target);
	
	        if ($target.is($personalBlock) || $target.closest('.js-show-auth-links-block').length > 0) return;
	
	        $personalBlock.removeClass('personal-block--hover');
	        setTimeout(function () {
	            $links.hide();
	        }, 350);
	    });
	});

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */,
/* 390 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */,
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Promise = __webpack_require__(258)['default'];
	
	var updateMiniBasket = function updateMiniBasket() {
	    var p = $.ajax({
	        url: '/ajax/component/maximaster:small.basket.widget/'
	    });
	    var p2 = $.ajax({
	        url: '/ajax/component/maximaster:small.basket.widget/cart-preview/'
	    });
	
	    _Promise.all([p, p2]).then(function (data) {
	        var selectors = ['.js-cart-preview-head', '.js-cart-preview'];
	        for (var i in selectors) {
	            var html = data[i]['html'];
	            if (html) {
	                $(selectors[i]).html(html);
	            }
	        }
	    });
	};
	
	window.updateMiniBasket = updateMiniBasket;

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(397);
	
	jQuery(function () {
	    $('.js-city-guess-hide').click(function () {
	        $.ajax({
	            url: '/ajax/action/region_widget/setCookie/',
	            data: 'code=' + $(this).data('code')
	        });
	        $(this).closest('.city-data-block__city-guess').fadeOut(300);
	    });
	});

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */,
/* 399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */,
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(402);
	
	jQuery(function () {
	    $('.js-topmenu-item-dropdown').hover(function () {
	        var $this = $(this);
	        var $dropdown = $this.find('.topmenu__dropdown');
	
	        if ($dropdown.length > 0) {
	            $dropdown.stop().slideDown(200);
	        }
	    }, function () {
	        var $this = $(this);
	        var $dropdown = $this.find('.topmenu__dropdown');
	
	        if ($dropdown.length > 0) {
	            $dropdown.stop().slideUp(200);
	        }
	    });
	});

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */,
/* 404 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */,
/* 413 */,
/* 414 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */,
/* 416 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */,
/* 426 */,
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(428);
	
	jQuery(function () {
	
	    function updateBaseHeight() {
	        var $mobileMenu = $('.mobilemenu');
	        var $base = $mobileMenu.closest('body');
	        var $baseContent = $base.find('.main-container');
	
	        $mobileMenu.addClass('autoheight');
	
	        if ($mobileMenu.innerHeight() > $baseContent.innerHeight()) $base.css('min-height', $mobileMenu.innerHeight() + 'px');
	        $mobileMenu.removeClass('autoheight');
	    }
	    function createMobileMenu() {
	        var $existedMobileMenu = $('.mobilemenu');
	        if ($existedMobileMenu.length > 0) return $existedMobileMenu;
	        var $mobileMenu = $('<div class="mobilemenu" />');
	        var $closeButton = $('<div class="mobilemenu__close-button js-closemobile" />');
	
	        var innerParentText = $('.js-topmenu__main-link--current-inner').text();
	        var $innerParent = $('<div class="mobilemenu__menu-head mobilemenu__menu-head--open" />').text(innerParentText);
	
	        var $innerMenu = $('<ul class="mobilemenu__menu mobilemenu__menu--inner js-menu-inner-show" />');
	
	        $('.topmenu__inner-list').find('.topmenu__inner-item').each(function () {
	            var $this = $(this);
	            if ($this.hasClass('js-topmenu__inner-item--also')) return true;
	
	            var $item = $this.clone();
	
	            /////////////////////////////////////////
	            var $dropLiIndex = $('<div class="mobilemenu__item mobilemenu__item_all mobilemenu__item--child" />');
	            var menuDrop = $item.find('.topmenu__inner-link').clone();
	
	            menuDrop[0].innerHTML = 'Все товары';
	            $dropLiIndex.append(menuDrop);
	
	            if ($item.hasClass('js-topmenu-item-dropdown')) {
	                $item.find('.topmenu__inner-link').removeAttr('href');
	                $item.find('.topmenu__inner-link').addClass('js-mobilemenu-show-children-a');
	            }
	
	            var $itemDrop = $item.find('.topmenu__dropdown').clone();
	            $item.find('.topmenu__dropdown').remove();
	            $itemDrop.append($dropLiIndex);
	            $item.append($itemDrop);
	            /////////////////////////////////////////
	
	            $item.removeClass('topmenu__inner-item').addClass('mobilemenu__menu-item');
	
	            if ($this.hasClass('hidden')) {
	                $item.addClass('hidden');
	            }
	
	            $item.find('.topmenu__lvl4-list').remove();
	            $item.find('.topmenu__dropdown').addClass('mobilemenu__list mobilemenu__list--children');
	            var $arrowSpan = $('<span class="mobilemenu__link mobilemenu__arrow-icon js-mobilemenu-show-children" />');
	
	            if ($item.hasClass('js-topmenu-item-dropdown')) {
	                $item.append($arrowSpan);
	            }
	
	            $item.find('.topmenu__inner-link').removeClass('topmenu__inner-link').addClass('mobilemenu__menu-link mobilemenu__link mobilemenu__link--parent js-mobilemenu-show-parent-children');
	
	            $innerMenu.append($item);
	        });
	
	        $('.js-topmenu__inner-item--also').find('.topmenu__dropdown-column--lvl2').each(function () {
	            var $this = $(this);
	            var $item = $this.clone();
	
	            /////////////////////////////////////////
	            var $dropLiIndex = $('<div class="mobilemenu__item mobilemenu__item_all mobilemenu__item--child mobilemenu__item_all--lv2" />');
	            var menuDrop = $item.find('.topmenu__lvl2-link').clone();
	
	            menuDrop[0].innerHTML = 'Все товары';
	            $dropLiIndex.append(menuDrop);
	
	            $item.find('.topmenu__lvl2-link').removeAttr('href');
	            $item.find('.topmenu__lvl2-link').addClass('js-mobilemenu-show-children-a');
	            /////////////////////////////////////////
	
	            $item.removeClass('topmenu__lvl2-link topmenu__dropdown-column topmenu__dropdown-column--lvl2').addClass('js-topmenu-item-dropdown mobilemenu__menu-item');
	
	            if ($this.hasClass('hidden')) {
	                $item.addClass('hidden');
	            }
	
	            $item.find('.topmenu__lvl4-list').remove();
	
	            var $itemList = $('<div class="topmenu__dropdown mobilemenu__list mobilemenu__list--children" />');
	
	            $itemList.append($dropLiIndex);
	
	            $itemList.append($item.find('.topmenu__dropdown-column--lvl3'));
	            $item.append($itemList);
	
	            var $arrowSpan = $('<span class="mobilemenu__link mobilemenu__arrow-icon js-mobilemenu-show-children" />');
	            $item.append($arrowSpan);
	
	            $item.find('.topmenu__lvl2-link').removeClass('topmenu__lvl2-link').addClass('mobilemenu__menu-link mobilemenu__link mobilemenu__link--parent js-mobilemenu-show-parent-children');
	            $innerMenu.append($item);
	        });
	
	        var $ordMenu = $('.js-topmenu__main-list--main').clone();
	        $ordMenu.removeClass('topmenu__main-list').addClass('mobilemenu__menu');
	        $ordMenu.find('.js-topmenu__main-item--special').remove();
	        $ordMenu.find('.topmenu__main-item').removeClass('topmenu__main-item').removeClass('topmenu__main-item--mobile').addClass('mobilemenu__menu-item');
	        $ordMenu.find('.topmenu__main-link').removeClass('topmenu__main-link topmenu__main-link--catalog topmenu__main-link--current js-topmenu__main-link--current-inner topmenu__main-link--ico-phone topmenu__main-link--ico-discount').addClass('mobilemenu__menu-link');
	
	        var $cityBlock = $('.header__city').clone();
	        $cityBlock.removeClass('header__city').addClass('city-data-block--all-white mobilemenu__menu-item');
	        $cityBlock.find('.city-data-block__content').addClass('mobilemenu__menu-link');
	        $cityBlock.find('.city-data-block__phones').remove();
	
	        var $cart = $('.header__cart').clone();
	        $cart.removeClass('header__cart mini-cart--responsive').addClass('mini-cart--side');
	
	        $ordMenu.find('.mobilemenu__menu-item').each(function (i, el) {
	            if ('mobilename' in el.dataset) {
	                el.firstElementChild.textContent = el.dataset.mobilename;
	            }
	
	            if ('beforelast' in el.dataset) {
	                el.parentNode.insertBefore(el, el.parentNode.lastElementChild);
	            }
	
	            if ('adviser' in el.dataset) {
	                /*global carrotquest*/
	                /*if (carrotquest && carrotquest.messenger && carrotquest.messenger._collapsedClick) {
	                    el.firstElementChild.onclick = carrotquest.messenger._collapsedClick;
	                }*/
	            }
	        });
	        $mobileMenu.append($closeButton);
	        $mobileMenu.append($innerParent);
	        $mobileMenu.append($innerMenu);
	        $mobileMenu.append($ordMenu);
	        $mobileMenu.append($cityBlock);
	        $mobileMenu.append($cart);
	
	        if (!$cart.hasClass('mini-cart--empty')) {
	            var $cartLink = $('.cart-preview').find('.cart-preview__cart-link').clone();
	            $cartLink.removeClass().addClass('btn-def btn-def--block btn-def--fullwhite');
	
	            $mobileMenu.append($cartLink);
	        }
	
	        var $container = $('.main-container');
	        $container.append($mobileMenu);
	
	        return $mobileMenu;
	    }
	
	    $('.js-btn-mobilemenu').click(function (e) {
	        e.stopPropagation();
	        var $container = $(this).closest('.main-container');
	
	        var $mobileMenu = createMobileMenu();
	
	        if ($mobileMenu.hasClass('mobilemenu--shown')) {
	            $container.removeClass('main-container--shifted-left');
	            $container.css('min-height', '0');
	            $mobileMenu.removeClass('mobilemenu--shown');
	        } else {
	            setTimeout(function () {
	                $container.addClass('main-container--shifted-left');
	                $mobileMenu.addClass('mobilemenu--shown');
	                $mobileMenu.addClass('mobilemenu--autoheight');
	                if ($mobileMenu.height() > $container.height()) $container.css('min-height', $mobileMenu.height() + 'px');
	                $mobileMenu.removeClass('mobilemenu--autoheight');
	            }, 25);
	        }
	    });
	
	    $('.js-btn-mobilesearch').click(function (e) {
	        e.stopPropagation();
	
	        var divSearch = $('div.simple-search-form__mobile');
	        if (divSearch.length > 0) {
	            divSearch.remove();
	            $('main.page-content').css('margin-top', 0);
	        } else {
	            setTimeout(function () {
	                $.ajax({
	                    url: '/ajax/component/bitrix:search.form/mobile/',
	                    data: { PAGE: '/search/' },
	                    success: function success(response) {
	                        if (response['code'] == 200) {
	                            var search = $(response['html']);
	                            if (search[0].tagName !== 'FONT') {
	                                $('header.header > .header__wrapper').append(search);
	                                $('main.page-content').css('margin-top', search.outerHeight() + 'px');
	                            } else {
	                                console.log(search.text());
	                            }
	                        } else {
	                            console.log(response['message']);
	                        }
	                    }
	                });
	            }, 25);
	        }
	    });
	
	    $(document).on('click', '.main-container--shifted-left .container', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	        var $container = $(this).closest('.main-container');
	        var $mobileMenu = $('.mobilemenu');
	        $container.removeClass('main-container--shifted-left');
	        $container.css('min-height', '0');
	
	        $mobileMenu.removeClass('mobilemenu--shown');
	    });
	
	    $(document).on('click', '.js-closemobile', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	        var $container = $('.main-container.main-container--shifted-left');
	        var $mobileMenu = $('.mobilemenu');
	        $container.removeClass('main-container--shifted-left');
	        $container.css('min-height', '0');
	
	        $mobileMenu.removeClass('mobilemenu--shown');
	    });
	
	    $(document).on('click', '.mobilemenu__menu-head', function () {
	        var $this = $(this);
	        if ($this.hasClass('mobilemenu__menu-head--open')) {
	            $this.removeClass('mobilemenu__menu-head--open');
	            $this.addClass('mobilemenu__menu-head--close');
	            $('.js-menu-inner-show').hide();
	        } else {
	            $this.removeClass('mobilemenu__menu-head--close');
	            $this.addClass('mobilemenu__menu-head--open');
	            $('.js-menu-inner-show').show();
	        }
	    });
	
	    $(document).on('click', '.js-mobilemenu-show-children', function (e) {
	        e.preventDefault();
	
	        var $this = $(this);
	        var $thisItem = $this.closest('.mobilemenu__menu-item');
	        var $children = $thisItem.find('.mobilemenu__list--children');
	
	        if ($children.is(':visible')) {
	            $children.slideUp(300, function () {
	                updateBaseHeight();
	                $this.siblings('.mobilemenu__link--parent').removeClass('mobilemenu__link--opened');
	                $this.removeClass('mobilemenu__arrow-icon--opened');
	            });
	        } else {
	            $children.slideDown({
	                start: function start() {
	                    updateBaseHeight();
	                    $(this).css({
	                        display: "flex"
	                    });
	                }
	            });
	            $this.siblings('.mobilemenu__link--parent').addClass('mobilemenu__link--opened');
	            $this.addClass('mobilemenu__arrow-icon--opened');
	        }
	    });
	
	    $(document).on('click', '.js-mobilemenu-show-children-a', function (e) {
	        e.preventDefault();
	        var $this = $(this);
	        var $thisItem = $this.closest('.mobilemenu__menu-item');
	        var $children = $thisItem.find('.mobilemenu__list--children');
	
	        if ($children.is(':visible')) {
	            $children.slideUp(300, function () {
	                updateBaseHeight();
	                $this.removeClass('mobilemenu__link--opened');
	                $this.parent().find('.mobilemenu__arrow-icon').removeClass('mobilemenu__arrow-icon--opened');
	            });
	        } else {
	            $children.slideDown({
	                start: function start() {
	                    updateBaseHeight();
	                    $(this).css({
	                        display: "flex"
	                    });
	                }
	            });
	            $this.addClass('mobilemenu__link--opened');
	            $this.parent().find('.mobilemenu__arrow-icon').addClass('mobilemenu__arrow-icon--opened');
	        }
	    });
	});

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */,
/* 430 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */,
/* 432 */,
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debounce = __webpack_require__(52);
	__webpack_require__(434);
	__webpack_require__(312);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    function onResizeCartPreview() {
	        var $cartPreview = $('.cart-preview');
	        var $miniCartScroll = $cartPreview.find('.js-cart-items-scrollbar');
	        var $miniCart = $('.mini-cart.header__cart');
	
	        var $wrapper = $miniCart.closest('.wrapper');
	
	        //обновление вертикального скролла при изменении ширины сайта
	        // т.е. перешли из режима десктопа в мобильный и наоборот
	        if ($cartPreview.hasClass('cart-preview--shown')) {
	            if (window.innerWidth >= size.desktop) {
	                $miniCartScroll.mCustomScrollbar({
	                    axis: 'y'
	                });
	
	                var posWrapper = $wrapper.width() / 2;
	                var posWindow = window.innerWidth / 2;
	                var pos = Math.min(posWrapper, posWindow);
	                pos -= $cartPreview.innerWidth() + 1;
	                $cartPreview.css('margin-left', pos + 'px');
	            } else {
	                $miniCartScroll.mCustomScrollbar('destroy');
	            }
	        }
	    }
	
	    $(document).on('click', '.js-show-cart-preview', function () {
	        if ($('.js-cart-preview').html() == '') {
	            $.ajax({
	                url: '/ajax/component/maximaster:small.basket.widget/cart-preview/',
	                async: false,
	                success: function success(data) {
	                    $('.js-cart-preview').html(data['html']);
	                }
	            });
	        }
	
	        var $cartPreview = $('.cart-preview');
	        var $container = $cartPreview.closest('.main-container');
	        var $miniCart = $('.mini-cart.header__cart');
	
	        //надо сделать копию корзины из шапки, чтобы тень была единая вокруг
	        //корзины в шапке и самом блоке выпадающей корзины (на десктопе)
	        var $miniCartCopy = $miniCart.clone();
	        $miniCartCopy.removeClass('header__cart js-show-cart-preview mini-cart--active');
	        $cartPreview.find('.cart-preview__cart-copy').html($miniCartCopy);
	
	        $container.toggleClass('main-container--shifted-right');
	        $cartPreview.toggleClass('cart-preview--shown');
	        $miniCart.toggleClass('mini-cart--active');
	
	        $cartPreview.addClass('cart-preview--autoheight');
	        if ($cartPreview.innerHeight() > $container.height()) $container.css('min-height', $cartPreview.innerHeight() + 'px');
	        $cartPreview.removeClass('cart-preview--autoheight');
	
	        onResizeCartPreview();
	    });
	
	    debounce.setResizeDebounce(onResizeCartPreview);
	
	    $(document).on('click', '.main-container--shifted-right .container, .js-close-cart-preview', function (e) {
	        var $target = $(e.target);
	        var $cartPreview = $('.cart-preview');
	        var $container = $cartPreview.closest('.main-container');
	
	        if (!$(this).hasClass('js-close-cart-preview') && ($target.is($cartPreview) || $target.closest('.cart-preview').length > 0 || $target.is('.mini-cart') || $target.closest('.mini-cart').length > 0)) return;
	
	        e.stopPropagation();
	        e.preventDefault();
	
	        $container.removeClass('main-container--shifted-right');
	        $('.mini-cart.mini-cart--active').removeClass('mini-cart--active');
	        $cartPreview.removeClass('cart-preview--shown');
	        $container.css('min-height', '0');
	    });
	});

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */,
/* 436 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */,
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(439);
	
	var size = __webpack_require__(55);
	
	$(function () {
	    var tooltips = {
	        getTooltipContentTest: function getTooltipContentTest() {
	            return '<div class="tooltipster__title">Преимущества регистрации</div>' + '<ol class="reg-benefits reg-benefits--black-text">' + '<li class="reg-benefits__item">Если вы косметолог, Вы можете покупать товары по <b>ОПТОВОЙ ЦЕНЕ!</b></li>' + '<li class="reg-benefits__item"><b>1000 РУБЛЕЙ</b> в&nbsp;подарок на первую покупку</li>' + '<li class="reg-benefits__item">Зарегистрируйтесь и получите электронную книгу в <b>ПОДАРОК!</b></li>' + '</ol>';
	        }
	    };
	
	    var defaultTooptipsOptions = {
	        debug: false,
	        contentAsHTML: true,
	        interactive: true,
	        maxWidth: 18 * size.defaultFontSize,
	        repositionOnScroll: true,
	        side: ['bottom', 'top'],
	        trigger: 'custom',
	        triggerOpen: {
	            mouseenter: true,
	            tap: true
	        },
	        triggerClose: {
	            mouseleave: true,
	            tap: true
	        },
	        updateAnimation: null
	    };
	
	    $(document).on('mouseenter click', '.js-tooltip:not(.tooltipstered)', function (e) {
	        e.preventDefault();
	        var $this = $(this);
	
	        var func = tooltips[$this.data('tooltip-callback')];
	
	        if ($.isFunction(func)) {
	            $this.tooltipster($.extend({}, defaultTooptipsOptions, {
	                content: 'Загрузка...',
	                functionBefore: function functionBefore(instance, helper) {
	                    var $origin = $(helper.origin);
	
	                    if ($origin.data('loaded') !== true) {
	                        instance.content(func());
	                        $origin.data('loaded', true);
	
	                        //$.get('http://example.com/ajax.php', function(data) {
	                        //	instance.content(data);
	                        //	$origin.data('loaded', true);
	                        //});
	                    }
	                }
	            })).tooltipster('open');
	        } else {
	            $this.tooltipster($.extend({}, defaultTooptipsOptions, {
	                content: $this.data('tooltip')
	            })).tooltipster('open');
	        }
	    });
	});

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */,
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerEvents = __webpack_require__(131);
	
	var _trackerEvents2 = _interopRequireDefault(_trackerEvents);
	
	var slickDefaults = __webpack_require__(49);
	var size = __webpack_require__(55);
	
	var event = new _trackerEvents2['default']();
	
	jQuery(function ($) {
	    $('body').on('click', '.js-show-popup-card', function (e) {
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/component/maximaster:catalog.element/popup/?POPUP=Y&ELEMENT_CODE=' + $(this).data('elem_code') + '&NO_BASKET=' + $(this).data('no-basket'),
	            success: function success(result) {
	                var cardHtml = result.html;
	                $.prompt(cardHtml, {
	                    buttons: {},
	                    persistent: false, //чтобы можно было закрыть при клике по оверлею
	                    classes: {
	                        prompt: 'prompt--product',
	                        form: 'prompt__form--special',
	                        close: 'jqiclose--cross'
	                    },
	                    statechanged: function statechanged() {
	                        var $jqi = $('.jqi');
	                        var $card = $jqi.find('.product-card');
	                        if ($card.length > 0) setProductCard($card);
	
	                        event.onShowProductCardPopup();
	                    }
	                });
	            }
	        });
	        return false;
	    });
	
	    function setProductCard($card) {
	        if ($card == undefined) $card = $('.product-card');
	
	        var $cardPreviews = $card.find('.js-slick-previews:visible');
	        var $cardPreviewsCompact = $card.find('.js-slick-previews-compact:visible');
	
	        if ($cardPreviews.length > 0) {
	            $cardPreviews.slick($.extend({}, slickDefaults.params, {
	                slidesToShow: 4,
	                vertical: false,
	                verticalSwiping: false,
	                responsive: [{
	                    breakpoint: size.tabletBig,
	                    settings: { slidesToShow: 3 }
	                }, {
	                    breakpoint: size.tablet,
	                    settings: {
	                        slidesToShow: 4,
	                        vertical: true,
	                        verticalSwiping: true
	                    }
	                }]
	            }));
	        }
	
	        if ($cardPreviewsCompact.length > 0) {
	            $cardPreviewsCompact.slick($.extend({}, slickDefaults.params, {
	                slidesToShow: 4,
	                vertical: true,
	                verticalSwiping: true,
	                responsive: [{
	                    breakpoint: size.desktop,
	                    settings: {
	                        slidesToShow: 4,
	                        vertical: false,
	                        verticalSwiping: false
	                    }
	                }, {
	                    breakpoint: size.tabletBig,
	                    settings: {
	                        slidesToShow: 3,
	                        vertical: false,
	                        verticalSwiping: false
	                    }
	                }, {
	                    breakpoint: size.tablet,
	                    settings: {
	                        slidesToShow: 4,
	                        vertical: true,
	                        verticalSwiping: true
	                    }
	                }]
	            }));
	        }
	    }
	});

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Array$from = __webpack_require__(238)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _loginBySmsLoginBySms = __webpack_require__(443);
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _modulesPreloader = __webpack_require__(120);
	
	var _modulesPreloader2 = _interopRequireDefault(_modulesPreloader);
	
	var _modulesMindboxMindboxOperation = __webpack_require__(453);
	
	var evEmitter = __webpack_require__(448);
	
	var trackers = new _trackerTracker2['default']();
	
	var mbTracker = new _modulesMindboxMindboxOperation.MindboxOperation();
	
	jQuery(function ($) {
	    /**
	     * Добавляет товар в избранное, необходимо передавать data-аттрибут product-id с ИД товара
	     */
	    $('body').on('click', '.js-add-favorite', function (e) {
	        var preload = new _modulesPreloader2['default']();
	        preload.show();
	        var $selectorFavorite = $(this);
	        var priceVal = 0;
	        var productId = $(this).data('product-id');
	
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/action/favorite/add/',
	            data: 'PRODUCT_ID=' + $(this).data('product-id'),
	            success: function success(result) {
	                //Закрашиваем сердечки
	                if (result.code === 200) {
	                    //Для списка товаров
	                    if ($selectorFavorite.hasClass('heart') && $selectorFavorite.hasClass('product__fav')) {
	                        $selectorFavorite.addClass('heart--active');
	                        $selectorFavorite.addClass('product__fav--active');
	                        $selectorFavorite.addClass('js-remove-favorite');
	                        $selectorFavorite.removeClass('js-add-favorite');
	
	                        var productCart = $selectorFavorite.parent();
	                        priceVal = parseInt($(productCart).find('.product__price-value').attr('data-price').replace(' ', ''));
	                    } else {
	                        //Для карточки товара
	                        $('span.heart').addClass('heart--active');
	                        $('span.heart').addClass('js-remove-favorite');
	                        $('span.heart').removeClass('js-add-favorite');
	                        $('.product-card__top span.product-card__fav').removeClass('js-add-favorite');
	                        $('.product-card__top span.product-card__fav').addClass('js-remove-favorite');
	
	                        $('.product-detail__info span.product-card__fav').removeClass('js-add-favorite');
	                        $('.product-detail__info span.product-card__fav').addClass('js-remove-favorite');
	
	                        priceVal = parseInt($('.product-detail__info').find('.product-detail__price-sum').attr('data-price').replace(' ', ''));
	                    }
	                    if (priceVal > 0) {
	                        mbTracker.setWishList();
	                        trackers.onAddToFav({
	                            fbpixel: {
	                                value: parseInt(priceVal)
	                            }
	                        });
	                    }
	
	                    var list = document.getElementsByClassName('breadcrumbs__text');
	
	                    if (!!list.length > 0) {
	                        trackers.onPMbtnFavorite({ param: _Array$from(list).slice(-1)[0].innerHTML });
	                    }
	
	                    evEmitter.emitEvent('addToFavorites');
	                } else if (result.code === 403) {
	                    //Показываем окно авторизации
	                    _loginBySmsLoginBySms.LoginBySms.showPopup();
	                }
	
	                preload.hide();
	            }
	        });
	    });
	
	    /**
	     * Убирает товар из избранного, необходимо передавать data-аттрибут product-id с ИД товара
	     */
	    $('body').on('click', '.js-remove-favorite', function (e) {
	        var preload = new _modulesPreloader2['default']();
	        preload.show();
	
	        var $selectorFavorite = $(this);
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/action/favorite/remove/',
	            data: 'PRODUCT_ID=' + $(this).data('product-id'),
	            success: function success(result) {
	                //Закрашиваем сердечки
	                if (result.code === 200) {
	                    //Для списка товаров
	                    if ($selectorFavorite.hasClass('heart--active') && $selectorFavorite.hasClass('product__fav--active')) {
	                        $selectorFavorite.removeClass('heart--active');
	                        $selectorFavorite.removeClass('product__fav--active');
	                        $selectorFavorite.removeClass('js-remove-favorite');
	                        $selectorFavorite.addClass('js-add-favorite');
	                    } else {
	                        //Для карточки товара
	                        $('span.heart').removeClass('heart--active');
	                        $('span.heart').removeClass('js-remove-favorite');
	                        $('span.heart').addClass('js-add-favorite');
	                        $('.product-card__top span.product-card__fav').addClass('js-add-favorite');
	                        $('.product-card__top span.product-card__fav').removeClass('js-remove-favorite');
	
	                        $('.product-detail__info span.product-card__fav').addClass('js-add-favorite');
	                        $('.product-detail__info span.product-card__fav').removeClass('js-remove-favorite');
	                    }
	                }
	
	                preload.hide();
	            }
	        });
	    });
	});

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	//import {PopupMessage} from '../popup/popup';
	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _toConsumableArray = __webpack_require__(236)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _modulesPreloader = __webpack_require__(120);
	
	var _modulesPreloader2 = _interopRequireDefault(_modulesPreloader);
	
	var _modulesFunctions = __webpack_require__(166);
	
	var _modulesFunctions2 = _interopRequireDefault(_modulesFunctions);
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _modulesMd5 = __webpack_require__(444);
	
	var _modulesMd52 = _interopRequireDefault(_modulesMd5);
	
	var _modulesMindboxMindboxTracker = __webpack_require__(445);
	
	var _modulesTrackerRetailrocket = __webpack_require__(446);
	
	var _modulesYandexSmartCaptchaYandexSmartCaptcha = __webpack_require__(299);
	
	__webpack_require__(300);
	
	var autoComplete = __webpack_require__(447);
	var styleSelects = __webpack_require__(309);
	
	/**
	 *  Класс для работы авторизации/регистрации по смс
	 */
	
	var LoginBySms = (function () {
	    function LoginBySms() {
	        _classCallCheck(this, LoginBySms);
	
	        this.loader = new _modulesPreloader2['default']();
	        this.isInit = false;
	        this.timeReset = 60;
	        this.timerId = null;
	        this.retailRocket = new _modulesTrackerRetailrocket.RetailRocket();
	        this.mindboxTracker = new _modulesMindboxMindboxTracker.MindboxTracker();
	        /**
	         * Вот эта переменная нужна чтобы не отправлять запрос
	         * на проверку кода и авторизацию после ввода 4 символов
	         * @type {boolean}
	         */
	        this.isSendLoginBySmsQuery = false;
	    }
	
	    /**
	     *  Подтягивает контент для формы и показывает окно авторизации
	     */
	
	    _createClass(LoginBySms, [{
	        key: 'initElements',
	
	        //PopupMessage.show(result.html);
	
	        /**
	         * Инициализация элементов DOM
	         * @param jqActionLink
	         */
	        value: function initElements(jqActionLink) {
	            if (this.isInit) {
	                return;
	            }
	
	            var _self = this;
	            this.isInit = true;
	            this.jqActionLink = jqActionLink;
	            this.loginMainContainer = jqActionLink.parents('.js-login-by-sms-main-container');
	            this.recoveryMainContainer = this.loginMainContainer.next();
	
	            this.jqMode = this.loginMainContainer.find('.js-mode');
	            this.jqTestSmsCode = this.loginMainContainer.find('.js-test-code');
	
	            this.jqInputPhoneNumber = this.loginMainContainer.find('.js-phone');
	
	            this.jqInputNameContainer = this.loginMainContainer.find('.js-name-container');
	            this.jqInputName = this.jqInputNameContainer.find('input');
	
	            this.jqInputLastNameContainer = this.loginMainContainer.find('.js-last-name-container');
	            this.jqInputLastName = this.jqInputLastNameContainer.find('input');
	
	            this.jqInputEmailContainer = this.loginMainContainer.find('.js-email-container');
	            this.jqInputEmail = this.jqInputEmailContainer.find('input');
	
	            this.jqInputLocationContainer = this.loginMainContainer.find('.js-last-location-container');
	            this.jqInputLocation = this.jqInputLocationContainer.find('input');
	
	            this.jqSelectUserTypeContainer = this.loginMainContainer.find('.js-last-user-type-container');
	            this.jqSelectUserType = this.jqSelectUserTypeContainer.find('select');
	
	            this.jqCodeContainer = this.loginMainContainer.find('.js-code-container');
	            this.jqCodeContainerTimerText = this.loginMainContainer.find('.js-code-timer-text-container');
	
	            this.jqTimer = this.loginMainContainer.find('.js-timer');
	
	            this.jqInputSmsCode = this.jqCodeContainer.find('input');
	
	            this.jqErrorContainer = this.loginMainContainer.find('.js-error-container');
	            this.jqSmartCaptchaToken = this.loginMainContainer.find('[name="smart-token"]');
	
	            this.token = (0, _modulesMd52['default'])([].concat(_toConsumableArray(this.loginMainContainer.find('.js-token').val())).reverse().join(''));
	
	            /**
	             * Если это форма заказ в 1 клик
	             * @type {boolean}
	             */
	            this.isOneClick = this.loginMainContainer.find('.js-onle-click').val() === 'Y';
	            this.productId = this.loginMainContainer.find('.js-onle-click-product').val();
	
	            /**
	             *  Вот это событие для вставки кода смс на мобиле
	             */
	            this.jqInputSmsCode.on('input', function (e) {
	                var code = $(this).val();
	                if (code.length === 4) {
	                    if (_self.isSendLoginBySmsQuery === true) {
	                        return;
	                    }
	
	                    var phoneNumber = $.trim(_self.jqInputPhoneNumber.val());
	                    _self.login(phoneNumber, code);
	                    event.preventDefault();
	                }
	            });
	
	            this.jqInputSmsCode.on('keydown', function (event) {
	                _self.hideErrorInput($(this));
	
	                // Разрешаем: backspace, delete, tab и escape
	                if (event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 27 ||
	                // Разрешаем: Ctrl+A
	                event.keyCode === 65 && event.ctrlKey === true ||
	                /*(event.keyCode === 86 && event.ctrlKey === true) ||*/
	                // Разрешаем: home, end, влево, вправо
	                event.keyCode >= 35 && event.keyCode <= 39) {
	                    // Ничего не делаем
	                    return;
	                } else {
	                    var code = $(this).val();
	                    if (code.length === 4) {
	                        event.preventDefault();
	                        return;
	                    }
	
	                    // Запрещаем все, кроме цифр на основной клавиатуре, а так же Num-клавиатуре
	                    if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
	                        event.preventDefault();
	                    }
	                }
	            });
	
	            this.jqInputSmsCode.on('keyup', function () {
	                if (event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 27 ||
	                // Разрешаем: Ctrl+A
	                event.keyCode === 65 && event.ctrlKey === true || event.keyCode === 86 && event.ctrlKey === true ||
	                // Разрешаем: home, end, влево, вправо
	                event.keyCode >= 35 && event.keyCode <= 39) {
	                    // Ничего не делаем
	                    return;
	                }
	
	                var code = $(this).val();
	
	                if (code.length === 4) {
	                    if (_self.isSendLoginBySmsQuery === true) {
	                        return;
	                    }
	
	                    var phoneNumber = $.trim(_self.jqInputPhoneNumber.val());
	                    _self.login(phoneNumber, code);
	                }
	            });
	        }
	
	        /**
	         * Запрос смс кода
	         * @param jqActionLink
	         */
	    }, {
	        key: 'getSmsCode',
	        value: function getSmsCode(jqActionLink) {
	            this.initElements(jqActionLink);
	
	            var _self = this;
	
	            var captchaToken = this.jqSmartCaptchaToken.val();
	            var phoneNumber = $.trim(this.jqInputPhoneNumber.val());
	            if (phoneNumber.length === 0) {
	                return;
	            }
	
	            var mode = this.jqMode.val();
	
	            var ajaxPath = undefined,
	                dataParams = undefined;
	            if (mode === 'AUT') {
	                // https://www.smartbuy.ru/ajax/action/basket_add_popup/get_data_layer/
	                //ajaxPath = '/ajax/action/maximaster:widget.login.by.sms/get_sms_code/';
	                ajaxPath = '/ajax/action/widget_login_by_sms/get_sms_code/';
	                dataParams = {
	                    phone: phoneNumber,
	                    isOneClick: _self.isOneClick ? 'Y' : 'N',
	                    _t: _self.token,
	                    captcha_token: captchaToken
	                };
	            }
	
	            if (mode === 'REGISTER') {
	                //ajaxPath = '/ajax/action/maximaster:widget.login.by.sms/registration/';
	                ajaxPath = '/ajax/action/widget_login_by_sms/registration/';
	                dataParams = {
	                    phone: phoneNumber,
	                    name: $.trim(this.jqInputName.val()),
	                    last_name: $.trim(this.jqInputLastName.val()),
	                    email: $.trim(this.jqInputEmail.val()),
	                    location: $.trim(this.jqInputLocation.val()),
	                    userType: $.trim(this.jqSelectUserType.val()),
	                    isOneClick: _self.isOneClick ? 'Y' : 'N',
	                    _t: _self.token,
	                    captcha_token: captchaToken
	                };
	            }
	
	            this.loader.show();
	
	            $.ajax({
	                url: ajaxPath,
	                type: 'POST',
	                data: dataParams,
	                success: function success(result) {
	                    _self.loader.hide();
	
	                    _self.jqErrorContainer.empty();
	                    _self.hideErrorInput(_self.jqInputName);
	                    _self.hideErrorInput(_self.jqInputLastName);
	                    _self.hideErrorInput(_self.jqInputEmail);
	                    _self.hideErrorInput(_self.jqInputLocation);
	
	                    var data = result.data;
	                    if (result.code === 400 && data['captcha_validation'] === false) {
	                        alert('Не пройдена защита от спама, пожалуйста отметьте что вы не робот!');
	                        return;
	                    }
	                    if (result.code === 401) {
	                        /**
	                         *  Если при попытке регистрации возникли ошиьки
	                         *  показываем их
	                         */
	                        if (data.mode === 'RIGISTR_ERROR_FIELDS') {
	                            var errors = data.errors;
	                            var count = errors.length;
	                            if (count > 0) {
	                                for (var i = 0; i < count; i++) {
	                                    if (errors[i].TYPE === 'INPUT_NAME_ERROR') {
	                                        _self.showErrorInput(_self.jqInputName);
	                                    }
	
	                                    if (errors[i].TYPE === 'INPUT_LAST_NAME_ERROR') {
	                                        _self.showErrorInput(_self.jqInputLastName);
	                                    }
	
	                                    if (errors[i].TYPE === 'INPUT_EMAIL') {
	                                        _self.showErrorInput(_self.jqInputEmail);
	                                    }
	
	                                    if (errors[i].TYPE === 'INPUT_LOCATION') {
	                                        _self.showErrorInput(_self.jqInputLocation);
	                                    }
	
	                                    if (errors[i].TYPE === 'ERROR_EMAIL_ACCOUNT') {
	                                        _self.jqErrorContainer.html(errors[i].TEXT);
	                                    }
	                                }
	                            }
	
	                            return;
	                        }
	
	                        _self.jqErrorContainer.html(data.error);
	                        new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('aut_reg_smart_captcha').init();
	                        return;
	                    }
	
	                    var mode = result.data.mode;
	                    switch (mode) {
	                        /**
	                         *  Пользователь существует, ждем ввод кода СМС
	                         */
	                        case 'SET_SMS_CODE':
	                            _self.jqCodeContainer.show();
	                            _self.jqInputSmsCode.focus();
	                            _self.jqCodeContainerTimerText.show();
	                            _self.jqInputPhoneNumber.prop('disabled', true);
	                            _self.jqActionLink.addClass('button--disable-login').attr('data-disabled', 'Y');
	                            _self.timerSecond(_self.timeReset, 'aut');
	
	                            new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('aut_reg_smart_captcha').hide();
	                            /**
	                             *  @todo убрать на проде
	                             */
	                            //_self.jqTestSmsCode.val(result.data.code);
	
	                            break;
	
	                        /**
	                         *  Если в ответе пришла метка на регистрацию
	                         *  показываем дополнительные поля и устанавливем типа
	                         *  следущего запроса  REGISTER
	                         */
	                        case 'SHOW_REGISTER_FIELDS':
	                            _self.jqInputPhoneNumber.prop('disabled', true);
	                            _self.jqInputNameContainer.show();
	                            _self.jqInputLastNameContainer.show();
	                            _self.jqInputEmailContainer.show();
	                            _self.jqInputLocationContainer.show();
	                            _self.jqSelectUserTypeContainer.show();
	                            _self.jqMode.val('REGISTER');
	                            styleSelects.styleSelects($('.js-styled-select'));
	                            //window.beautyShopTracker.registerPageViewed();
	
	                            break;
	
	                        case 'REGISTER_RESULT':
	                            _self.jqCodeContainer.show();
	                            _self.jqCodeContainerTimerText.show();
	                            _self.jqInputName.prop('disabled', true);
	                            _self.jqInputLastName.prop('disabled', true);
	                            _self.jqInputEmail.prop('disabled', true);
	                            _self.jqInputPhoneNumber.prop('disabled', true);
	                            _self.jqInputLocation.prop('disabled', true);
	                            _self.jqSelectUserType.prop('disabled', true);
	
	                            _self.jqActionLink.addClass('button--disable-login').attr('data-disabled', 'Y');
	
	                            _self.timerSecond(_self.timeReset, 'reg');
	                            new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('aut_reg_smart_captcha').hide();
	                            /**
	                             *  @todo убрать на проде
	                             */
	                            //_self.jqTestSmsCode.val(result.data.code);
	
	                            break;
	                    }
	                    // Делаем заново инициализацию
	                    new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('aut_reg_smart_captcha').init();
	                }
	            });
	        }
	
	        /**
	         * Заказ в один клик
	         * @param data
	         */
	    }, {
	        key: 'orderOneClick',
	        value: function orderOneClick(data) {
	            $.ajax({
	                //url: '/ajax/action/maximaster:widget.order/ajaxOneClickLoginBySms/',
	                //url: '/ajax/action/widget_order/ajaxOneClickLoginBySms/',
	                url: '/ajax/action/order_oneclick/buy/',
	                type: 'POST',
	                data: data,
	                success: function success(result) {
	                    if (result.data['SUCCESS']) {
	                        //window.beautyShopTracker.orderPageOneClickOrderButtonClicked();
	                        //window.beautyShopTracker.subscriptionPopupForms(data.EMAIL);
	                        window.location.href = result.data['ORDER_PAGE'];
	                    } else {
	                        alert(result.data['ERROR']);
	                    }
	                }
	            });
	        }
	
	        /**
	         * Авторизация после получения кода
	         * @param phoneNumber
	         * @param code
	         */
	    }, {
	        key: 'login',
	        value: function login(phoneNumber, code) {
	            var _self = this;
	
	            _self.loader.show();
	            //clearTimeout(this.timerId);
	
	            _self.isSendLoginBySmsQuery = true;
	
	            $.ajax({
	                //url: '/ajax/action/maximaster:widget.login.by.sms/login/',
	                url: '/ajax/action/widget_login_by_sms/login/',
	                type: 'POST',
	                data: {
	                    code: code,
	                    phoneNumber: phoneNumber
	                },
	                success: function success(result) {
	                    console.log('phone' + result.data.PHONE);
	                    _self.isSendLoginBySmsQuery = false;
	                    var action = result.data.ACTION || '';
	
	                    var trackers = new _trackerTracker2['default']();
	
	                    if (result.code === 200) {
	                        if (_self.isOneClick) {
	                            var oneClickData = result.data;
	                            var productsParams = [];
	                            productsParams.push({ id: parseInt(_self.productId), quantity: 1 });
	
	                            oneClickData.products = productsParams;
	
	                            _self.orderOneClick(oneClickData);
	                            return;
	                        }
	
	                        if (action === 'AUT') {
	                            _self.retailRocket.setCustomer({
	                                authorized: true,
	                                user_id: String(result.data.USER_ID),
	                                email: result.data.EMAIL,
	                                phone_format: result.data.PHONE
	                            });
	                            location.reload();
	                        }
	
	                        if (action === 'REG') {
	                            window.LoginBySms.accesRegister();
	                            _self.retailRocket.setCustomer({
	                                authorized: true,
	                                user_id: String(result.data.USER_ID),
	                                email: result.data.EMAIL,
	                                phone_format: result.data.PHONE
	                            });
	                            // trackers.getTracker('gtm').pushEvent('completeRegistration');
	                            //location.reload();
	                            /*_self.loader.hide();*/
	                            /* $('.js-login-by-sms-main-container, .form__footnote').fadeOut(function() {
	                                $('.js-login-by-sms-register-done').fadeIn();
	                            });*/
	                        }
	                        _modulesFunctions2['default'].setCookie('BITRIX_SM_is_aut', 'Y', { expires: 604800, path: '/' });
	                        _self.mindboxTracker.authorization(result.data.PHONE);
	                        trackers.userAuthorized(result.data);
	                    }
	
	                    if (result.code === 400) {
	                        _self.showErrorInput(_self.jqInputSmsCode);
	                        _self.loader.hide();
	                        return;
	                    }
	
	                    if (result.code === 500) {
	                        alert('Ошибка, попробуйте позже, мы уже занимаемся устранением проблемы.');
	                        _self.loader.hide();
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'showErrorInput',
	        value: function showErrorInput(jqInput) {
	            jqInput.parent().prev().show();
	            jqInput.addClass('form__input--error');
	        }
	    }, {
	        key: 'hideErrorInput',
	        value: function hideErrorInput(jqInput) {
	            jqInput.parent().prev().hide();
	            jqInput.removeClass('form__input--error');
	        }
	
	        /**
	         * Таймер для вывода счетчика
	         * @param count - кол-во сек
	         * @param mode - для авторизации и для регистрации
	         */
	    }, {
	        key: 'timerSecond',
	        value: function timerSecond(count, mode) {
	            var _this = this;
	
	            if (count > 0) {
	                (function () {
	                    var _self = _this;
	                    _this.jqTimer.text(count + _this.declOfNum(count, [' секунда', ' секунды', ' секунд']));
	                    _this.timerId = setTimeout(function () {
	                        _self.timerSecond(count - 1, mode);
	                    }, 1000);
	                })();
	            } else {
	                if (mode === 'aut') {
	                    this.resetAutFields();
	                }
	
	                if (mode === 'reg') {
	                    this.resetRegFields();
	                }
	            }
	        }
	    }, {
	        key: 'declOfNum',
	        value: function declOfNum(number, titles) {
	            var cases = [2, 0, 1, 1, 1, 2];
	            return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
	        }
	    }, {
	        key: 'resetAutFields',
	        value: function resetAutFields() {
	            this.jqCodeContainerTimerText.hide();
	            this.jqActionLink.removeClass('button--disable-login').attr('data-disabled', 'N');
	            this.jqInputPhoneNumber.prop('disabled', false);
	
	            // если не ввели смс показываем еще раз
	            var yandexSmartCaptcha = new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('aut_reg_smart_captcha');
	            yandexSmartCaptcha.init();
	            yandexSmartCaptcha.show();
	        }
	    }, {
	        key: 'resetRegFields',
	        value: function resetRegFields() {
	            this.jqCodeContainerTimerText.hide();
	            this.jqActionLink.removeClass('button--disable-login').attr('data-disabled', 'N');
	        }
	    }, {
	        key: 'getHtmlRecoveryByEmail',
	        value: function getHtmlRecoveryByEmail() {
	            var _self = this;
	
	            $.ajax({
	                url: '/ajax/action/widget_login_by_sms/get_html_recovery_by_email/',
	                type: 'GET',
	                data: {
	                    email: this.jqInputEmail.val()
	                },
	                success: function success(result) {
	                    _self.loginMainContainer.hide();
	                    _self.recoveryMainContainer.show().html(result.html);
	                }
	            });
	        }
	
	        /**
	         *  Подтягивает контент для формы и показывает окно авторизации
	         */
	    }, {
	        key: 'accesRegister',
	        value: function accesRegister() {
	            var _self = this;
	            $.ajax({
	                url: '/ajax/component/maximaster:widget.login.by.sms/reg_done/',
	                type: 'GET',
	                success: function success(result) {
	                    _self.loader.hide();
	                    $.prompt(result.html);
	                }
	            });
	        }
	    }, {
	        key: 'showFormLoginBySms',
	        value: function showFormLoginBySms() {
	            this.loginMainContainer.show();
	            this.recoveryMainContainer.hide().empty();
	        }
	    }, {
	        key: 'sendRecoveryEmail',
	        value: function sendRecoveryEmail() {
	            var email = this.recoveryMainContainer.find('.js-email ').val();
	
	            var _self = this;
	
	            this.loader.show();
	
	            $.ajax({
	                url: '/ajax/action/widget_login_by_sms/send_email_for_recovery/',
	                type: 'GET',
	                data: {
	                    email: email
	                },
	                /*data: {
	                    email: this.jqInputEmail.val()
	                },*/
	                success: function success(result) {
	                    _self.loader.hide();
	
	                    if (result.code === 401) {
	                        alert('Ошибка, попробуйте позже');
	                        return;
	                    }
	
	                    if (result.code === 200) {
	                        _self.recoveryMainContainer.find('.js-recovery-form-fields-container').hide();
	                        _self.recoveryMainContainer.find('.js-recovery-result-container').show();
	                    }
	                    //_self.loginMainContainer.hide();
	                    //_self.recoveryMainContainer.show().html(result.html);
	                }
	            });
	        }
	    }, {
	        key: 'checkedApproval',
	        value: function checkedApproval(element) {
	            var isChecked = $(element).is(':checked');
	            $('.js-login-by-sms-action-link').attr('data-disabled', isChecked ? 'N' : 'Y');
	        }
	    }], [{
	        key: 'showPopup',
	        value: function showPopup() {
	            var isOneClick = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	            var productId = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	            $.ajax({
	                url: '/ajax/component/maximaster:widget.login.by.sms.popup/',
	                type: 'GET',
	                data: {
	                    isOneClick: isOneClick ? 'Y' : 'N',
	                    productId: productId
	                },
	                success: function success(result) {
	                    $.prompt(result.html);
	                    new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('aut_reg_smart_captcha').init();
	                }
	            });
	        }
	    }]);
	
	    return LoginBySms;
	})();
	
	exports.LoginBySms = LoginBySms;
	
	jQuery(function () {
	    window.LoginBySms = new LoginBySms();
	    new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('aut_reg_smart_captcha').init();
	    /**
	     *  Нажимая кнопку, вы подтверждаете, что ознакомлены и согласны
	     */
	    $(document).on('change', '.js-callback-approval', function () {
	        window.LoginBySms.checkedApproval(this);
	    });
	
	    /**
	     *  Открытие окна с формой авторизации
	     */
	    $(document).on('click', '.js-login-by-sms-show-popup', function () {
	        LoginBySms.showPopup();
	        window.LoginBySms = new LoginBySms();
	    });
	
	    /**
	     *  Отправка запроса на отправку смс
	     */
	    $(document).on('click', '.js-login-by-sms-action-link', function (e) {
	        e.preventDefault();
	        var isDisabled = $(this).attr('data-disabled') === 'Y';
	        if (isDisabled) {
	            return;
	        }
	        window.LoginBySms.getSmsCode($(this));
	    });
	
	    /**
	     *  Показ формы для запроса восстановления пароля
	     */
	    $(document).on('click', '.js-recovery-by-email-link', function () {
	        window.LoginBySms.getHtmlRecoveryByEmail();
	        return false;
	    });
	
	    /**
	     *  Переход к форме авторизации
	     */
	    $(document).on('click', '.js-show-login-by-sms-form', function () {
	        window.LoginBySms.showFormLoginBySms();
	        return false;
	    });
	
	    /**
	     *  Отправка сообщения на воссатновление аккаунта
	     */
	    $(document).on('click', '.js-send-recovery-email-link', function () {
	        window.LoginBySms.sendRecoveryEmail();
	        return false;
	    });
	
	    $(document).on('click', '.js-one-click-aut', function () {
	        var productId = $(this).attr('data-product-id');
	        LoginBySms.showPopup(true, productId);
	        window.LoginBySms = new LoginBySms();
	        return false;
	    });
	
	    /**
	     * Это нужно чтобы после авторизации и загрузки страницы выполнить метод
	     * userAuthorizedMain
	     */
	    var isAfterAut = _modulesFunctions2['default'].getCookie('BITRIX_SM_is_aut') === 'Y';
	    if (isAfterAut) {
	        //window.beautyShopTracker.userAuthorizedMain({});
	        _modulesFunctions2['default'].deleteCookie('BITRIX_SM_is_aut');
	    }
	
	    $(document).on('focus', '.js-autocomplete', function () {
	        autoComplete.setAutocomplete($('.js-autocomplete'));
	    });
	
	    $(document).on('click', '.jqiclose', function () {
	        location.reload();
	    });
	});

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = md5;
	function M(d) {
	    for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++) _ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _);
	    return f;
	}
	
	function X(d) {
	    for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++) _[m] = 0;
	    for (m = 0; m < 8 * d.length; m += 8) _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32;
	    return _;
	}
	
	function V(d) {
	    for (var _ = "", m = 0; m < 32 * d.length; m += 8) _ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
	    return _;
	}
	
	function Y(d, _) {
	    d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _;
	    for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
	        var h = m,
	            t = f,
	            g = r,
	            e = i;
	        f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e);
	    }
	    return Array(m, f, r, i);
	}
	
	function md5_cmn(d, _, m, f, r, i) {
	    return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m);
	}
	
	function md5_ff(d, _, m, f, r, i, n) {
	    return md5_cmn(_ & m | ~_ & f, d, _, r, i, n);
	}
	
	function md5_gg(d, _, m, f, r, i, n) {
	    return md5_cmn(_ & f | m & ~f, d, _, r, i, n);
	}
	
	function md5_hh(d, _, m, f, r, i, n) {
	    return md5_cmn(_ ^ m ^ f, d, _, r, i, n);
	}
	
	function md5_ii(d, _, m, f, r, i, n) {
	    return md5_cmn(m ^ (_ | ~f), d, _, r, i, n);
	}
	
	function safe_add(d, _) {
	    var m = (65535 & d) + (65535 & _);
	    return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m;
	}
	
	function bit_rol(d, _) {
	    return d << _ | d >>> 32 - _;
	}
	
	function md5(d) {
	    d = unescape(encodeURIComponent(d));
	    var result = M(V(Y(X(d), 8 * d.length)));
	    return result.toLowerCase();
	}
	
	;
	module.exports = exports["default"];

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var MindboxTracker = (function () {
	    function MindboxTracker() {
	        _classCallCheck(this, MindboxTracker);
	    }
	
	    _createClass(MindboxTracker, [{
	        key: 'operationSend',
	        value: function operationSend(operation, data) {
	            window.mindbox('async', {
	                operation: operation,
	                data: data,
	
	                onSuccess: function onSuccess() {
	                    console.info('OK MindboxTracker ' + operation + ': %o', data);
	                },
	                onError: function onError(error) {
	                    console.error('ERROR MindboxTracker: ' + operation + ' ' + error);
	                }
	            });
	        }
	
	        /**
	         * Трекер раздела товаров+
	         * @param category
	         */
	    }, {
	        key: 'categoryView',
	        value: function categoryView(category) {
	            this.operationSend('CategoryView', {
	                viewProductCategory: {
	                    productCategory: {
	                        ids: {
	                            smartBuy: category.id
	                        }
	                    }
	                }
	            });
	        }
	
	        /**
	         * Трекер детальной страницы товара+
	         * @param product
	         */
	    }, {
	        key: 'productView',
	        value: function productView(product) {
	            this.operationSend('ProductView', {
	                viewProduct: {
	                    price: product.price,
	                    product: {
	                        ids: {
	                            smartBuy: product.vendorCode
	                        }
	                    }
	                }
	            });
	        }
	
	        /**
	         * Трекер добавления товара в корзину-
	         * @param basketData
	         */
	    }, {
	        key: 'setCart',
	        value: function setCart(basketData) {
	            this.operationSend('SetCart', basketData);
	        }
	
	        /**
	         * Трекер добавления товара в избранное+
	         * @param productsData
	         */
	    }, {
	        key: 'setWishList',
	        value: function setWishList(productsData) {
	            this.operationSend('SetWishList', productsData);
	        }
	
	        /**
	         * Трекер авторизации пользователя+
	         * @param phone
	         */
	    }, {
	        key: 'authorization',
	        value: function authorization(phone) {
	            this.operationSend('Authorization', {
	                customer: {
	                    mobilePhone: phone
	                }
	            });
	        }
	    }]);
	
	    return MindboxTracker;
	})();

	exports.MindboxTracker = MindboxTracker;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var RetailRocket = (function () {
	    function RetailRocket() {
	        _classCallCheck(this, RetailRocket);
	    }
	
	    _createClass(RetailRocket, [{
	        key: 'track',
	        value: function track(callback) {
	            (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function () {
	                try {
	                    callback();
	                } catch (e) {
	                    if (false) {
	                        console.log(e);
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'viewContentProduct',
	        value: function viewContentProduct(product) {
	            if (!product) {
	                return;
	            }
	
	            var callback = undefined;
	            if (product.is_offers) {
	                callback = function () {
	                    rrApi.groupView(product.offers_id);
	                };
	            } else {
	                callback = function () {
	                    rrApi.view(product.id);
	                };
	            }
	
	            this.track(callback);
	        }
	    }, {
	        key: 'viewContentCategory',
	        value: function viewContentCategory(category) {
	            if (!category) {
	                return;
	            }
	
	            this.track(function () {
	                rrApi.categoryView(category.id);
	            });
	        }
	    }, {
	        key: 'setProfile',
	        value: function setProfile(params) {
	            if (!params) {
	                return;
	            }
	
	            this.track(function () {
	                rrApi.setProfile(params);
	            });
	        }
	    }, {
	        key: 'setCustomer',
	        value: function setCustomer(user) {
	            if (!user.authorized) {
	                return;
	            }
	
	            var phone = '7' + user['phone'];
	            if (user.phone_format) {
	                phone = user.phone_format;
	            }
	
	            this.track(function () {
	                rrApi.setCustomer({
	                    customerId: user['user_id'],
	                    email: user['email'],
	                    phone: phone
	                });
	            });
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            this.track(function () {
	                rrApi.search('search_phrase');
	            });
	        }
	
	        /*
	        subscription(email) {
	            this.track(function() {
	                rrApi.setEmail(email);
	                rrApi.welcomeSequence(email);
	            });
	        }
	           subscriptionPopup(email) {
	            this.track(function() {
	                rrApi.setEmail(email, {EmailPopUp: true});
	                rrApi.welcomeSequence(email);
	            });
	        }
	           oneClick(productId) {
	            this.track(function() {
	                rrApi.addToBasket(productId);
	            });
	        }
	        */
	
	    }, {
	        key: 'addToCart',
	        value: function addToCart(product) {
	            this.track(function () {
	                rrApi.addToBasket(product.id);
	            });
	        }
	    }, {
	        key: 'orderTransaction',
	        value: function orderTransaction(order, basket) {
	            var params = {
	                transaction: order.id,
	                items: this.formatBasket(basket)
	            };
	            this.track(function () {
	                rrApi.order(params);
	            });
	        }
	
	        /*
	        productAddToFavorite(params) {
	            this.track(function() {
	                rrApi.subscribeonpricedrop(params.email, [params.product]);
	            });
	        }
	        */
	
	    }, {
	        key: 'formatBasket',
	        value: function formatBasket(basket) {
	            return basket.map(function (basketItem) {
	                return RetailRocket.formatBasketItem(basketItem);
	            });
	        }
	    }], [{
	        key: 'formatBasketItem',
	        value: function formatBasketItem(basketItem) {
	            return {
	                id: basketItem.offer_id || basketItem.id,
	                qnt: parseFloat(basketItem.quantity),
	                price: parseFloat(basketItem.price)
	            };
	        }
	    }]);
	
	    return RetailRocket;
	})();

	exports.RetailRocket = RetailRocket;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(133)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	/**
	 * @type EvEmitter
	 */
	
	var _modulesEvents = __webpack_require__(448);
	
	var _modulesEvents2 = _interopRequireDefault(_modulesEvents);
	
	__webpack_require__(450);
	__webpack_require__(451);
	__webpack_require__(312);
	
	jQuery(function () {
	    var autocompleteParams = {
	        cities: {
	            lookup: [] // deprecated
	        },
	        location: {
	            lookup: function lookup(query, done) {
	                $.post('/ajax/action/location/search/', {
	                    query: query
	                }, function (result) {
	                    var items = {
	                        suggestions: []
	                    };
	                    if (result.message == 'ok') {
	                        result.data.forEach(function (item) {
	                            items.suggestions.push({
	                                data: item,
	                                value: item.name
	                            });
	                        });
	                    }
	                    done(items);
	                });
	            },
	            onSelect: function onSelect(suggestion) {
	                suggestion.data.element = this;
	                _modulesEvents2['default'].emitEvent('setLocation', [suggestion.data]);
	            },
	            triggerSelectOnValidInput: false,
	            minChars: 3,
	            showNoSuggestionNotice: true,
	            noSuggestionNotice: 'Город не найден'
	        }
	    };
	
	    var setAutocomplete = function setAutocomplete($items) {
	        $items.each(function () {
	            var $this = $(this);
	
	            var lookupParam = $this.data('autocompelte-source');
	
	            var options = {
	                minChars: 1,
	                additionalContainerClass: '.mCSB_container',
	                appendTo: $this.parent(),
	                onSearchComplete: function onSearchComplete() {
	                    $('.autocomplete-suggestions').mCustomScrollbar({
	                        axis: 'y',
	                        scrollbarPosition: 'inside',
	                        advanced: {
	                            updateOnContentResize: true
	                        },
	                        live: true
	                    });
	                }
	            };
	
	            // isObject http://stackoverflow.com/a/14706877
	            if (autocompleteParams[lookupParam] === Object(autocompleteParams[lookupParam])) {
	                options = _Object$assign({}, options, autocompleteParams[lookupParam]);
	            }
	
	            $this.autocomplete(options);
	        });
	    };
	
	    setAutocomplete($('.js-autocomplete'));
	
	    module.exports.setAutocomplete = setAutocomplete;
	});

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var eventEmitter = __webpack_require__(449);
	
	var events = new eventEmitter();
	
	if (false) {
	    (function () {
	        var called = 'Event called: ';
	        /**
	         * Событие на смену местоположения
	         *
	         * @param data
	         * @param data.id Код местоположения (Bitrix Местоположения 2.0)
	         * @param data.name Название местоположения
	         * @param data.element Node текущего элемента
	         */
	        events.on('setLocation', function (data) {
	            console.log(called + 'setLocation, ', data);
	        });
	    })();
	}
	
	exports['default'] = events;
	module.exports = exports['default'];

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * EvEmitter v1.0.3
	 * Lil' event emitter
	 * MIT License
	 */
	
	/* jshint unused: true, undef: true, strict: true */
	
	( function( global, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, window */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.EvEmitter = factory();
	  }
	
	}( typeof window != 'undefined' ? window : this, function() {
	
	"use strict";
	
	function EvEmitter() {}
	
	var proto = EvEmitter.prototype;
	
	proto.on = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // set events hash
	  var events = this._events = this._events || {};
	  // set listeners array
	  var listeners = events[ eventName ] = events[ eventName ] || [];
	  // only add once
	  if ( listeners.indexOf( listener ) == -1 ) {
	    listeners.push( listener );
	  }
	
	  return this;
	};
	
	proto.once = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // add event
	  this.on( eventName, listener );
	  // set once flag
	  // set onceEvents hash
	  var onceEvents = this._onceEvents = this._onceEvents || {};
	  // set onceListeners object
	  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
	  // set flag
	  onceListeners[ listener ] = true;
	
	  return this;
	};
	
	proto.off = function( eventName, listener ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var index = listeners.indexOf( listener );
	  if ( index != -1 ) {
	    listeners.splice( index, 1 );
	  }
	
	  return this;
	};
	
	proto.emitEvent = function( eventName, args ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var i = 0;
	  var listener = listeners[i];
	  args = args || [];
	  // once stuff
	  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
	
	  while ( listener ) {
	    var isOnce = onceListeners && onceListeners[ listener ];
	    if ( isOnce ) {
	      // remove listener
	      // remove before trigger to prevent recursion
	      this.off( eventName, listener );
	      // unset once flag
	      delete onceListeners[ listener ];
	    }
	    // trigger listener
	    listener.apply( this, args );
	    // get next listener
	    i += isOnce ? 0 : 1;
	    listener = listeners[i];
	  }
	
	  return this;
	};
	
	return EvEmitter;
	
	}));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	*  Ajax Autocomplete for jQuery, version 1.2.24
	*  (c) 2015 Tomas Kirda
	*
	*  Ajax Autocomplete for jQuery is freely distributable under the terms of an MIT-style license.
	*  For details, see the web site: https://github.com/devbridge/jQuery-Autocomplete
	*/
	
	/*jslint  browser: true, white: true, plusplus: true, vars: true */
	/*global define, window, document, jQuery, exports, require */
	
	// Expose plugin as an AMD module if AMD loader is present:
	(function (factory) {
	    'use strict';
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(124)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object' && typeof require === 'function') {
	        // Browserify
	        factory(require('jquery'));
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	}(function ($) {
	    'use strict';
	
	    var
	        utils = (function () {
	            return {
	                escapeRegExChars: function (value) {
	                    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	                },
	                createNode: function (containerClass) {
	                    var div = document.createElement('div');
	                    div.className = containerClass;
	                    div.style.position = 'absolute';
	                    div.style.display = 'none';
	                    return div;
	                }
	            };
	        }()),
	
	        keys = {
	            ESC: 27,
	            TAB: 9,
	            RETURN: 13,
	            LEFT: 37,
	            UP: 38,
	            RIGHT: 39,
	            DOWN: 40
	        };
	
	    function Autocomplete(el, options) {
	        var noop = function () { },
	            that = this,
	            defaults = {
	                ajaxSettings: {},
	                autoSelectFirst: false,
	                appendTo: document.body,
	                serviceUrl: null,
	                lookup: null,
	                onSelect: null,
	                width: 'auto',
	                minChars: 1,
	                maxHeight: 300,
	                deferRequestBy: 0,
	                params: {},
	                formatResult: Autocomplete.formatResult,
	                delimiter: null,
	                zIndex: 9999,
	                type: 'GET',
	                noCache: false,
	                onSearchStart: noop,
	                onSearchComplete: noop,
	                onSearchError: noop,
	                preserveInput: false,
	                containerClass: 'autocomplete-suggestions',
	                tabDisabled: false,
	                dataType: 'text',
	                currentRequest: null,
	                triggerSelectOnValidInput: true,
	                preventBadQueries: true,
	                lookupFilter: function (suggestion, originalQuery, queryLowerCase) {
	                    return suggestion.value.toLowerCase().indexOf(queryLowerCase) !== -1;
	                },
	                paramName: 'query',
	                transformResult: function (response) {
	                    return typeof response === 'string' ? $.parseJSON(response) : response;
	                },
	                showNoSuggestionNotice: false,
	                noSuggestionNotice: 'No results',
	                orientation: 'bottom',
	                forceFixPosition: false,
	                additionalContainerClass: ''
	            };
	
	        // Shared variables:
	        that.element = el;
	        that.el = $(el);
	        that.suggestions = [];
	        that.badQueries = [];
	        that.selectedIndex = -1;
	        that.currentValue = that.element.value;
	        that.intervalId = 0;
	        that.cachedResponse = {};
	        that.onChangeInterval = null;
	        that.onChange = null;
	        that.isLocal = false;
	        that.suggestionsContainer = null;
	        that.noSuggestionsContainer = null;
	        that.options = $.extend({}, defaults, options);
	        that.classes = {
	            selected: 'autocomplete-selected',
	            suggestion: 'autocomplete-suggestion'
	        };
	        that.hint = null;
	        that.hintValue = '';
	        that.selection = null;
	
	        // Initialize and set options:
	        that.initialize();
	        that.setOptions(options);
	    }
	
	    Autocomplete.utils = utils;
	
	    $.Autocomplete = Autocomplete;
	
	    Autocomplete.formatResult = function (suggestion, currentValue) {
	        var pattern = '(' + utils.escapeRegExChars(currentValue) + ')';
	        
	        return suggestion.value
	            .replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>')
	            .replace(/&/g, '&amp;')
	            .replace(/</g, '&lt;')
	            .replace(/>/g, '&gt;')
	            .replace(/"/g, '&quot;')
	            .replace(/&lt;(\/?strong)&gt;/g, '<$1>');
	    };
	
	    Autocomplete.prototype = {
	
	        killerFn: null,
	
	        initialize: function () {
	            var that = this,
	                suggestionSelector = '.' + that.classes.suggestion,
	                selected = that.classes.selected,
	                options = that.options,
	                container;
	
	            // Remove autocomplete attribute to prevent native suggestions:
	            that.element.setAttribute('autocomplete', 'off');
	
	            that.killerFn = function (e) {
	                if ($(e.target).closest('.' + that.options.containerClass).length === 0) {
	                    that.killSuggestions();
	                    that.disableKillerFn();
	                }
	            };
	
	            // html() deals with many types: htmlString or Element or Array or jQuery
	            that.noSuggestionsContainer = $('<div class="autocomplete-no-suggestion"></div>')
	                                          .html(this.options.noSuggestionNotice).get(0);
	
	            that.suggestionsContainer = Autocomplete.utils.createNode(options.containerClass);
	
	            container = $(that.suggestionsContainer);
	
	            container.appendTo(options.appendTo);
	
	            // Only set width if it was provided:
	            if (options.width !== 'auto') {
	                container.width(options.width);
	            }
	
	            // Listen for mouse over event on suggestions list:
	            container.on('mouseover.autocomplete', suggestionSelector, function () {
	                that.activate($(this).data('index'));
	            });
	
	            // Deselect active element when mouse leaves suggestions container:
	            container.on('mouseout.autocomplete', function () {
	                that.selectedIndex = -1;
	                container.children('.' + selected).removeClass(selected);
	            });
	
	            // Listen for click event on suggestions list:
	            container.on('click.autocomplete', suggestionSelector, function () {
	                that.select($(this).data('index'));
	            });
	
	            that.fixPositionCapture = function () {
	                if (that.visible) {
	                    that.fixPosition();
	                }
	            };
	
	            $(window).on('resize.autocomplete', that.fixPositionCapture);
	
	            that.el.on('keydown.autocomplete', function (e) { that.onKeyPress(e); });
	            that.el.on('keyup.autocomplete', function (e) { that.onKeyUp(e); });
	            that.el.on('blur.autocomplete', function () { that.onBlur(); });
	            that.el.on('focus.autocomplete', function () { that.onFocus(); });
	            that.el.on('change.autocomplete', function (e) { that.onKeyUp(e); });
	            that.el.on('input.autocomplete', function (e) { that.onKeyUp(e); });
	        },
	
	        onFocus: function () {
	            var that = this;
	            that.fixPosition();
	            if (that.options.minChars === 0 && that.el.val().length === 0) {
	                that.onValueChange();
	            }
	        },
	
	        onBlur: function () {
	            this.enableKillerFn();
	        },
	        
	        abortAjax: function () {
	            var that = this;
	            if (that.currentRequest) {
	                that.currentRequest.abort();
	                that.currentRequest = null;
	            }
	        },
	
	        setOptions: function (suppliedOptions) {
	            var that = this,
	                options = that.options;
	
	            $.extend(options, suppliedOptions);
	
	            that.isLocal = $.isArray(options.lookup);
	
	            if (that.isLocal) {
	                options.lookup = that.verifySuggestionsFormat(options.lookup);
	            }
	
	            options.orientation = that.validateOrientation(options.orientation, 'bottom');
	
	            // Adjust height, width and z-index:
	            $(that.suggestionsContainer).css({
	                'max-height': options.maxHeight + 'px',
	                'width': options.width + 'px',
	                'z-index': options.zIndex
	            });
	        },
	
	
	        clearCache: function () {
	            this.cachedResponse = {};
	            this.badQueries = [];
	        },
	
	        clear: function () {
	            this.clearCache();
	            this.currentValue = '';
	            this.suggestions = [];
	        },
	
	        disable: function () {
	            var that = this;
	            that.disabled = true;
	            clearInterval(that.onChangeInterval);
	            that.abortAjax();
	        },
	
	        enable: function () {
	            this.disabled = false;
	        },
	
	        fixPosition: function () {
	            // Use only when container has already its content
	
	            var that = this,
	                $container = $(that.suggestionsContainer),
	                containerParent = $container.parent().get(0);
	            // Fix position automatically when appended to body.
	            // In other cases force parameter must be given.
	            if (containerParent !== document.body && !that.options.forceFixPosition) {
	                return;
	            }
	
	            // Choose orientation
	            var orientation = that.options.orientation,
	                containerHeight = $container.outerHeight(),
	                height = that.el.outerHeight(),
	                offset = that.el.offset(),
	                styles = { 'top': offset.top, 'left': offset.left };
	
	            if (orientation === 'auto') {
	                var viewPortHeight = $(window).height(),
	                    scrollTop = $(window).scrollTop(),
	                    topOverflow = -scrollTop + offset.top - containerHeight,
	                    bottomOverflow = scrollTop + viewPortHeight - (offset.top + height + containerHeight);
	
	                orientation = (Math.max(topOverflow, bottomOverflow) === topOverflow) ? 'top' : 'bottom';
	            }
	
	            if (orientation === 'top') {
	                styles.top += -containerHeight;
	            } else {
	                styles.top += height;
	            }
	
	            // If container is not positioned to body,
	            // correct its position using offset parent offset
	            if(containerParent !== document.body) {
	                var opacity = $container.css('opacity'),
	                    parentOffsetDiff;
	
	                    if (!that.visible){
	                        $container.css('opacity', 0).show();
	                    }
	
	                parentOffsetDiff = $container.offsetParent().offset();
	                styles.top -= parentOffsetDiff.top;
	                styles.left -= parentOffsetDiff.left;
	
	                if (!that.visible){
	                    $container.css('opacity', opacity).hide();
	                }
	            }
	
	            // -2px to account for suggestions border.
	            if (that.options.width === 'auto') {
	                styles.width = (that.el.outerWidth() - 2) + 'px';
	            }
	
	            $container.css(styles);
	        },
	
	        enableKillerFn: function () {
	            var that = this;
	            $(document).on('click.autocomplete', that.killerFn);
	        },
	
	        disableKillerFn: function () {
	            var that = this;
	            $(document).off('click.autocomplete', that.killerFn);
	        },
	
	        killSuggestions: function () {
	            var that = this;
	            that.stopKillSuggestions();
	            that.intervalId = window.setInterval(function () {
	                if (that.visible) {
	                    that.el.val(that.currentValue);
	                    that.hide();
	                }
	                
	                that.stopKillSuggestions();
	            }, 50);
	        },
	
	        stopKillSuggestions: function () {
	            window.clearInterval(this.intervalId);
	        },
	
	        isCursorAtEnd: function () {
	            var that = this,
	                valLength = that.el.val().length,
	                selectionStart = that.element.selectionStart,
	                range;
	
	            if (typeof selectionStart === 'number') {
	                return selectionStart === valLength;
	            }
	            if (document.selection) {
	                range = document.selection.createRange();
	                range.moveStart('character', -valLength);
	                return valLength === range.text.length;
	            }
	            return true;
	        },
	
	        onKeyPress: function (e) {
	            var that = this;
	
	            // If suggestions are hidden and user presses arrow down, display suggestions:
	            if (!that.disabled && !that.visible && e.which === keys.DOWN && that.currentValue) {
	                that.suggest();
	                return;
	            }
	
	            if (that.disabled || !that.visible) {
	                return;
	            }
	
	            switch (e.which) {
	                case keys.ESC:
	                    that.el.val(that.currentValue);
	                    that.hide();
	                    break;
	                case keys.RIGHT:
	                    if (that.hint && that.options.onHint && that.isCursorAtEnd()) {
	                        that.selectHint();
	                        break;
	                    }
	                    return;
	                case keys.TAB:
	                    if (that.hint && that.options.onHint) {
	                        that.selectHint();
	                        return;
	                    }
	                    if (that.selectedIndex === -1) {
	                        that.hide();
	                        return;
	                    }
	                    that.select(that.selectedIndex);
	                    if (that.options.tabDisabled === false) {
	                        return;
	                    }
	                    break;
	                case keys.RETURN:
	                    if (that.selectedIndex === -1) {
	                        that.hide();
	                        return;
	                    }
	                    that.select(that.selectedIndex);
	                    break;
	                case keys.UP:
	                    that.moveUp();
	                    break;
	                case keys.DOWN:
	                    that.moveDown();
	                    break;
	                default:
	                    return;
	            }
	
	            // Cancel event if function did not return:
	            e.stopImmediatePropagation();
	            e.preventDefault();
	        },
	
	        onKeyUp: function (e) {
	            var that = this;
	
	            if (that.disabled) {
	                return;
	            }
	
	            switch (e.which) {
	                case keys.UP:
	                case keys.DOWN:
	                    return;
	            }
	
	            clearInterval(that.onChangeInterval);
	
	            if (that.currentValue !== that.el.val()) {
	                that.findBestHint();
	                if (that.options.deferRequestBy > 0) {
	                    // Defer lookup in case when value changes very quickly:
	                    that.onChangeInterval = setInterval(function () {
	                        that.onValueChange();
	                    }, that.options.deferRequestBy);
	                } else {
	                    that.onValueChange();
	                }
	            }
	        },
	
	        onValueChange: function () {
	            var that = this,
	                options = that.options,
	                value = that.el.val(),
	                query = that.getQuery(value);
	
	            if (that.selection && that.currentValue !== query) {
	                that.selection = null;
	                (options.onInvalidateSelection || $.noop).call(that.element);
	            }
	
	            clearInterval(that.onChangeInterval);
	            that.currentValue = value;
	            that.selectedIndex = -1;
	
	            // Check existing suggestion for the match before proceeding:
	            if (options.triggerSelectOnValidInput && that.isExactMatch(query)) {
	                that.select(0);
	                return;
	            }
	
	            if (query.length < options.minChars) {
	                that.hide();
	            } else {
	                that.getSuggestions(query);
	            }
	        },
	
	        isExactMatch: function (query) {
	            var suggestions = this.suggestions;
	
	            return (suggestions.length === 1 && suggestions[0].value.toLowerCase() === query.toLowerCase());
	        },
	
	        getQuery: function (value) {
	            var delimiter = this.options.delimiter,
	                parts;
	
	            if (!delimiter) {
	                return value;
	            }
	            parts = value.split(delimiter);
	            return $.trim(parts[parts.length - 1]);
	        },
	
	        getSuggestionsLocal: function (query) {
	            var that = this,
	                options = that.options,
	                queryLowerCase = query.toLowerCase(),
	                filter = options.lookupFilter,
	                limit = parseInt(options.lookupLimit, 10),
	                data;
	
	            data = {
	                suggestions: $.grep(options.lookup, function (suggestion) {
	                    return filter(suggestion, query, queryLowerCase);
	                })
	            };
	
	            if (limit && data.suggestions.length > limit) {
	                data.suggestions = data.suggestions.slice(0, limit);
	            }
	
	            return data;
	        },
	
	        getSuggestions: function (q) {
	            var response,
	                that = this,
	                options = that.options,
	                serviceUrl = options.serviceUrl,
	                params,
	                cacheKey,
	                ajaxSettings;
	
	            options.params[options.paramName] = q;
	            params = options.ignoreParams ? null : options.params;
	
	            if (options.onSearchStart.call(that.element, options.params) === false) {
	                return;
	            }
	
	            if ($.isFunction(options.lookup)){
	                options.lookup(q, function (data) {
	                    that.suggestions = data.suggestions;
	                    that.suggest();
	                    options.onSearchComplete.call(that.element, q, data.suggestions);
	                });
	                return;
	            }
	
	            if (that.isLocal) {
	                response = that.getSuggestionsLocal(q);
	            } else {
	                if ($.isFunction(serviceUrl)) {
	                    serviceUrl = serviceUrl.call(that.element, q);
	                }
	                cacheKey = serviceUrl + '?' + $.param(params || {});
	                response = that.cachedResponse[cacheKey];
	            }
	
	            if (response && $.isArray(response.suggestions)) {
	                that.suggestions = response.suggestions;
	                that.suggest();
	                options.onSearchComplete.call(that.element, q, response.suggestions);
	            } else if (!that.isBadQuery(q)) {
	                that.abortAjax();
	
	                ajaxSettings = {
	                    url: serviceUrl,
	                    data: params,
	                    type: options.type,
	                    dataType: options.dataType
	                };
	
	                $.extend(ajaxSettings, options.ajaxSettings);
	
	                that.currentRequest = $.ajax(ajaxSettings).done(function (data) {
	                    var result;
	                    that.currentRequest = null;
	                    result = options.transformResult(data, q);
	                    that.processResponse(result, q, cacheKey);
	                    options.onSearchComplete.call(that.element, q, result.suggestions);
	                }).fail(function (jqXHR, textStatus, errorThrown) {
	                    options.onSearchError.call(that.element, q, jqXHR, textStatus, errorThrown);
	                });
	            } else {
	                options.onSearchComplete.call(that.element, q, []);
	            }
	        },
	
	        isBadQuery: function (q) {
	            if (!this.options.preventBadQueries){
	                return false;
	            }
	
	            var badQueries = this.badQueries,
	                i = badQueries.length;
	
	            while (i--) {
	                if (q.indexOf(badQueries[i]) === 0) {
	                    return true;
	                }
	            }
	
	            return false;
	        },
	
	        hide: function () {
	            var that = this,
	                container = $(that.suggestionsContainer);
	
	            if ($.isFunction(that.options.onHide) && that.visible) {
	                that.options.onHide.call(that.element, container);
	            }
	
	            that.visible = false;
	            that.selectedIndex = -1;
	            clearInterval(that.onChangeInterval);
	            $(that.suggestionsContainer).hide();
	            that.signalHint(null);
	        },
	
	        suggest: function () {
	            if (this.suggestions.length === 0) {
	                if (this.options.showNoSuggestionNotice) {
	                    this.noSuggestions();
	                } else {
	                    this.hide();
	                }
	                return;
	            }
	
	            var that = this,
	                options = that.options,
	                groupBy = options.groupBy,
	                formatResult = options.formatResult,
	                value = that.getQuery(that.currentValue),
	                className = that.classes.suggestion,
	                classSelected = that.classes.selected,
	                container = $(that.suggestionsContainer),
	                noSuggestionsContainer = $(that.noSuggestionsContainer),
	                beforeRender = options.beforeRender,
	                html = '',
	                category,
	                formatGroup = function (suggestion, index) {
	                        var currentCategory = suggestion.data[groupBy];
	
	                        if (category === currentCategory){
	                            return '';
	                        }
	
	                        category = currentCategory;
	
	                        return '<div class="autocomplete-group"><strong>' + category + '</strong></div>';
	                    };
	
	            if (options.triggerSelectOnValidInput && that.isExactMatch(value)) {
	                that.select(0);
	                return;
	            }
	
	            // Build suggestions inner HTML:
	            $.each(that.suggestions, function (i, suggestion) {
	                if (groupBy){
	                    html += formatGroup(suggestion, value, i);
	                }
	
	                html += '<div class="' + className + '" data-index="' + i + '">' + formatResult(suggestion, value) + '</div>';
	            });
	
	            this.adjustContainerWidth();
	
	            noSuggestionsContainer.detach();
	
	            if (container.find(this.options.additionalContainerClass).length > 0)
	                container.find(this.options.additionalContainerClass).html(html);
	            else
	                container.html(html);
	
	            if ($.isFunction(beforeRender)) {
	                beforeRender.call(that.element, container);
	            }
	
	            that.fixPosition();
	            container.show();
	
	            // Select first value by default:
	            if (options.autoSelectFirst) {
	                that.selectedIndex = 0;
	                container.scrollTop(0);
	                container.children('.' + className).first().addClass(classSelected);
	            }
	
	            that.visible = true;
	            that.findBestHint();
	        },
	
	        noSuggestions: function() {
	             var that = this,
	                 container = $(that.suggestionsContainer),
	                 noSuggestionsContainer = $(that.noSuggestionsContainer);
	
	            this.adjustContainerWidth();
	
	            // Some explicit steps. Be careful here as it easy to get
	            // noSuggestionsContainer removed from DOM if not detached properly.
	            noSuggestionsContainer.detach();
	            container.empty(); // clean suggestions if any
	            container.append(noSuggestionsContainer);
	
	            that.fixPosition();
	
	            container.show();
	            that.visible = true;
	        },
	
	        adjustContainerWidth: function() {
	            var that = this,
	                options = that.options,
	                width,
	                container = $(that.suggestionsContainer);
	
	            // If width is auto, adjust width before displaying suggestions,
	            // because if instance was created before input had width, it will be zero.
	            // Also it adjusts if input width has changed.
	            // -2px to account for suggestions border.
	            if (options.width === 'auto') {
	                width = that.el.outerWidth() - 2;
	                container.width(width > 0 ? width : 300);
	            }
	        },
	
	        findBestHint: function () {
	            var that = this,
	                value = that.el.val().toLowerCase(),
	                bestMatch = null;
	
	            if (!value) {
	                return;
	            }
	
	            $.each(that.suggestions, function (i, suggestion) {
	                var foundMatch = suggestion.value.toLowerCase().indexOf(value) === 0;
	                if (foundMatch) {
	                    bestMatch = suggestion;
	                }
	                return !foundMatch;
	            });
	
	            that.signalHint(bestMatch);
	        },
	
	        signalHint: function (suggestion) {
	            var hintValue = '',
	                that = this;
	            if (suggestion) {
	                hintValue = that.currentValue + suggestion.value.substr(that.currentValue.length);
	            }
	            if (that.hintValue !== hintValue) {
	                that.hintValue = hintValue;
	                that.hint = suggestion;
	                (this.options.onHint || $.noop)(hintValue);
	            }
	        },
	
	        verifySuggestionsFormat: function (suggestions) {
	            // If suggestions is string array, convert them to supported format:
	            if (suggestions.length && typeof suggestions[0] === 'string') {
	                return $.map(suggestions, function (value) {
	                    return { value: value, data: null };
	                });
	            }
	
	            return suggestions;
	        },
	
	        validateOrientation: function(orientation, fallback) {
	            orientation = $.trim(orientation || '').toLowerCase();
	
	            if($.inArray(orientation, ['auto', 'bottom', 'top']) === -1){
	                orientation = fallback;
	            }
	
	            return orientation;
	        },
	
	        processResponse: function (result, originalQuery, cacheKey) {
	            var that = this,
	                options = that.options;
	
	            result.suggestions = that.verifySuggestionsFormat(result.suggestions);
	
	            // Cache results if cache is not disabled:
	            if (!options.noCache) {
	                that.cachedResponse[cacheKey] = result;
	                if (options.preventBadQueries && result.suggestions.length === 0) {
	                    that.badQueries.push(originalQuery);
	                }
	            }
	
	            // Return if originalQuery is not matching current query:
	            if (originalQuery !== that.getQuery(that.currentValue)) {
	                return;
	            }
	
	            that.suggestions = result.suggestions;
	            that.suggest();
	        },
	
	        activate: function (index) {
	            var that = this,
	                activeItem,
	                selected = that.classes.selected,
	                container = $(that.suggestionsContainer),
	                children = container.find('.' + that.classes.suggestion);
	
	            container.find('.' + selected).removeClass(selected);
	
	            that.selectedIndex = index;
	
	            if (that.selectedIndex !== -1 && children.length > that.selectedIndex) {
	                activeItem = children.get(that.selectedIndex);
	                $(activeItem).addClass(selected);
	                return activeItem;
	            }
	
	            return null;
	        },
	
	        selectHint: function () {
	            var that = this,
	                i = $.inArray(that.hint, that.suggestions);
	
	            that.select(i);
	        },
	
	        select: function (i) {
	            var that = this;
	            that.hide();
	            that.onSelect(i);
	        },
	
	        moveUp: function () {
	            var that = this;
	
	            if (that.selectedIndex === -1) {
	                return;
	            }
	
	            if (that.selectedIndex === 0) {
	                $(that.suggestionsContainer).children().first().removeClass(that.classes.selected);
	                that.selectedIndex = -1;
	                that.el.val(that.currentValue);
	                that.findBestHint();
	                return;
	            }
	
	            that.adjustScroll(that.selectedIndex - 1);
	        },
	
	        moveDown: function () {
	            var that = this;
	
	            if (that.selectedIndex === (that.suggestions.length - 1)) {
	                return;
	            }
	
	            that.adjustScroll(that.selectedIndex + 1);
	        },
	
	        adjustScroll: function (index) {
	            var that = this,
	                activeItem = that.activate(index);
	
	            if (!activeItem) {
	                return;
	            }
	
	            var offsetTop,
	                upperBound,
	                lowerBound,
	                heightDelta = $(activeItem).outerHeight();
	
	            offsetTop = activeItem.offsetTop;
	            upperBound = $(that.suggestionsContainer).scrollTop();
	            lowerBound = upperBound + that.options.maxHeight - heightDelta;
	
	            if (offsetTop < upperBound) {
	                $(that.suggestionsContainer).scrollTop(offsetTop);
	            } else if (offsetTop > lowerBound) {
	                $(that.suggestionsContainer).scrollTop(offsetTop - that.options.maxHeight + heightDelta);
	            }
	
	            if (!that.options.preserveInput) {
	                that.el.val(that.getValue(that.suggestions[index].value));
	            }
	            that.signalHint(null);
	        },
	
	        onSelect: function (index) {
	            var that = this,
	                onSelectCallback = that.options.onSelect,
	                suggestion = that.suggestions[index];
	
	            that.currentValue = that.getValue(suggestion.value);
	
	            if (that.currentValue !== that.el.val() && !that.options.preserveInput) {
	                that.el.val(that.currentValue);
	            }
	
	            that.signalHint(null);
	            that.suggestions = [];
	            that.selection = suggestion;
	
	            if ($.isFunction(onSelectCallback)) {
	                onSelectCallback.call(that.element, suggestion);
	            }
	        },
	
	        getValue: function (value) {
	            var that = this,
	                delimiter = that.options.delimiter,
	                currentValue,
	                parts;
	
	            if (!delimiter) {
	                return value;
	            }
	
	            currentValue = that.currentValue;
	            parts = currentValue.split(delimiter);
	
	            if (parts.length === 1) {
	                return value;
	            }
	
	            return currentValue.substr(0, currentValue.length - parts[parts.length - 1].length) + value;
	        },
	
	        dispose: function () {
	            var that = this;
	            that.el.off('.autocomplete').removeData('autocomplete');
	            that.disableKillerFn();
	            $(window).off('resize.autocomplete', that.fixPositionCapture);
	            $(that.suggestionsContainer).remove();
	        }
	    };
	
	    // Create chainable jQuery plugin:
	    $.fn.autocomplete = $.fn.devbridgeAutocomplete = function (options, args) {
	        var dataKey = 'autocomplete';
	        // If function invoked without argument return
	        // instance of the first matched element:
	        if (arguments.length === 0) {
	            return this.first().data(dataKey);
	        }
	
	        return this.each(function () {
	            var inputElement = $(this),
	                instance = inputElement.data(dataKey);
	
	            if (typeof options === 'string') {
	                if (instance && typeof instance[options] === 'function') {
	                    instance[options](args);
	                }
	            } else {
	                // If instance already exists, destroy it:
	                if (instance && instance.dispose) {
	                    instance.dispose();
	                }
	                instance = new Autocomplete(this, options);
	                inputElement.data(dataKey, instance);
	            }
	        });
	    };
	}));


/***/ }),
/* 451 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */,
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _mindboxTracker = __webpack_require__(445);
	
	var MindboxOperation = (function () {
	    function MindboxOperation() {
	        _classCallCheck(this, MindboxOperation);
	
	        this.mindboxTracker = new _mindboxTracker.MindboxTracker();
	    }
	
	    _createClass(MindboxOperation, [{
	        key: 'setCart',
	        value: function setCart() {
	            var _self = this;
	            $.ajax({
	                url: '/ajax/action/widget_mindbox_operation_basket/get_data/',
	                type: 'GET',
	                success: function success(result) {
	                    if (parseInt(result.code) === 200) {
	                        _self.mindboxTracker.setCart(result.data);
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'setWishList',
	        value: function setWishList() {
	            var _self = this;
	            $.ajax({
	                url: '/ajax/action/widget_mindbox_operation_favorite/get_data/',
	                type: 'GET',
	                success: function success(result) {
	                    if (parseInt(result.code) === 200) {
	                        _self.mindboxTracker.setWishList(result.data);
	                    }
	                }
	            });
	        }
	    }]);
	
	    return MindboxOperation;
	})();

	exports.MindboxOperation = MindboxOperation;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(455);
	
	(function () {
	    var body = $('html, body');
	    var scrollTop = $('.scrolltop');
	    var contStyleName = '.scrolltop__container';
	
	    body.on('mouseenter', contStyleName, function () {
	        $(this).stop().animate({ opacity: '0.75' }, 200);
	    });
	
	    body.on('mouseleave', contStyleName, function () {
	        $(this).stop().animate({ opacity: '0.35' }, 200);
	    });
	
	    body.on('click', contStyleName, function () {
	        body.animate({ scrollTop: 0 }, 300);
	        return false;
	    });
	
	    $(window).scroll(function () {
	        if ($(this).scrollTop() > (screen.height / 2 | 0)) {
	            scrollTop.show();
	            $(contStyleName).stop().animate({ opacity: '0.35' }, 600);
	            return;
	        }
	
	        $(contStyleName).stop().animate({ opacity: '0' }, 600);
	        scrollTop.fadeOut(600, function () {
	            scrollTop.hide();
	        });
	    });
	})();

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */,
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(133)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _modulesPreloader = __webpack_require__(120);
	
	var _modulesPreloader2 = _interopRequireDefault(_modulesPreloader);
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _googleCaptcha = __webpack_require__(458);
	
	var _googleCaptcha2 = _interopRequireDefault(_googleCaptcha);
	
	__webpack_require__(300);
	var form = __webpack_require__(318);
	
	var size = __webpack_require__(55);
	
	var autoComplete = __webpack_require__(447);
	
	var captcha = undefined,
	    bxCaptchaSid = undefined;
	
	var trackers = new _trackerTracker2['default']();
	
	var changeState = function changeState(v) {
	    if (v == 'login') {
	        $.prompt.goToState('loginForm');
	    } else if (v == 'reg') {
	        trackers.onPMbtnReg();
	        $.prompt.goToState(curRegForm);
	    } else if (v == 'passrecovery') {
	        $.prompt.goToState('passRecoveryForm');
	    } else if (v == 'thankyou') {
	        $.prompt.goToState('thankYouForm');
	    } else {
	        return 'nogo';
	    }
	};
	
	var curRegForm = 'regForm';
	
	var registration = $('.js-registration-head');
	var authPromptHeader = registration.find('.js-prompt-header').remove().html();
	var thankYouPrompt = $('.js-thankyou-prompt').html();
	
	var authPrompt = {
	    loginForm: {
	        html: $('.js-auth-component').remove().html(),
	        submit: function submit(e, v, m) {
	            // РКН блоктрует google и отсутствие grecaptcha ломает авторизацию
	            window.grecaptcha = window.grecaptcha ? window.grecaptcha : {};
	
	            if (!captcha) {
	                captcha = new _googleCaptcha2['default']('.captcha-field', grecaptcha);
	            }
	
	            var changeStateRes = changeState(v);
	            if (changeStateRes == 'nogo') {
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        login_email: { required: true, email: true },
	                        login_password: { required: true },
	                        login_remember_me: {}
	                    },
	                    messages: {
	                        login_email: {
	                            required: 'Не указан e-mail',
	                            email: 'Указан неверный e-mail'
	                        },
	                        login_password: { required: 'Указан неверный пароль' }
	                    },
	                    submitHandler: function submitHandler() {
	                        var email = $('.jqistate input[name=login_email]').val();
	                        var password = $('.jqistate input[name=login_password]').val();
	                        var remember = $('.jqistate input[name=login_remember_me]').is(':checked');
	                        var sessid = $('.jqistate input[name=sessid]').val();
	
	                        if (captcha.key && !captcha.exists()) {
	                            captcha.render();
	                        }
	
	                        if (captcha.rendered() && !captcha.completed()) {
	                            $('.js-login_error').text('Необходимо выполнить captcha');
	                            return;
	                        }
	
	                        var sendObj = {
	                            email: email,
	                            password: password,
	                            isRemember: remember,
	                            sessid: sessid
	                        };
	
	                        if (bxCaptchaSid) {
	                            sendObj = _Object$assign(sendObj, {
	                                'g-recaptcha-response': captcha.completed() || '',
	                                captcha_sid: bxCaptchaSid,
	                                captcha_word: Math.random().toString(36).substr(2, 5).toUpperCase()
	                            });
	                        }
	                        var loader = new _modulesPreloader2['default']();
	                        loader.show();
	
	                        $.ajax({
	                            method: 'POST',
	                            url: '/ajax/action/personal_authorize/get_authorization_data/',
	                            data: sendObj,
	                            async: false,
	                            success: function success(response) {
	                                loader.hide(0);
	                                if (response['code'] !== 200) {
	                                    $('.js-login_error').text(response['message']);
	                                    $('.jqistate input[name=login_password]').val('');
	
	                                    bxCaptchaSid = response['data']['BX_CAPTCHA_CODE'];
	
	                                    if (response['data']['CAPTCHA_CODE'] && !captcha.rendered()) {
	                                        captcha.key = response['data']['CAPTCHA_CODE'];
	                                        captcha.render();
	                                        return;
	                                    }
	
	                                    if (captcha.rendered()) {
	                                        captcha.reset();
	                                    }
	                                } else {
	                                    location.replace(location.href);
	                                }
	                            },
	                            error: function error() {
	                                loader.hide(0);
	                            }
	                        });
	                    }
	                });
	                var $form = m.closest('form');
	                $form.validate($params);
	                $('.js-login_error').text('');
	            }
	            e.preventDefault();
	        }
	    },
	    regForm: {
	        html: authPromptHeader + registration.find('.js-reg-component').html(),
	        submit: function submit(e, v, m) {
	            var changeStateRes = changeState(v);
	            curRegForm = 'regForm';
	            if (changeStateRes == 'nogo') {
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        EMAIL: {
	                            required: true,
	                            email: true,
	                            remote: {
	                                url: '/ajax/action/personal_registration/checkEmailTaken/',
	                                type: 'get',
	                                dataType: 'json',
	                                dataFilter: function dataFilter(response) {
	                                    var result = true;
	                                    if (response) {
	                                        var json = $.parseJSON(response);
	                                        if (json.data[0] === 'false') {
	                                            result = false;
	                                        }
	                                    }
	                                    return result;
	                                }
	                            }
	                        },
	                        PASSWORD: {
	                            required: true,
	                            minlength: 6
	                        },
	                        WORK_CITY: { required: true },
	                        UF_PHONE: { required: true, phoneMask: true },
	                        NAME: { required: true },
	                        reg_user_type: { required: true }
	                    },
	                    messages: {
	                        EMAIL: {
	                            required: 'Не указан e-mail',
	                            email: 'Указан неверный e-mail',
	                            remote: 'Пользователь с таким email уже существует'
	                        },
	                        PASSWORD: {
	                            required: 'Не указан пароль',
	                            minlength: 'Длина пароля - не менее 6 символов'
	                        },
	                        WORK_CITY: { required: 'Не указан город' },
	                        UF_PHONE: {
	                            required: 'Не указан телефон',
	                            phoneMask: 'Указан неверный телефон'
	                        },
	                        NAME: { required: 'Не указано имя' },
	                        reg_user_type: { required: 'Не выбран тип' }
	                    },
	                    submitHandler: function submitHandler() {
	                        var currentCaptchaId = window.Recaptchafree.items[window.Recaptchafree.items.length - 1];
	                        var recaptchaResponse = grecaptcha.getResponse(currentCaptchaId) || '';
	
	                        if (!recaptchaResponse) {
	                            $('.js-server_errors').html('Необходимо выполнить captcha!' + '<br>').addClass('form__error-msg');
	                            return;
	                        }
	
	                        var responseField = $('<input/>', {
	                            type: 'text',
	                            name: 'g-recaptcha-response',
	                            val: recaptchaResponse
	                        });
	
	                        var dataRegForm = $.prompt.getState('regForm').find('.js-reg-form');
	                        var regResult = $.merge($.merge(dataRegForm, $.prompt.getState('regForm').find('[name=reg_user_type]')), responseField);
	                        var userType = $.prompt.getState('regForm').find('[name=reg_user_type]').val();
	
	                        var loader = new _modulesPreloader2['default']();
	                        loader.show();
	
	                        $.ajax({
	                            url: '/ajax/action/personal_registration/registration/',
	                            data: regResult,
	                            type: 'POST',
	                            success: function success(response) {
	                                loader.hide(0);
	                                if (response['code'] == 200) {
	                                    var _trackers = new _trackerTracker2['default']();
	                                    _trackers.onSignUpEnd({ gtm: 'registrationDone' });
	                                    if (userType === 'individual') {
	                                        $('.js-thankyou-wholesale').remove();
	                                    } else {
	                                        $('.js-thankyou-retail').remove();
	                                    }
	                                    $('.jqiclose').remove();
	                                    $('.jqiform').css('padding-bottom', 0);
	                                    grecaptcha.reset(currentCaptchaId);
	                                    _trackers.onPMfrmReg();
	                                    changeState('thankyou');
	                                } else {
	                                    $.each(response['data']['errors'], function () {
	                                        $('.js-server_errors').html(this + '<br>').addClass('form__error-msg');
	                                        bxCaptchaSid = response['data']['BX_CAPTCHA_CODE'];
	                                        $('input[name="captcha_sid"]').val(bxCaptchaSid);
	                                        grecaptcha.reset(currentCaptchaId);
	                                    });
	                                }
	                            },
	                            error: function error() {
	                                loader.hide(0);
	                            }
	                        });
	                    }
	                });
	
	                var $form = m.closest('form');
	                $form.validate($params);
	            }
	            e.preventDefault();
	        }
	    },
	    passRecoveryForm: {
	        html: $('.js-forgotpasswd-component').remove().html(),
	        submit: function submit(e, v, m) {
	            var changeStateRes = changeState(v);
	            if (changeStateRes == 'nogo') {
	                var $form = m.closest('form');
	
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        USER_EMAIL: { required: true, email: true }
	                    },
	                    messages: {
	                        USER_EMAIL: {
	                            required: 'Не указан e-mail',
	                            email: 'Указан неверный e-mail'
	                        }
	                    },
	                    submitHandler: function submitHandler() {
	                        var email = $('.jqistate input[name="USER_EMAIL"]').val();
	                        var inputs = $.prompt.getState('passRecoveryForm').find(':input');
	                        inputs = inputs.serialize();
	                        var recoveryResult = undefined;
	                        var code = undefined;
	                        $.ajax({
	                            url: '/ajax/action/personal_forgotpasswd/check_user/?email=' + email,
	                            async: false,
	                            complete: function complete(response) {
	                                recoveryResult = response.responseJSON['data'];
	                                code = response.responseJSON['code'];
	                            }
	                        });
	                        if (code !== 200) {
	                            $('.login_email_error-js').text(recoveryResult['message']).addClass('form__error-msg');
	                        } else {
	                            $.ajax({
	                                type: 'POST',
	                                data: inputs,
	                                success: function success() {
	                                    $.prompt.getState('passRecoveryForm').find('.form').html(recoveryResult['message']);
	                                    $.prompt.position();
	                                }
	                            });
	                        }
	                    }
	                });
	
	                $form.validate($params);
	            }
	            e.preventDefault();
	        }
	    },
	    thankYouForm: {
	        html: thankYouPrompt,
	        submit: function submit(e) {
	            e.preventDefault();
	            location.replace(location.href);
	        }
	    }
	};
	
	module.exports = authPrompt;
	
	jQuery(function () {
	    $(document).on('click', '.js-jqi-show-login', function (e) {
	        e.preventDefault();
	        $.prompt(authPrompt, {
	            initialState: 'loginForm',
	
	            statechanging: function statechanging(e, from, to) {
	                if (to !== 'regForm') {
	                    return;
	                }
	
	                window.Recaptchafree.render();
	            }
	        });
	    });
	
	    $(document).on('click', '.js-jqi-show-reg', function (e) {
	        e.preventDefault();
	        trackers.onSignUp();
	        trackers.onPMbtnReg();
	        $.prompt(authPrompt, {
	            initialState: 'regForm',
	            statechanging: function statechanging(e, from, to) {
	                if (to !== 'regForm') {
	                    return;
	                }
	
	                window.Recaptchafree.render();
	            }
	        });
	    });
	
	    $(document).on('click', '.js-jqi-show-passrecovery', function (e) {
	        e.preventDefault();
	        $.prompt(authPrompt, { initialState: 'passRecoveryForm' });
	    });
	
	    $(document).on('click', '.js-expand-reg-promo', function () {
	        var $regPromoBlock = $(this).closest('.prompt__reg-promo');
	        $regPromoBlock.addClass('prompt__reg-promo--shown');
	    });
	
	    $(document).on('click', '.js-mobile-auth-btn', function (e) {
	        e.preventDefault();
	
	        if (window.innerWidth < size.desktop) {
	            $.prompt(authPrompt, {
	                initialState: 'loginForm',
	                statechanging: function statechanging(e, from, to) {
	                    if (to !== 'regForm') {
	                        return;
	                    }
	
	                    window.Recaptchafree.render();
	                }
	            });
	        }
	    });
	
	    $(document).on('click', '.js-mobile-user-btn', function () {
	        var userFormHtml = '';
	        $.ajax({
	            url: '/ajax/component/maximaster:personal.widget/user/',
	            async: false,
	            success: function success(data) {
	                userFormHtml = data['html'];
	            }
	        });
	
	        var userPrompt = {
	            userForm: {
	                html: userFormHtml
	            }
	        };
	
	        if (window.innerWidth < size.desktop) {
	            $.prompt(userPrompt, {
	                initialState: 'userForm',
	                statechanging: function statechanging(e, from, to) {
	                    if (to !== 'regForm') {
	                        return;
	                    }
	
	                    window.Recaptchafree.render();
	                }
	            });
	        }
	    });
	
	    $(document).on('click', '.js-user-logout-btn', function () {
	        $.ajax({
	            url: '/ajax/action/personal_authorize/logout/',
	            success: function success() {
	                location.replace(location.href);
	            }
	        });
	    });
	
	    $(document).on('focus', '.js-autocomplete', function () {
	        autoComplete.setAutocomplete($('.js-autocomplete'));
	    });
	});

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _Number$isInteger = __webpack_require__(459)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var ReCaptcha = (function () {
	    function ReCaptcha(selector, captcha) {
	        _classCallCheck(this, ReCaptcha);
	
	        this.selector = selector;
	        this.captcha = captcha;
	        this.captchaId = null;
	        this.siteKey = null;
	    }
	
	    _createClass(ReCaptcha, [{
	        key: 'render',
	        value: function render(callback) {
	            if (!this.siteKey) {
	                console.error('cannot render captcha, siteKey not found');
	                return;
	            }
	
	            var config = { sitekey: this.siteKey };
	
	            if (callback) {
	                config['callback'] = callback;
	            }
	
	            this.captchaId = this.captcha.render(this.elem, config);
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            if (!this.rendered()) {
	                console.error('cannot reset captcha, captcha not rendered');
	                return;
	            }
	
	            this.captcha.reset(this.captchaId);
	        }
	    }, {
	        key: 'rendered',
	        value: function rendered() {
	            return _Number$isInteger(this.captchaId);
	        }
	    }, {
	        key: 'exists',
	        value: function exists() {
	            if (!this.elem) {
	                return false;
	            }
	
	            return this.elem.firstElementChild && this.rendered();
	        }
	    }, {
	        key: 'completed',
	        value: function completed() {
	            if (!this.rendered()) {
	                return false;
	            }
	
	            return this.captcha.getResponse(this.captchaId);
	        }
	    }, {
	        key: 'key',
	        set: function set(key) {
	            this.siteKey = key;
	        },
	        get: function get() {
	            return this.siteKey;
	        }
	    }, {
	        key: 'elem',
	        get: function get() {
	            var elem = document.querySelector(this.selector);
	
	            if (!elem) {
	                console.error('element ' + this.selector + ' not exists');
	            }
	
	            return elem;
	        }
	    }]);
	
	    return ReCaptcha;
	})();
	
	exports['default'] = ReCaptcha;
	module.exports = exports['default'];

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(460), __esModule: true };

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(461);
	module.exports = __webpack_require__(61).Number.isInteger;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(59);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(462) });


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(67);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(300);
	var Url = __webpack_require__(464);
	
	jQuery(function () {
	    $(document).on('click', '.js-city-select', function (e) {
	        e.preventDefault();
	        var citiesHtml = $('.js-city-list-container').html();
	        $.prompt(citiesHtml, {
	            buttons: {},
	            persistent: false, //чтобы можно было закрыть при клике по оверлею
	            classes: {
	                prompt: 'prompt--middle-large',
	                form: 'prompt__form-special',
	                close: 'jqiclose--cross'
	            }
	        });
	    });
	
	    $(document).on('click', '.cities-list__link', function () {
	        var currentUrl = new Url();
	        if (currentUrl.query.city) {
	            delete currentUrl.query.city;
	            $(this).attr('href', currentUrl.toString());
	        }
	        var date = new Date(new Date().getTime() + 99999999);
	        document.cookie = 'BITRIX_SM_region_code=' + $(this).data('code') + '; expires=' + date.toUTCString() + '; path=/';
	
	        var urlSetRegion = '/ajax/action/region_widget/set_region/';
	        var xhr = new XMLHttpRequest();
	        xhr.open('GET', urlSetRegion, false);
	        xhr.send();
	        if (xhr.status !== 200) {
	            console.error(urlSetRegion + ' ' + xhr.statusText);
	        }
	    });
	});

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, global, process) {!function(t){"use strict";var y=/^[a-z]+:/,d=/[-a-z0-9]+(\.[-a-z0-9])*:\d+/i,v=/\/\/(.*?)(?::(.*?))?@/,r=/^win/i,g=/:$/,m=/^\?/,q=/^#/,w=/(.*\/)/,A=/^\/{2,}/,I=/(^\/?)/,e=/'/g,o=/%([ef][0-9a-f])%([89ab][0-9a-f])%([89ab][0-9a-f])/gi,n=/%([cd][0-9a-f])%([89ab][0-9a-f])/gi,i=/%([0-7][0-9a-f])/gi,s=/\+/g,a=/^\w:$/,C=/[^/#?]/;var p,S="undefined"==typeof window&&"undefined"!=typeof global&&"function"=="function",b=!S&&t.navigator&&t.navigator.userAgent&&~t.navigator.userAgent.indexOf("MSIE"),x=S?t.require:null,j={protocol:"protocol",host:"hostname",port:"port",path:"pathname",query:"search",hash:"hash"},z={ftp:21,gopher:70,http:80,https:443,ws:80,wss:443};function E(){return S?p=p||"file://"+(process.platform.match(r)?"/":"")+x("fs").realpathSync("."):"about:srcdoc"===document.location.href?self.parent.document.location.href:document.location.href}function h(t,r,e){var o,n,i;r=r||E(),S?o=x("url").parse(r):(o=document.createElement("a")).href=r;var a,s,p=(s={path:!0,query:!0,hash:!0},(a=r)&&y.test(a)&&(s.protocol=!0,s.host=!0,d.test(a)&&(s.port=!0),v.test(a)&&(s.user=!0,s.pass=!0)),s);for(n in i=r.match(v)||[],j)p[n]?t[n]=o[j[n]]||"":t[n]="";if(t.protocol=t.protocol.replace(g,""),t.query=t.query.replace(m,""),t.hash=F(t.hash.replace(q,"")),t.user=F(i[1]||""),t.pass=F(i[2]||""),t.port=z[t.protocol]==t.port||0==t.port?"":t.port,!p.protocol&&C.test(r.charAt(0))&&(t.path=r.split("?")[0].split("#")[0]),!p.protocol&&e){var h=new L(E().match(w)[0]),u=h.path.split("/"),c=t.path.split("/"),f=["protocol","user","pass","host","port"],l=f.length;for(u.pop(),n=0;n<l;n++)t[f[n]]=h[f[n]];for(;".."===c[0];)u.pop(),c.shift();t.path=("/"!==r.charAt(0)?u.join("/"):"")+"/"+c.join("/")}t.path=t.path.replace(A,"/"),b&&(t.path=t.path.replace(I,"/")),t.paths(t.paths()),t.query=new U(t.query)}function u(t){return encodeURIComponent(t).replace(e,"%27")}function F(t){return(t=(t=(t=t.replace(s," ")).replace(o,function(t,r,e,o){var n=parseInt(r,16)-224,i=parseInt(e,16)-128;if(0==n&&i<32)return t;var a=(n<<12)+(i<<6)+(parseInt(o,16)-128);return 65535<a?t:String.fromCharCode(a)})).replace(n,function(t,r,e){var o=parseInt(r,16)-192;if(o<2)return t;var n=parseInt(e,16)-128;return String.fromCharCode((o<<6)+n)})).replace(i,function(t,r){return String.fromCharCode(parseInt(r,16))})}function U(t){for(var r=t.split("&"),e=0,o=r.length;e<o;e++){var n=r[e].split("="),i=decodeURIComponent(n[0].replace(s," "));if(i){var a=void 0!==n[1]?F(n[1]):null;void 0===this[i]?this[i]=a:(this[i]instanceof Array||(this[i]=[this[i]]),this[i].push(a))}}}function L(t,r){h(this,t,!r)}U.prototype.toString=function(){var t,r,e="",o=u;for(t in this){var n=this[t];if(!(n instanceof Function||void 0===n))if(n instanceof Array){var i=n.length;if(!i){e+=(e?"&":"")+o(t)+"=";continue}for(r=0;r<i;r++){var a=n[r];void 0!==a&&(e+=e?"&":"",e+=o(t)+(null===a?"":"="+o(a)))}}else e+=e?"&":"",e+=o(t)+(null===n?"":"="+o(n))}return e},L.prototype.clearQuery=function(){for(var t in this.query)this.query[t]instanceof Function||delete this.query[t];return this},L.prototype.queryLength=function(){var t=0;for(var r in this.query)this.query[r]instanceof Function||t++;return t},L.prototype.isEmptyQuery=function(){return 0===this.queryLength()},L.prototype.paths=function(t){var r,e="",o=0;if(t&&t.length&&t+""!==t){for(this.isAbsolute()&&(e="/"),r=t.length;o<r;o++)t[o]=!o&&a.test(t[o])?t[o]:u(t[o]);this.path=e+t.join("/")}for(o=0,r=(t=("/"===this.path.charAt(0)?this.path.slice(1):this.path).split("/")).length;o<r;o++)t[o]=F(t[o]);return t},L.prototype.encode=u,L.prototype.decode=F,L.prototype.isAbsolute=function(){return this.protocol||"/"===this.path.charAt(0)},L.prototype.toString=function(){return(this.protocol&&this.protocol+"://")+(this.user&&u(this.user)+(this.pass&&":"+u(this.pass))+"@")+(this.host&&this.host)+(this.port&&":"+this.port)+(this.path&&this.path)+(this.query.toString()&&"?"+this.query)+(this.hash&&"#"+u(this.hash))},t[t.exports?"exports":"Url"]=L}("undefined"!=typeof module&&module.exports?module:window);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(465)(module), (function() { return this; }()), __webpack_require__(466)))

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 466 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 467 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */,
/* 469 */
/***/ (function(module, exports) {

	'use strict';
	
	jQuery.validator.addMethod('phoneMask', function (value, element) {
	    return this.optional(element) || /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}$/.test(value);
	}, 'Указан неверный телефон');
	
	/*jQuery.validator.addMethod("require_from_group", function(value, element, options) {
		var validator = this;
		var selector = options[1];
		var validOrNot = $(selector, element.form).filter(function() {
				return validator.elementValue(this);
			}).length >= options[0];
	
		if(!$(element).data('being_validated')) {
			var fields = $(selector, element.form);
			fields.data('being_validated', true);
			fields.valid();
			fields.data('being_validated', false);
		}
		return validOrNot;
	}, jQuery.validator.format("Заполните как минимум {0} из этих полей."));*/
	
	$.validator.addMethod('require_from_group', function (value, element, options) {
	    var $fields = $(options[1], element.form),
	        $fieldsFirst = $fields.eq(0),
	        validator = $fieldsFirst.data('valid_req_grp') ? $fieldsFirst.data('valid_req_grp') : $.extend({}, this),
	        isValid = $fields.filter(function () {
	        return validator.elementValue(this);
	    }).length >= options[0];
	
	    // Store the cloned validator for future validation
	    $fieldsFirst.data('valid_req_grp', validator);
	
	    // If element isn't being validated, run each require_from_group field's validation rules
	    if (!$(element).data('being_validated')) {
	        $fields.data('being_validated', true);
	        $fields.each(function () {
	            validator.element(this);
	        });
	        $fields.data('being_validated', false);
	    }
	    return isValid;
	}, $.validator.format('Please fill at least {0} of these fields.'));
	
	$.validator.addMethod('all_req', function (value, element, options) {
	    var isValid = false;
	
	    var $fields = $(options[0], element.form);
	    var count = $fields.length;
	
	    $fields.each(function () {
	        if (this.value !== '') {
	            count--;
	        }
	    });
	
	    if (count == 0 || count == $fields.length) isValid = true;else if (value !== '') isValid = true;
	
	    return isValid;
	}, $.validator.format('Заполните либо все, либо ни одного поля'));
	
	/* Проверка контрольных разрядов ИНН  - используется в методе INN_RUS */
	var getControlSum = function getControlSum(value, position) {
	    var res = -1;
	    if (position < value.length - 2 || position > 11) {
	        return res;
	    }
	    var test = [2, 4, 10, 3, 5, 9, 4, 6, 8];
	    if (position > test.length) {
	        test.unshift(7);
	    }
	    if (position > test.length) {
	        test.unshift(3);
	    }
	
	    var arr = [];
	    for (var i = 0; i < value.length; i++) {
	        arr.push(parseInt(value[i]));
	    }
	
	    var summ = 0;
	    for (i = 0; i < test.length; i++) {
	        summ += test[i] * arr[i];
	    }
	
	    res = summ % 11;
	    res = res % 10;
	
	    if (res === 10) {
	        res = 0;
	    }
	
	    return res;
	};
	/* Формат КПП и ИНН в соответствии с Приказом ФНС РФ от 29.06.2012 № ММВ-7-6/435@ */
	jQuery.validator.addMethod('KPP_RUS', function (value) {
	    return (/^[\d]{4}[\dA-Z]{2}[\d]{3}$/.test(value) || value === ''
	    );
	}, 'Enter valid KPP');
	jQuery.validator.addMethod('INN_RUS', function (value) {
	    var res = /^[\d]{10}$/.test(value) || /^[\d]{12}$/.test(value);
	    if (!res) {
	        return res;
	    }
	
	    switch (value.length) {
	        case 10:
	            res = parseInt(value[9]) === getControlSum(value, 9);
	            break;
	        case 12:
	            res = parseInt(value[10]) === getControlSum(value, 10) && parseInt(value[11]) === getControlSum(value, 11);
	            break;
	        default:
	            res = false;
	            break;
	    }
	
	    return res;
	}, 'Enter valid INN');

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(300);
	var form = __webpack_require__(318);
	
	jQuery(function () {
	    var specialRegGiftPromptHtml = '<div class="special-action special-action--blue">' + '<img class="special-action__bg-img" src="local/assets/img/bg-reg-gift.jpg" alt="1000 РУБЛЕЙ за регистрацию" />' + '<div class="special-action__content">' + '<div class="special-action__box special-action__box--white">' + '<span class="special-action__box-big-text">1000 рублей</span> <span class="special-action__box-normal-text">за регистрацию</span>' + '</div>' + '<div class="form form--fullwidth">' + '<div class="form__field icon-field icon-field--man">' + '<div class="icon-field icon-field--man">' + '<input type="email" name="quick_reg_email" placeholder="Введите e-mail" class="form__input form__input--shade icon-field__input" />' + '</div>' + '</div>' + '<div class="form__field jqibuttons">' + '<button class="btn-def btn-def--pink btn-def--w100" value="quick-reg">Зарегистрироваться</button>' + '</div>' + '</div>' + '</div>' + '</div>';
	
	    var specialRegBenefitsPromptHtml = '<div class="special-action special-action--dark-pink">' + '<img class="special-action__bg-img" src="local/assets/img/bg-reg-gift-2.jpg" alt="1000 РУБЛЕЙ за регистрацию" />' + '<div class="special-action__content">' + '<ol class="reg-benefits reg-benefits--compact">' + '<li class="reg-benefits__item">Если вы косметолог, Вы можете покупать товары по <b>ОПТОВОЙ ЦЕНЕ!</b></li>' + '<li class="reg-benefits__item"><b>1000 РУБЛЕЙ</b> в&nbsp;подарок на первую покупку</li>' + '<li class="reg-benefits__item">Зарегистрируйтесь и получите электронную книгу в <b>ПОДАРОК!</b></li>' + '</ol>' + '<div class="form form--fullwidth">' + '<div class="form__field icon-field icon-field--man">' + '<div class="icon-field icon-field--man">' + '<input type="email" name="quick_reg_email" placeholder="Введите e-mail" class="form__input form__input--shade icon-field__input" />' + '</div>' + '</div>' + '<div class="form__field form__field--nomargin jqibuttons">' + '<button class="btn-def btn-def--w100" value="quick-reg">Зарегистрироваться</button>' + '</div>' + '</div>' + '</div>' + '</div>';
	
	    function promoSubmit(e, v, m) {
	        e.preventDefault();
	        var $params = $.extend({}, form.formValidateDefaults, {
	            rules: {
	                quick_reg_email: { required: true, email: true }
	            },
	            messages: {
	                quick_reg_email: {
	                    required: 'Не указан e-mail',
	                    email: 'Указан неверный e-mail'
	                }
	            },
	            submitHandler: function submitHandler() {
	                //form.submit();
	
	                // данные формы:
	                // console.log(f);
	
	                //тест. все поля заполнены верно
	                $.prompt.getState('state0').find('.form').html('<p>Регистрация</p>');
	                //т.к. изменилась высота блока, надо его подвинуть в видимую часть окна,
	                // чтобы не казалось, будто он совсем пропал с экрана
	                $.prompt.position();
	                //$.prompt.close();
	            }
	        });
	        var $form = m.closest('form');
	        $form.validate($params);
	    }
	
	    $('.js-show-reg-gift-popup').click(function (e) {
	        e.preventDefault();
	
	        $.prompt(specialRegGiftPromptHtml, {
	            buttons: {},
	            persistent: false, //чтобы можно было закрыть при клике по оверлею
	            classes: {
	                prompt: 'prompt--large',
	                form: 'prompt__form-special',
	                close: 'jqiclose--cross jqiclose--pink-cross'
	            },
	            submit: promoSubmit
	        });
	    });
	
	    $('.js-show-reg-benefits-popup').click(function (e) {
	        e.preventDefault();
	
	        $.prompt(specialRegBenefitsPromptHtml, {
	            buttons: {},
	            persistent: false, //чтобы можно было закрыть при клике по оверлею
	            classes: {
	                prompt: 'prompt--large',
	                form: 'prompt__form-special',
	                close: 'jqiclose--cross jqiclose--pink-cross'
	            },
	            submit: promoSubmit
	        });
	    });
	});

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _modulesPreloader = __webpack_require__(120);
	
	var _modulesPreloader2 = _interopRequireDefault(_modulesPreloader);
	
	var _modulesYandexSmartCaptchaYandexSmartCaptcha = __webpack_require__(299);
	
	__webpack_require__(472);
	var form = __webpack_require__(318);
	
	jQuery(function ($) {
	    var trackers = new _trackerTracker2['default']();
	    var contactsPrompt = {
	        callback: {
	            html: $('.js-callback-forms').remove().html(),
	            submit: function submit(e, v, m) {
	                e.preventDefault();
	                var callbackForm = m.closest('form');
	                trackers.onCallBackButton();
	                var params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        callback_phone: {
	                            required: true,
	                            phoneMask: true
	                        },
	                        callback_approval: {
	                            required: true
	                        }
	                    },
	                    messages: {
	                        callback_phone: {
	                            required: $.validator.messages.callback_phone.required,
	                            phoneMask: $.validator.messages.callback_phone.phoneMask
	                        },
	                        callback_approval: {
	                            required: $.validator.messages.callback_approval.required
	                        }
	                    },
	                    submitHandler: function submitHandler() {
	                        $('.form__captcha-error').removeClass('form__error-msg');
	                        $('.form__captcha-error').html(' ');
	                        var loader = new _modulesPreloader2['default']();
	                        loader.show();
	                        $.ajax({
	                            type: 'POST',
	                            url: '/ajax/action/callback_form/callback/',
	                            data: callbackForm.serialize(),
	                            dataType: 'json',
	                            success: function success(response) {
	                                loader.hide();
	                                if (response.code === 200) {
	                                    $.prompt.goToState('successCallbackMessage');
	                                    trackers.onCallBackRequestSend();
	                                    trackers.onPMfrmCallMe();
	                                } else {
	                                    var errorDiv = $('<div/>', {
	                                        'class': 'form__error-msg',
	                                        text: response.data.error
	                                    });
	                                    callbackForm.find('.form').prepend(errorDiv);
	                                }
	                            }
	                        });
	                    }
	                });
	
	                callbackForm.validate(params);
	            }
	        },
	
	        successCallbackMessage: {
	            html: function html() {
	                return '  <div class="prompt__content">\n' + '       <p>Сообщение успешно отправлено.</p>\n' + '    </div>';
	            }
	        }
	    };
	
	    $(document).on('click', '.callback__btn', function (e) {
	        e.preventDefault();
	        trackers.onCallBackFormShow();
	        $.prompt(contactsPrompt, {
	            initialState: 'callback',
	            statechanging: function statechanging(e, from, to) {
	                if (to !== 'callback') {
	                    return;
	                }
	                new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('callback_captcha').init();
	            }
	        });
	    });
	
	    $(document).on('click', '.callback__menu', function (e) {
	        e.preventDefault();
	        trackers.onCallBackFormShow();
	        trackers.onPMbtnCallMe();
	        //window.grecaptcha = window.grecaptcha ? window.grecaptcha : {};
	        $.prompt(contactsPrompt, {
	            initialState: 'callback',
	            statechanging: function statechanging(e, from, to) {
	                if (to !== 'callback') {
	                    return;
	                }
	                //window.Recaptchafree.render();
	                new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('callback_captcha').init();
	            }
	        });
	    });
	
	    $('.js-feedback-form').submit(function (e) {
	        e.preventDefault();
	        var $this = $(this);
	        var params = $.extend({}, form.formValidateDefaults, {
	            rules: {
	                feedback_name: { required: true },
	                feedback_city: { required: true },
	                feedback_phone: {
	                    phoneMask: true
	                }
	            },
	            messages: {
	                feedback_name: {
	                    required: $.validator.messages.feedback_name.required
	                },
	                feedback_city: {
	                    required: $.validator.messages.feedback_city.required
	                },
	                feedback_phone: {
	                    phoneMask: $.validator.messages.feedback_phone.phoneMask
	                }
	            },
	            submitHandler: function submitHandler() {
	                $('.form__captcha-error').removeClass('form__error-msg');
	                $('.form__captcha-error').html(' ');
	                $.ajax({
	                    type: 'POST',
	                    url: '/ajax/action/feedback_form/feedback/',
	                    data: $this.serialize(),
	                    dataType: 'json',
	                    success: function success(response) {
	                        if (response.code == 200) {
	                            $('.js-form-reset').trigger('click');
	                            $this.find('.form__input--correct').each(function (i, element) {
	                                $(element).removeClass('form__input--correct');
	                            });
	                            trackers.onPMfrmCallMeContact();
	                            $.prompt(contactsPrompt, {
	                                initialState: 'successFeedbackMessage'
	                            });
	                        } else {
	                            var errorDiv = $('<div/>', {
	                                'class': 'form__error-msg',
	                                text: response.error
	                            });
	                            $this.find('.form__head-label').after(errorDiv);
	                        }
	                    }
	                });
	            }
	        });
	        $this.validate(params);
	        $this.valid();
	    });
	});

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */,
/* 474 */,
/* 475 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */,
/* 477 */
/***/ (function(module, exports) {

	'use strict';
	
	jQuery(function () {
	    $('.social-block-on-pages').click(function () {
	        var classActive = $('.social-block-on-pages_hidden').hasClass('active');
	        if (classActive == true) {
	            $('.social-block-on-pages_hidden').removeClass('active');
	        } else {
	            $('.social-block-on-pages_hidden').addClass('active');
	        }
	    });
	});

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(479);
	
	__webpack_require__(175);
	__webpack_require__(481);
	
	var slickDefaults = __webpack_require__(49);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    function setProductCard($card) {
	        if ($card == undefined) $card = $('.product-card');
	
	        var $cardPreviews = $card.find('.js-slick-previews:visible');
	        var $cardPreviewsCompact = $card.find('.js-slick-previews-compact:visible');
	
	        if ($cardPreviews.length > 0) {
	            $cardPreviews.slick($.extend({}, slickDefaults.params, {
	                slidesToShow: 4,
	                vertical: false,
	                verticalSwiping: false,
	                responsive: [{
	                    breakpoint: size.tabletBig,
	                    settings: { slidesToShow: 4 }
	                }, {
	                    breakpoint: size.mobileBig,
	                    settings: { slidesToShow: 2 }
	                }, {
	                    breakpoint: size.mobile,
	                    settings: { slidesToShow: 2 }
	                }, {
	                    breakpoint: size.tablet,
	                    settings: {
	                        slidesToShow: 3
	                    }
	                }]
	            }));
	        }
	
	        /* if ($cardPreviewsCompact.length > 0) {
	            $cardPreviewsCompact.slick(
	                $.extend({}, slickDefaults.params, {
	                    slidesToShow: 4,
	                    vertical: true,
	                    verticalSwiping: true,
	                    responsive: [
	                        {
	                            breakpoint: size.desktop,
	                            settings: {
	                                slidesToShow: 4,
	                                vertical: false,
	                                verticalSwiping: false
	                            }
	                        },
	                        {
	                            breakpoint: size.tabletBig,
	                            settings: {
	                                slidesToShow: 3,
	                                vertical: false,
	                                verticalSwiping: false
	                            }
	                        },
	                        {
	                            breakpoint: size.tablet,
	                            settings: {
	                                slidesToShow: 4,
	                                vertical: true,
	                                verticalSwiping: true
	                            }
	                        }
	                    ]
	                })
	            );
	        }*/
	    }
	
	    setProductCard();
	
	    $(document).on('click', '.js-change-main-img', function (e) {
	        e.preventDefault();
	        var $this = $(this);
	        var $mainImg = $this.closest('.product-card').find('#product-card-main-img');
	        var $mainVideo = $this.closest('.product-card').find('#product-card-main-video');
	        var $video = $('#product-card-main-video').get(0);
	        var bigImgSrc = $this.data('big-img');
	        console.log($this);
	        var classCurrent = 'product-card__previews-item--current';
	
	        $this.closest('.product-card__previews').find('.' + classCurrent).removeClass(classCurrent);
	
	        $this.addClass(classCurrent);
	
	        if ($this.hasClass('product-detail__images-slider-item--video')) {
	            $mainImg.fadeOut(100, function () {
	                $mainVideo.fadeIn();
	                $video.play();
	            });
	        }
	
	        var img = new Image();
	        img.onload = function () {
	            $mainImg.fadeOut(1, function () {
	
	                $mainImg.fadeIn(300);
	                $mainVideo.fadeOut('1', function () {
	                    $video.pause();
	                });
	
	                $mainImg.removeClass('item--pdf');
	                if ($this.hasClass('product-detail__images-slider-item--pdf')) {
	                    $mainImg.attr('data-href', $this.attr('href'));
	                    $mainImg.addClass('item--pdf');
	                }
	                console.log($this);
	                $mainImg.attr('src', bigImgSrc);
	            });
	        };
	        img.src = bigImgSrc;
	    });
	
	    $(document).on('click', '.item--pdf', function (e) {
	        var $this = $(this);
	        window.open($this.attr('data-href'));
	    });
	});

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */,
/* 481 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */,
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerEvents = __webpack_require__(131);
	
	var _trackerEvents2 = _interopRequireDefault(_trackerEvents);
	
	var _modulesPreloader = __webpack_require__(120);
	
	var _modulesPreloader2 = _interopRequireDefault(_modulesPreloader);
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	//import { MindboxOperation } from '../../modules/mindbox/mindbox-operation';
	
	__webpack_require__(300);
	__webpack_require__(392);
	__webpack_require__(484);
	
	var event = new _trackerEvents2['default']();
	
	var Basket = __webpack_require__(222);
	
	jQuery(function () {
	    var trackers = new _trackerTracker2['default']();
	    //const mindboxOperation = new MindboxOperation();
	    //закрытие popup окна по клику на кнопку вернуться к покупкам
	    $('body').on('click', 'button.js-close-btn', function (e) {
	        e.preventDefault();
	        $.prompt.close();
	    });
	
	    //Кнопка добавить в корзину
	    $('body').on('click', '.js-add-2-cart', function (e) {
	        e.preventDefault();
	        var iQuantity = $('input[name="product_quantity"]').val();
	
	        var path = window.location.pathname;
	        var isBasketPage = path.includes('/basket/');
	
	        var isBasketRefresh = $(this).data('basket-refresh');
	        if (typeof isBasketRefresh === 'undefined') {
	            isBasketRefresh = isBasketPage;
	        }
	
	        trackers.getTracker('gtm').onAddToCart();
	
	        if (!$.isNumeric(iQuantity)) {
	            iQuantity = 1;
	        }
	
	        var productId = $(this).data('product-id');
	        var $this = $(this);
	        var data = {
	            product_id: productId,
	            quantity: iQuantity
	        };
	
	        var product_name = $this.parent().parent().find('.product__name').data('name');
	
	        $.ajax({
	            url: '/ajax/action/basket_add_popup/add_to_basket_without_popup/',
	            data: data,
	            success: function success(result) {
	                $this.removeClass('js-add-2-cart');
	                $this.text(result.data.BUTTON_TEXT.toUpperCase());
	
	                if ($this.hasClass('product-card__btn')) {
	                    $this.attr('href', result.data.PATH_TO_BASKET);
	                    $('.js-product-quantity').hide();
	                }
	
	                if ($this.hasClass('product-detail__action-btn')) {
	                    $this.attr('href', result.data.PATH_TO_BASKET);
	                }
	
	                if ($this.hasClass('product__btn')) {
	                    $this.removeClass('product__btn-buy');
	                    $this.addClass('product__btn-detail');
	                    $this.addClass('js-go-to-basket');
	                    $this.attr('data-href', result.data.PATH_TO_BASKET);
	                }
	
	                // ПЕРЕЗАГРУЗКА СТРАНИЦЫ
	                if (isBasketRefresh) {
	                    location.reload();
	                    return;
	                }
	
	                trackers.onPMbtnAddToCart({ param: product_name });
	                window.updateMiniBasket();
	                window.pushNewCartItem(productId, iQuantity);
	                window.smartBuyTracker.basketItemAdded({ id: productId });
	            }
	        });
	    });
	    //Кнопка добавить в корзину в шаблоне Протокол
	    $('body').on('click', '.js-add-2-cart--protocol', function (e) {
	        e.preventDefault();
	        var iQuantity = $('input[name="product_quantity"]').val();
	
	        trackers.getTracker('gtm').onAddToCart();
	
	        if (!$.isNumeric(iQuantity)) {
	            iQuantity = 1;
	        }
	        var productId = $(this).data('product-id');
	
	        var productIds = [];
	        if (productId.length) {
	            productIds = productId.split(',');
	        } else {
	            productIds.push(productId);
	        }
	
	        var $this = $(this);
	        $.each(productIds, function (key, value) {
	            var data = {
	                product_id: value,
	                quantity: iQuantity
	            };
	
	            var product_name = $this.parent().parent().find('.product__name').data('name');
	
	            $.ajax({
	                url: '/ajax/action/basket_add_popup/add_to_basket_without_popup/',
	                data: data,
	                success: function success(result) {
	                    if ($this.hasClass('product-card__btn')) {
	                        $this.attr('href', result.data.PATH_TO_BASKET);
	                        $('.js-product-quantity').hide();
	                    }
	                    if ($this.hasClass('product__btn')) {
	                        $this.removeClass('product__btn-buy');
	                        $this.addClass('product__btn-detail');
	                        $this.addClass('js-go-to-basket');
	                        $this.attr('data-href', result.data.PATH_TO_BASKET);
	                    }
	
	                    trackers.onPMbtnAddToCart({ param: product_name });
	                    window.updateMiniBasket();
	                    window.smartBuyTracker.basketItemAdded({ id: productId });
	                }
	            });
	        });
	        $this.removeClass('js-add-2-cart');
	        $this.text('В корзине');
	        event.onAddToCardProduct($this);
	    });
	
	    //Кнопка комплексной покупки
	    $('body').on('click', '.js-complex-buy', function (e) {
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/component/maximaster:basket.add.popup/complex/?POPUP=Y&COMPLEX=Y&PRODUCT_ID=' + $(this).data('product-id'),
	            success: function success(result) {
	                $.prompt(result.html, {
	                    buttons: {},
	                    persistent: false, //чтобы можно было закрыть при клике по оверлею
	                    classes: {
	                        prompt: 'prompt--large',
	                        form: 'prompt__form-special',
	                        close: 'jqiclose--cross'
	                    },
	                    submit: function submit(e) {
	                        e.preventDefault();
	                        window.updateMiniBasket();
	                    }
	                });
	            }
	        });
	    });
	
	    //Добавление в корзину при изменинии кол-ва в инпуте
	    $('body').on('change', 'input.js-quantity-input-basket', function () {
	        var basket = new Basket();
	        basket.updateProductQuantity($(this).data('product-id'), $(this).val(), $(this).data('parent-product-id'));
	    });
	
	    //Добавление в корзину при изменении кол-ва кнопками
	    $('body').on('click', '.quantity__btn', function () {
	        if ($(this).hasClass('js-quantity-minus-basket') || $(this).hasClass('js-quantity-plus-basket')) {
	            var iQuantity = $('input[name="QUANTITY_' + $(this).data('product-id') + '"]').val();
	            if ($(this).hasClass('js-quantity-plus')) {
	                iQuantity++;
	            } else if ($(this).hasClass('js-quantity-minus') && iQuantity > 0) {
	                iQuantity--;
	            }
	            var basket = new Basket();
	            basket.updateProductQuantity($(this).data('product-id'), iQuantity, $(this).data('parent-product-id'));
	        }
	    });
	
	    //Кнопка уведомить при поступлении товара
	    $(document).on('click', '.js-cart-inform', function (e) {
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/component/maximaster:element.arrival.inform/.default/',
	            data: {
	                ELEMENT_ID: $(this).data('product-id')
	            },
	            success: function success(result) {
	                $.prompt(result.html, {
	                    buttons: {},
	                    persistent: false, //чтобы можно было закрыть при клике по оверлею
	                    classes: {
	                        prompt: 'prompt--large',
	                        form: 'prompt__form-special',
	                        close: 'jqiclose--cross'
	                    },
	                    submit: function submit(e) {
	                        e.preventDefault();
	                        $.ajax({
	                            url: '/ajax/action/element_arrival_inform/add_to_sch_list/',
	                            data: $('form.jqiform').serialize(),
	                            success: function success(result) {
	                                $('#subscribe__content').html(result.html);
	                            }
	                        });
	                    }
	                });
	            }
	        });
	    });
	
	    $('.js-beautician-price-request-tooltip').tooltipster({
	        content: $('.js-beautician-price-request-tooltip-content').html(),
	        interactive: true,
	        contentAsHTML: true,
	        position: 'bottom',
	        maxWidth: 320,
	        minWidth: 320,
	
	        repositionOnScroll: true,
	        side: ['bottom', 'top'],
	        trigger: 'custom',
	        triggerOpen: {
	            mouseenter: true,
	            tap: true
	        },
	        triggerClose: {
	            mouseleave: true,
	            tap: true
	        },
	        updateAnimation: null
	    });
	    $('.js-product-subscribe-request-tooltip').tooltipster({
	        content: $('.js-product-subscribe-request-tooltip-content').html(),
	        interactive: true,
	        contentAsHTML: true,
	        position: 'bottom',
	        maxWidth: 320,
	        minWidth: 320,
	
	        repositionOnScroll: true,
	        side: ['bottom', 'top'],
	        trigger: 'custom',
	        triggerOpen: {
	            mouseenter: true,
	            tap: true
	        },
	        triggerClose: {
	            mouseleave: true,
	            tap: true
	        },
	        updateAnimation: null
	    });
	
	    $(document).on('click', '.js-product-subscribe', function (e) {
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/component/maximaster:widget.product.subscribe/.default/',
	            data: {
	                ELEMENT_ID: $(this).data('product-id')
	            },
	            success: function success(result) {
	                $('.js-product-subscribe-request-tooltip').tooltipster('hide');
	                $.prompt(result.html, {
	                    buttons: {},
	                    persistent: true, //чтобы можно было закрыть при клике по оверлею
	                    classes: {
	                        form: 'product-subscribe-request-form'
	                    },
	                    submit: function submit(e, v, m, form) {
	                        e.preventDefault();
	                        var preLoader = new _modulesPreloader2['default']();
	                        preLoader.show();
	                        var formData = new FormData();
	                        for (var _name in form) {
	                            formData.append(_name, form[_name]);
	                        }
	                        $.ajax({
	                            url: '/ajax/action/widget_product_subscribe/submit_form/',
	                            data: formData,
	                            processData: false,
	                            contentType: false,
	                            type: 'POST',
	                            cache: false,
	                            success: function success(response) {
	                                preLoader.hide();
	                                if (response['code'] === 400) {
	                                    $('.js-product-subscribe-request-error').html(response.message);
	                                    return;
	                                }
	                                $('.js-product-subscribe-request-container').html(response.html);
	                            }
	                        });
	                    }
	                });
	            }
	        });
	    });
	    $(document).on('click', '.js-beautician-price-request', function (e) {
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/component/maximaster:widget.beautician.price.request/.default/',
	            data: {
	                ELEMENT_ID: $(this).data('product-id')
	            },
	            success: function success(result) {
	                $('.js-beautician-price-request-tooltip').tooltipster('hide');
	                $.prompt(result.html, {
	                    buttons: {},
	                    persistent: true, //чтобы можно было закрыть при клике по оверлею
	                    classes: {
	                        form: 'beautician-price-request-form'
	                    },
	                    submit: function submit(e, v, m, form) {
	                        e.preventDefault();
	
	                        var preLoader = new _modulesPreloader2['default']();
	                        preLoader.show();
	
	                        var files = $('.js-attach-file-input-controll')[0].files;
	                        var formData = new FormData();
	                        for (var _name2 in form) {
	                            formData.append(_name2, form[_name2]);
	                        }
	
	                        for (var k = 0; k <= files.length; k++) {
	                            if (files[k]) {
	                                formData.append('ATTACH_FILES[]', files[k]);
	                            }
	                        }
	
	                        $.ajax({
	                            url: '/ajax/action/widget_beautician_price_request/submit_form/',
	                            data: formData,
	                            processData: false,
	                            contentType: false,
	                            type: 'POST',
	                            cache: false,
	                            success: function success(response) {
	                                preLoader.hide();
	                                if (response['code'] === 400) {
	                                    $('.js-beautician-price-request-error').html(response.message);
	                                    return;
	                                }
	                                $('.js-beautician-price-request-container').html(response.html);
	                            }
	                        });
	                    }
	                });
	            }
	        });
	    });
	
	    $(document).on('click', '.js-btn-detail', function (e) {
	        e.preventDefault();
	        var element = e.target;
	        window.location = element.getAttribute('data-href');
	    });
	
	    $(document).on('click', '.js-go-to-basket', function (e) {
	        e.preventDefault();
	        var element = e.target;
	        window.location = element.getAttribute('data-href');
	    });
	
	    $(document).on('click', '.js-close-window', function (e) {
	        e.preventDefault();
	        $.prompt.close();
	    });
	});

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var trackers = new _trackerTracker2['default']();
	
	var pushNewCartItem = function pushNewCartItem(productId, quantity) {
	    var ajaxData = {
	        productId: productId,
	        quantity: quantity
	    };
	    $.ajax({
	        url: '/ajax/action/basket_add_popup/get_data_layer/',
	        type: 'post',
	        async: false,
	        data: ajaxData,
	        success: function success(result) {
	            if (result.data.productData !== undefined) {
	                trackers.onAddToCart({
	                    fbpixel: {
	                        content_name: result.data.productData.name,
	                        value: result.data.productData.price
	                    },
	                    gtm: {
	                        ecommerce: {
	                            add: {
	                                products: [result.data.productData]
	                            }
	                        }
	                    }
	                });
	            }
	        },
	        error: function error() {
	            console.log('Error getDataLayer');
	        }
	    });
	};
	
	window.pushNewCartItem = pushNewCartItem;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	__webpack_require__(486);
	
	var Quantity = (function () {
	    /**
	     * В конструктор передается изменямый элемент
	     * @param element {HTMLElement}
	     */
	
	    function Quantity(element) {
	        _classCallCheck(this, Quantity);
	
	        this.element = $(element);
	        this.block = this.element.closest('.js-quantity-block');
	        this.input = this.block.find('.quantity__value');
	    }
	
	    /**
	     * Изменить количество
	     * @param callback {Function}
	     * @returns {boolean}
	     */
	
	    _createClass(Quantity, [{
	        key: 'change',
	        value: function change(callback) {
	            if (this.block.hasClass('js-quantity-block-disabled')) return false;
	
	            var curValue = parseInt(this.input.val());
	            if (isNaN(curValue)) {
	                curValue = 0;
	            }
	
	            if (callback === undefined || callback(this.input, curValue)) {
	                this.input.val(curValue);
	            }
	        }
	
	        /**
	         * Увеличить количество
	         * @param callback {Function}
	         * @returns {boolean}
	         */
	    }, {
	        key: 'plus',
	        value: function plus(callback) {
	            if (this.block.hasClass('js-quantity-block-disabled')) return false;
	
	            var curValue = parseInt(this.input.val());
	            curValue += 1;
	
	            if (callback === undefined || callback(this.input, curValue)) {
	                this.input.val(curValue);
	            }
	        }
	
	        /**
	         * Уменьшить количество
	         * @param callback {Function}
	         * @returns {boolean}
	         */
	    }, {
	        key: 'minus',
	        value: function minus(callback) {
	            if (this.block.hasClass('js-quantity-block-disabled')) return false;
	
	            var curValue = parseInt(this.input.val());
	            curValue -= 1;
	
	            if (curValue < 0) curValue = 0;
	
	            if (callback === undefined || callback(this.input, curValue)) {
	                this.input.val(curValue);
	            }
	        }
	    }]);
	
	    return Quantity;
	})();
	
	module.exports = Quantity;
	
	jQuery(function () {
	    $('.js-quantity-block').each(function () {
	        var $block = $(this);
	        var $btnMinus = $block.find('.quantity__minus');
	        var $btnPlus = $block.find('.quantity__plus');
	
	        //чтобы при быстром кликаньи по кнопкам не срабатывало выделение текста в инпуте
	        $btnMinus.add($btnPlus).mousedown(function (e) {
	            e.stopPropagation();
	            e.preventDefault();
	            return false;
	        });
	
	        if ($block.hasClass('js-quantity-block-disabled')) return false;
	    });
	
	    $(document).on('change', '.js-quantity-input', function () {
	        var quantity = new Quantity(this);
	        quantity.change();
	    });
	
	    $(document).on('click', '.js-quantity-plus', function () {
	        var quantity = new Quantity(this);
	        quantity.plus();
	    });
	
	    $(document).on('click', '.js-quantity-minus', function () {
	        var quantity = new Quantity(this);
	        quantity.minus();
	    });
	});

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */,
/* 488 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */,
/* 490 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */,
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mindboxCarousel = __webpack_require__(493);
	
	var MindboxProductsRecommendations = (function () {
	    function MindboxProductsRecommendations() {
	        _classCallCheck(this, MindboxProductsRecommendations);
	
	        this.container = (0, _jquery2['default'])('[data-mindbox-product="personal"]');
	    }
	
	    _createClass(MindboxProductsRecommendations, [{
	        key: 'init',
	        value: function init() {
	            if (this.container.length === 0) {
	                return;
	            }
	
	            var _self = this;
	            _jquery2['default'].ajax({
	                url: '/ajax/action/widget_mindbox_products/get_personal_products/',
	                type: 'GET',
	                success: function success(result) {
	                    if (result.data.status !== 'ok') {
	                        console.log('mindbox box not render');
	                        return;
	                    }
	
	                    _self.container.html(result.html);
	                    _mindboxCarousel.MindboxCarousel.init();
	                }
	            });
	        }
	    }]);
	
	    return MindboxProductsRecommendations;
	})();
	
	exports.MindboxProductsRecommendations = MindboxProductsRecommendations;
	
	jQuery(function () {
	    new MindboxProductsRecommendations().init();
	});

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(494);
	
	__webpack_require__(495);
	
	var MindboxCarousel = (function () {
	    function MindboxCarousel() {
	        _classCallCheck(this, MindboxCarousel);
	    }
	
	    _createClass(MindboxCarousel, null, [{
	        key: 'init',
	        value: function init(responsive) {
	            (0, _jquery2['default'])('.js-owl-carousel-mindbox').owlCarousel({
	                margin: 20,
	                stagePadding: true,
	                loop: true,
	                nav: true,
	                navText: [],
	                dots: false,
	                pagination: true,
	                responsive: responsive ? responsive : {
	                    0: {
	                        items: 2,
	                        dots: true
	                    },
	                    481: {
	                        items: 2,
	                        dots: true
	                    },
	                    768: {
	                        items: 3,
	                        nav: true
	                    },
	                    992: {
	                        items: 4,
	                        nav: true
	                    },
	                    1200: {
	                        items: 5,
	                        nav: true
	                    }
	                }
	            });
	        }
	    }]);
	
	    return MindboxCarousel;
	})();

	exports.MindboxCarousel = MindboxCarousel;

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	/**
	 * Owl Carousel v2.3.4
	 * Copyright 2013-2018 David Deutsch
	 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
	 */
	/**
	 * Owl carousel
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 * @todo Lazy Load Icon
	 * @todo prevent animationend bubling
	 * @todo itemsScaleUp
	 * @todo Test Zepto
	 * @todo stagePadding calculate wrong active classes
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates a carousel.
		 * @class The Owl Carousel.
		 * @public
		 * @param {HTMLElement|jQuery} element - The element to create the carousel for.
		 * @param {Object} [options] - The options
		 */
		function Owl(element, options) {
	
			/**
			 * Current settings for the carousel.
			 * @public
			 */
			this.settings = null;
	
			/**
			 * Current options set by the caller including defaults.
			 * @public
			 */
			this.options = $.extend({}, Owl.Defaults, options);
	
			/**
			 * Plugin element.
			 * @public
			 */
			this.$element = $(element);
	
			/**
			 * Proxied event handlers.
			 * @protected
			 */
			this._handlers = {};
	
			/**
			 * References to the running plugins of this carousel.
			 * @protected
			 */
			this._plugins = {};
	
			/**
			 * Currently suppressed events to prevent them from being retriggered.
			 * @protected
			 */
			this._supress = {};
	
			/**
			 * Absolute current position.
			 * @protected
			 */
			this._current = null;
	
			/**
			 * Animation speed in milliseconds.
			 * @protected
			 */
			this._speed = null;
	
			/**
			 * Coordinates of all items in pixel.
			 * @todo The name of this member is missleading.
			 * @protected
			 */
			this._coordinates = [];
	
			/**
			 * Current breakpoint.
			 * @todo Real media queries would be nice.
			 * @protected
			 */
			this._breakpoint = null;
	
			/**
			 * Current width of the plugin element.
			 */
			this._width = null;
	
			/**
			 * All real items.
			 * @protected
			 */
			this._items = [];
	
			/**
			 * All cloned items.
			 * @protected
			 */
			this._clones = [];
	
			/**
			 * Merge values of all items.
			 * @todo Maybe this could be part of a plugin.
			 * @protected
			 */
			this._mergers = [];
	
			/**
			 * Widths of all items.
			 */
			this._widths = [];
	
			/**
			 * Invalidated parts within the update process.
			 * @protected
			 */
			this._invalidated = {};
	
			/**
			 * Ordered list of workers for the update process.
			 * @protected
			 */
			this._pipe = [];
	
			/**
			 * Current state information for the drag operation.
			 * @todo #261
			 * @protected
			 */
			this._drag = {
				time: null,
				target: null,
				pointer: null,
				stage: {
					start: null,
					current: null
				},
				direction: null
			};
	
			/**
			 * Current state information and their tags.
			 * @type {Object}
			 * @protected
			 */
			this._states = {
				current: {},
				tags: {
					'initializing': [ 'busy' ],
					'animating': [ 'busy' ],
					'dragging': [ 'interacting' ]
				}
			};
	
			$.each([ 'onResize', 'onThrottledResize' ], $.proxy(function(i, handler) {
				this._handlers[handler] = $.proxy(this[handler], this);
			}, this));
	
			$.each(Owl.Plugins, $.proxy(function(key, plugin) {
				this._plugins[key.charAt(0).toLowerCase() + key.slice(1)]
					= new plugin(this);
			}, this));
	
			$.each(Owl.Workers, $.proxy(function(priority, worker) {
				this._pipe.push({
					'filter': worker.filter,
					'run': $.proxy(worker.run, this)
				});
			}, this));
	
			this.setup();
			this.initialize();
		}
	
		/**
		 * Default options for the carousel.
		 * @public
		 */
		Owl.Defaults = {
			items: 3,
			loop: false,
			center: false,
			rewind: false,
			checkVisibility: true,
	
			mouseDrag: true,
			touchDrag: true,
			pullDrag: true,
			freeDrag: false,
	
			margin: 0,
			stagePadding: 0,
	
			merge: false,
			mergeFit: true,
			autoWidth: false,
	
			startPosition: 0,
			rtl: false,
	
			smartSpeed: 250,
			fluidSpeed: false,
			dragEndSpeed: false,
	
			responsive: {},
			responsiveRefreshRate: 200,
			responsiveBaseElement: window,
	
			fallbackEasing: 'swing',
			slideTransition: '',
	
			info: false,
	
			nestedItemSelector: false,
			itemElement: 'div',
			stageElement: 'div',
	
			refreshClass: 'owl-refresh',
			loadedClass: 'owl-loaded',
			loadingClass: 'owl-loading',
			rtlClass: 'owl-rtl',
			responsiveClass: 'owl-responsive',
			dragClass: 'owl-drag',
			itemClass: 'owl-item',
			stageClass: 'owl-stage',
			stageOuterClass: 'owl-stage-outer',
			grabClass: 'owl-grab'
		};
	
		/**
		 * Enumeration for width.
		 * @public
		 * @readonly
		 * @enum {String}
		 */
		Owl.Width = {
			Default: 'default',
			Inner: 'inner',
			Outer: 'outer'
		};
	
		/**
		 * Enumeration for types.
		 * @public
		 * @readonly
		 * @enum {String}
		 */
		Owl.Type = {
			Event: 'event',
			State: 'state'
		};
	
		/**
		 * Contains all registered plugins.
		 * @public
		 */
		Owl.Plugins = {};
	
		/**
		 * List of workers involved in the update process.
		 */
		Owl.Workers = [ {
			filter: [ 'width', 'settings' ],
			run: function() {
				this._width = this.$element.width();
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function(cache) {
				cache.current = this._items && this._items[this.relative(this._current)];
			}
		}, {
			filter: [ 'items', 'settings' ],
			run: function() {
				this.$stage.children('.cloned').remove();
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function(cache) {
				var margin = this.settings.margin || '',
					grid = !this.settings.autoWidth,
					rtl = this.settings.rtl,
					css = {
						'width': 'auto',
						'margin-left': rtl ? margin : '',
						'margin-right': rtl ? '' : margin
					};
	
				!grid && this.$stage.children().css(css);
	
				cache.css = css;
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function(cache) {
				var width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
					merge = null,
					iterator = this._items.length,
					grid = !this.settings.autoWidth,
					widths = [];
	
				cache.items = {
					merge: false,
					width: width
				};
	
				while (iterator--) {
					merge = this._mergers[iterator];
					merge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;
	
					cache.items.merge = merge > 1 || cache.items.merge;
	
					widths[iterator] = !grid ? this._items[iterator].width() : width * merge;
				}
	
				this._widths = widths;
			}
		}, {
			filter: [ 'items', 'settings' ],
			run: function() {
				var clones = [],
					items = this._items,
					settings = this.settings,
					// TODO: Should be computed from number of min width items in stage
					view = Math.max(settings.items * 2, 4),
					size = Math.ceil(items.length / 2) * 2,
					repeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,
					append = '',
					prepend = '';
	
				repeat /= 2;
	
				while (repeat > 0) {
					// Switch to only using appended clones
					clones.push(this.normalize(clones.length / 2, true));
					append = append + items[clones[clones.length - 1]][0].outerHTML;
					clones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));
					prepend = items[clones[clones.length - 1]][0].outerHTML + prepend;
					repeat -= 1;
				}
	
				this._clones = clones;
	
				$(append).addClass('cloned').appendTo(this.$stage);
				$(prepend).addClass('cloned').prependTo(this.$stage);
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function() {
				var rtl = this.settings.rtl ? 1 : -1,
					size = this._clones.length + this._items.length,
					iterator = -1,
					previous = 0,
					current = 0,
					coordinates = [];
	
				while (++iterator < size) {
					previous = coordinates[iterator - 1] || 0;
					current = this._widths[this.relative(iterator)] + this.settings.margin;
					coordinates.push(previous + current * rtl);
				}
	
				this._coordinates = coordinates;
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function() {
				var padding = this.settings.stagePadding,
					coordinates = this._coordinates,
					css = {
						'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,
						'padding-left': padding || '',
						'padding-right': padding || ''
					};
	
				this.$stage.css(css);
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function(cache) {
				var iterator = this._coordinates.length,
					grid = !this.settings.autoWidth,
					items = this.$stage.children();
	
				if (grid && cache.items.merge) {
					while (iterator--) {
						cache.css.width = this._widths[this.relative(iterator)];
						items.eq(iterator).css(cache.css);
					}
				} else if (grid) {
					cache.css.width = cache.items.width;
					items.css(cache.css);
				}
			}
		}, {
			filter: [ 'items' ],
			run: function() {
				this._coordinates.length < 1 && this.$stage.removeAttr('style');
			}
		}, {
			filter: [ 'width', 'items', 'settings' ],
			run: function(cache) {
				cache.current = cache.current ? this.$stage.children().index(cache.current) : 0;
				cache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));
				this.reset(cache.current);
			}
		}, {
			filter: [ 'position' ],
			run: function() {
				this.animate(this.coordinates(this._current));
			}
		}, {
			filter: [ 'width', 'position', 'items', 'settings' ],
			run: function() {
				var rtl = this.settings.rtl ? 1 : -1,
					padding = this.settings.stagePadding * 2,
					begin = this.coordinates(this.current()) + padding,
					end = begin + this.width() * rtl,
					inner, outer, matches = [], i, n;
	
				for (i = 0, n = this._coordinates.length; i < n; i++) {
					inner = this._coordinates[i - 1] || 0;
					outer = Math.abs(this._coordinates[i]) + padding * rtl;
	
					if ((this.op(inner, '<=', begin) && (this.op(inner, '>', end)))
						|| (this.op(outer, '<', begin) && this.op(outer, '>', end))) {
						matches.push(i);
					}
				}
	
				this.$stage.children('.active').removeClass('active');
				this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');
	
				this.$stage.children('.center').removeClass('center');
				if (this.settings.center) {
					this.$stage.children().eq(this.current()).addClass('center');
				}
			}
		} ];
	
		/**
		 * Create the stage DOM element
		 */
		Owl.prototype.initializeStage = function() {
			this.$stage = this.$element.find('.' + this.settings.stageClass);
	
			// if the stage is already in the DOM, grab it and skip stage initialization
			if (this.$stage.length) {
				return;
			}
	
			this.$element.addClass(this.options.loadingClass);
	
			// create stage
			this.$stage = $('<' + this.settings.stageElement + '>', {
				"class": this.settings.stageClass
			}).wrap( $( '<div/>', {
				"class": this.settings.stageOuterClass
			}));
	
			// append stage
			this.$element.append(this.$stage.parent());
		};
	
		/**
		 * Create item DOM elements
		 */
		Owl.prototype.initializeItems = function() {
			var $items = this.$element.find('.owl-item');
	
			// if the items are already in the DOM, grab them and skip item initialization
			if ($items.length) {
				this._items = $items.get().map(function(item) {
					return $(item);
				});
	
				this._mergers = this._items.map(function() {
					return 1;
				});
	
				this.refresh();
	
				return;
			}
	
			// append content
			this.replace(this.$element.children().not(this.$stage.parent()));
	
			// check visibility
			if (this.isVisible()) {
				// update view
				this.refresh();
			} else {
				// invalidate width
				this.invalidate('width');
			}
	
			this.$element
				.removeClass(this.options.loadingClass)
				.addClass(this.options.loadedClass);
		};
	
		/**
		 * Initializes the carousel.
		 * @protected
		 */
		Owl.prototype.initialize = function() {
			this.enter('initializing');
			this.trigger('initialize');
	
			this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);
	
			if (this.settings.autoWidth && !this.is('pre-loading')) {
				var imgs, nestedSelector, width;
				imgs = this.$element.find('img');
				nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
				width = this.$element.children(nestedSelector).width();
	
				if (imgs.length && width <= 0) {
					this.preloadAutoWidthImages(imgs);
				}
			}
	
			this.initializeStage();
			this.initializeItems();
	
			// register event handlers
			this.registerEventHandlers();
	
			this.leave('initializing');
			this.trigger('initialized');
		};
	
		/**
		 * @returns {Boolean} visibility of $element
		 *                    if you know the carousel will always be visible you can set `checkVisibility` to `false` to
		 *                    prevent the expensive browser layout forced reflow the $element.is(':visible') does
		 */
		Owl.prototype.isVisible = function() {
			return this.settings.checkVisibility
				? this.$element.is(':visible')
				: true;
		};
	
		/**
		 * Setups the current settings.
		 * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
		 * @todo Support for media queries by using `matchMedia` would be nice.
		 * @public
		 */
		Owl.prototype.setup = function() {
			var viewport = this.viewport(),
				overwrites = this.options.responsive,
				match = -1,
				settings = null;
	
			if (!overwrites) {
				settings = $.extend({}, this.options);
			} else {
				$.each(overwrites, function(breakpoint) {
					if (breakpoint <= viewport && breakpoint > match) {
						match = Number(breakpoint);
					}
				});
	
				settings = $.extend({}, this.options, overwrites[match]);
				if (typeof settings.stagePadding === 'function') {
					settings.stagePadding = settings.stagePadding();
				}
				delete settings.responsive;
	
				// responsive class
				if (settings.responsiveClass) {
					this.$element.attr('class',
						this.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\S+\\s', 'g'), '$1' + match)
					);
				}
			}
	
			this.trigger('change', { property: { name: 'settings', value: settings } });
			this._breakpoint = match;
			this.settings = settings;
			this.invalidate('settings');
			this.trigger('changed', { property: { name: 'settings', value: this.settings } });
		};
	
		/**
		 * Updates option logic if necessery.
		 * @protected
		 */
		Owl.prototype.optionsLogic = function() {
			if (this.settings.autoWidth) {
				this.settings.stagePadding = false;
				this.settings.merge = false;
			}
		};
	
		/**
		 * Prepares an item before add.
		 * @todo Rename event parameter `content` to `item`.
		 * @protected
		 * @returns {jQuery|HTMLElement} - The item container.
		 */
		Owl.prototype.prepare = function(item) {
			var event = this.trigger('prepare', { content: item });
	
			if (!event.data) {
				event.data = $('<' + this.settings.itemElement + '/>')
					.addClass(this.options.itemClass).append(item)
			}
	
			this.trigger('prepared', { content: event.data });
	
			return event.data;
		};
	
		/**
		 * Updates the view.
		 * @public
		 */
		Owl.prototype.update = function() {
			var i = 0,
				n = this._pipe.length,
				filter = $.proxy(function(p) { return this[p] }, this._invalidated),
				cache = {};
	
			while (i < n) {
				if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
					this._pipe[i].run(cache);
				}
				i++;
			}
	
			this._invalidated = {};
	
			!this.is('valid') && this.enter('valid');
		};
	
		/**
		 * Gets the width of the view.
		 * @public
		 * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
		 * @returns {Number} - The width of the view in pixel.
		 */
		Owl.prototype.width = function(dimension) {
			dimension = dimension || Owl.Width.Default;
			switch (dimension) {
				case Owl.Width.Inner:
				case Owl.Width.Outer:
					return this._width;
				default:
					return this._width - this.settings.stagePadding * 2 + this.settings.margin;
			}
		};
	
		/**
		 * Refreshes the carousel primarily for adaptive purposes.
		 * @public
		 */
		Owl.prototype.refresh = function() {
			this.enter('refreshing');
			this.trigger('refresh');
	
			this.setup();
	
			this.optionsLogic();
	
			this.$element.addClass(this.options.refreshClass);
	
			this.update();
	
			this.$element.removeClass(this.options.refreshClass);
	
			this.leave('refreshing');
			this.trigger('refreshed');
		};
	
		/**
		 * Checks window `resize` event.
		 * @protected
		 */
		Owl.prototype.onThrottledResize = function() {
			window.clearTimeout(this.resizeTimer);
			this.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
		};
	
		/**
		 * Checks window `resize` event.
		 * @protected
		 */
		Owl.prototype.onResize = function() {
			if (!this._items.length) {
				return false;
			}
	
			if (this._width === this.$element.width()) {
				return false;
			}
	
			if (!this.isVisible()) {
				return false;
			}
	
			this.enter('resizing');
	
			if (this.trigger('resize').isDefaultPrevented()) {
				this.leave('resizing');
				return false;
			}
	
			this.invalidate('width');
	
			this.refresh();
	
			this.leave('resizing');
			this.trigger('resized');
		};
	
		/**
		 * Registers event handlers.
		 * @todo Check `msPointerEnabled`
		 * @todo #261
		 * @protected
		 */
		Owl.prototype.registerEventHandlers = function() {
			if ($.support.transition) {
				this.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));
			}
	
			if (this.settings.responsive !== false) {
				this.on(window, 'resize', this._handlers.onThrottledResize);
			}
	
			if (this.settings.mouseDrag) {
				this.$element.addClass(this.options.dragClass);
				this.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));
				this.$stage.on('dragstart.owl.core selectstart.owl.core', function() { return false });
			}
	
			if (this.settings.touchDrag){
				this.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));
				this.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));
			}
		};
	
		/**
		 * Handles `touchstart` and `mousedown` events.
		 * @todo Horizontal swipe threshold as option
		 * @todo #261
		 * @protected
		 * @param {Event} event - The event arguments.
		 */
		Owl.prototype.onDragStart = function(event) {
			var stage = null;
	
			if (event.which === 3) {
				return;
			}
	
			if ($.support.transform) {
				stage = this.$stage.css('transform').replace(/.*\(|\)| /g, '').split(',');
				stage = {
					x: stage[stage.length === 16 ? 12 : 4],
					y: stage[stage.length === 16 ? 13 : 5]
				};
			} else {
				stage = this.$stage.position();
				stage = {
					x: this.settings.rtl ?
						stage.left + this.$stage.width() - this.width() + this.settings.margin :
						stage.left,
					y: stage.top
				};
			}
	
			if (this.is('animating')) {
				$.support.transform ? this.animate(stage.x) : this.$stage.stop()
				this.invalidate('position');
			}
	
			this.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');
	
			this.speed(0);
	
			this._drag.time = new Date().getTime();
			this._drag.target = $(event.target);
			this._drag.stage.start = stage;
			this._drag.stage.current = stage;
			this._drag.pointer = this.pointer(event);
	
			$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));
	
			$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function(event) {
				var delta = this.difference(this._drag.pointer, this.pointer(event));
	
				$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));
	
				if (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {
					return;
				}
	
				event.preventDefault();
	
				this.enter('dragging');
				this.trigger('drag');
			}, this));
		};
	
		/**
		 * Handles the `touchmove` and `mousemove` events.
		 * @todo #261
		 * @protected
		 * @param {Event} event - The event arguments.
		 */
		Owl.prototype.onDragMove = function(event) {
			var minimum = null,
				maximum = null,
				pull = null,
				delta = this.difference(this._drag.pointer, this.pointer(event)),
				stage = this.difference(this._drag.stage.start, delta);
	
			if (!this.is('dragging')) {
				return;
			}
	
			event.preventDefault();
	
			if (this.settings.loop) {
				minimum = this.coordinates(this.minimum());
				maximum = this.coordinates(this.maximum() + 1) - minimum;
				stage.x = (((stage.x - minimum) % maximum + maximum) % maximum) + minimum;
			} else {
				minimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
				maximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
				pull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;
				stage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);
			}
	
			this._drag.stage.current = stage;
	
			this.animate(stage.x);
		};
	
		/**
		 * Handles the `touchend` and `mouseup` events.
		 * @todo #261
		 * @todo Threshold for click event
		 * @protected
		 * @param {Event} event - The event arguments.
		 */
		Owl.prototype.onDragEnd = function(event) {
			var delta = this.difference(this._drag.pointer, this.pointer(event)),
				stage = this._drag.stage.current,
				direction = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';
	
			$(document).off('.owl.core');
	
			this.$element.removeClass(this.options.grabClass);
	
			if (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {
				this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
				this.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));
				this.invalidate('position');
				this.update();
	
				this._drag.direction = direction;
	
				if (Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) {
					this._drag.target.one('click.owl.core', function() { return false; });
				}
			}
	
			if (!this.is('dragging')) {
				return;
			}
	
			this.leave('dragging');
			this.trigger('dragged');
		};
	
		/**
		 * Gets absolute position of the closest item for a coordinate.
		 * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
		 * @protected
		 * @param {Number} coordinate - The coordinate in pixel.
		 * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.
		 * @return {Number} - The absolute position of the closest item.
		 */
		Owl.prototype.closest = function(coordinate, direction) {
			var position = -1,
				pull = 30,
				width = this.width(),
				coordinates = this.coordinates();
	
			if (!this.settings.freeDrag) {
				// check closest item
				$.each(coordinates, $.proxy(function(index, value) {
					// on a left pull, check on current index
					if (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {
						position = index;
					// on a right pull, check on previous index
					// to do so, subtract width from value and set position = index + 1
					} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {
						position = index + 1;
					} else if (this.op(coordinate, '<', value)
						&& this.op(coordinate, '>', coordinates[index + 1] !== undefined ? coordinates[index + 1] : value - width)) {
						position = direction === 'left' ? index + 1 : index;
					}
					return position === -1;
				}, this));
			}
	
			if (!this.settings.loop) {
				// non loop boundries
				if (this.op(coordinate, '>', coordinates[this.minimum()])) {
					position = coordinate = this.minimum();
				} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
					position = coordinate = this.maximum();
				}
			}
	
			return position;
		};
	
		/**
		 * Animates the stage.
		 * @todo #270
		 * @public
		 * @param {Number} coordinate - The coordinate in pixels.
		 */
		Owl.prototype.animate = function(coordinate) {
			var animate = this.speed() > 0;
	
			this.is('animating') && this.onTransitionEnd();
	
			if (animate) {
				this.enter('animating');
				this.trigger('translate');
			}
	
			if ($.support.transform3d && $.support.transition) {
				this.$stage.css({
					transform: 'translate3d(' + coordinate + 'px,0px,0px)',
					transition: (this.speed() / 1000) + 's' + (
						this.settings.slideTransition ? ' ' + this.settings.slideTransition : ''
					)
				});
			} else if (animate) {
				this.$stage.animate({
					left: coordinate + 'px'
				}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));
			} else {
				this.$stage.css({
					left: coordinate + 'px'
				});
			}
		};
	
		/**
		 * Checks whether the carousel is in a specific state or not.
		 * @param {String} state - The state to check.
		 * @returns {Boolean} - The flag which indicates if the carousel is busy.
		 */
		Owl.prototype.is = function(state) {
			return this._states.current[state] && this._states.current[state] > 0;
		};
	
		/**
		 * Sets the absolute position of the current item.
		 * @public
		 * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
		 * @returns {Number} - The absolute position of the current item.
		 */
		Owl.prototype.current = function(position) {
			if (position === undefined) {
				return this._current;
			}
	
			if (this._items.length === 0) {
				return undefined;
			}
	
			position = this.normalize(position);
	
			if (this._current !== position) {
				var event = this.trigger('change', { property: { name: 'position', value: position } });
	
				if (event.data !== undefined) {
					position = this.normalize(event.data);
				}
	
				this._current = position;
	
				this.invalidate('position');
	
				this.trigger('changed', { property: { name: 'position', value: this._current } });
			}
	
			return this._current;
		};
	
		/**
		 * Invalidates the given part of the update routine.
		 * @param {String} [part] - The part to invalidate.
		 * @returns {Array.<String>} - The invalidated parts.
		 */
		Owl.prototype.invalidate = function(part) {
			if ($.type(part) === 'string') {
				this._invalidated[part] = true;
				this.is('valid') && this.leave('valid');
			}
			return $.map(this._invalidated, function(v, i) { return i });
		};
	
		/**
		 * Resets the absolute position of the current item.
		 * @public
		 * @param {Number} position - The absolute position of the new item.
		 */
		Owl.prototype.reset = function(position) {
			position = this.normalize(position);
	
			if (position === undefined) {
				return;
			}
	
			this._speed = 0;
			this._current = position;
	
			this.suppress([ 'translate', 'translated' ]);
	
			this.animate(this.coordinates(position));
	
			this.release([ 'translate', 'translated' ]);
		};
	
		/**
		 * Normalizes an absolute or a relative position of an item.
		 * @public
		 * @param {Number} position - The absolute or relative position to normalize.
		 * @param {Boolean} [relative=false] - Whether the given position is relative or not.
		 * @returns {Number} - The normalized position.
		 */
		Owl.prototype.normalize = function(position, relative) {
			var n = this._items.length,
				m = relative ? 0 : this._clones.length;
	
			if (!this.isNumeric(position) || n < 1) {
				position = undefined;
			} else if (position < 0 || position >= n + m) {
				position = ((position - m / 2) % n + n) % n + m / 2;
			}
	
			return position;
		};
	
		/**
		 * Converts an absolute position of an item into a relative one.
		 * @public
		 * @param {Number} position - The absolute position to convert.
		 * @returns {Number} - The converted position.
		 */
		Owl.prototype.relative = function(position) {
			position -= this._clones.length / 2;
			return this.normalize(position, true);
		};
	
		/**
		 * Gets the maximum position for the current item.
		 * @public
		 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
		 * @returns {Number}
		 */
		Owl.prototype.maximum = function(relative) {
			var settings = this.settings,
				maximum = this._coordinates.length,
				iterator,
				reciprocalItemsWidth,
				elementWidth;
	
			if (settings.loop) {
				maximum = this._clones.length / 2 + this._items.length - 1;
			} else if (settings.autoWidth || settings.merge) {
				iterator = this._items.length;
				if (iterator) {
					reciprocalItemsWidth = this._items[--iterator].width();
					elementWidth = this.$element.width();
					while (iterator--) {
						reciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;
						if (reciprocalItemsWidth > elementWidth) {
							break;
						}
					}
				}
				maximum = iterator + 1;
			} else if (settings.center) {
				maximum = this._items.length - 1;
			} else {
				maximum = this._items.length - settings.items;
			}
	
			if (relative) {
				maximum -= this._clones.length / 2;
			}
	
			return Math.max(maximum, 0);
		};
	
		/**
		 * Gets the minimum position for the current item.
		 * @public
		 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
		 * @returns {Number}
		 */
		Owl.prototype.minimum = function(relative) {
			return relative ? 0 : this._clones.length / 2;
		};
	
		/**
		 * Gets an item at the specified relative position.
		 * @public
		 * @param {Number} [position] - The relative position of the item.
		 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
		 */
		Owl.prototype.items = function(position) {
			if (position === undefined) {
				return this._items.slice();
			}
	
			position = this.normalize(position, true);
			return this._items[position];
		};
	
		/**
		 * Gets an item at the specified relative position.
		 * @public
		 * @param {Number} [position] - The relative position of the item.
		 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
		 */
		Owl.prototype.mergers = function(position) {
			if (position === undefined) {
				return this._mergers.slice();
			}
	
			position = this.normalize(position, true);
			return this._mergers[position];
		};
	
		/**
		 * Gets the absolute positions of clones for an item.
		 * @public
		 * @param {Number} [position] - The relative position of the item.
		 * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
		 */
		Owl.prototype.clones = function(position) {
			var odd = this._clones.length / 2,
				even = odd + this._items.length,
				map = function(index) { return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2 };
	
			if (position === undefined) {
				return $.map(this._clones, function(v, i) { return map(i) });
			}
	
			return $.map(this._clones, function(v, i) { return v === position ? map(i) : null });
		};
	
		/**
		 * Sets the current animation speed.
		 * @public
		 * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
		 * @returns {Number} - The current animation speed in milliseconds.
		 */
		Owl.prototype.speed = function(speed) {
			if (speed !== undefined) {
				this._speed = speed;
			}
	
			return this._speed;
		};
	
		/**
		 * Gets the coordinate of an item.
		 * @todo The name of this method is missleanding.
		 * @public
		 * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
		 * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
		 */
		Owl.prototype.coordinates = function(position) {
			var multiplier = 1,
				newPosition = position - 1,
				coordinate;
	
			if (position === undefined) {
				return $.map(this._coordinates, $.proxy(function(coordinate, index) {
					return this.coordinates(index);
				}, this));
			}
	
			if (this.settings.center) {
				if (this.settings.rtl) {
					multiplier = -1;
					newPosition = position + 1;
				}
	
				coordinate = this._coordinates[position];
				coordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;
			} else {
				coordinate = this._coordinates[newPosition] || 0;
			}
	
			coordinate = Math.ceil(coordinate);
	
			return coordinate;
		};
	
		/**
		 * Calculates the speed for a translation.
		 * @protected
		 * @param {Number} from - The absolute position of the start item.
		 * @param {Number} to - The absolute position of the target item.
		 * @param {Number} [factor=undefined] - The time factor in milliseconds.
		 * @returns {Number} - The time in milliseconds for the translation.
		 */
		Owl.prototype.duration = function(from, to, factor) {
			if (factor === 0) {
				return 0;
			}
	
			return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));
		};
	
		/**
		 * Slides to the specified item.
		 * @public
		 * @param {Number} position - The position of the item.
		 * @param {Number} [speed] - The time in milliseconds for the transition.
		 */
		Owl.prototype.to = function(position, speed) {
			var current = this.current(),
				revert = null,
				distance = position - this.relative(current),
				direction = (distance > 0) - (distance < 0),
				items = this._items.length,
				minimum = this.minimum(),
				maximum = this.maximum();
	
			if (this.settings.loop) {
				if (!this.settings.rewind && Math.abs(distance) > items / 2) {
					distance += direction * -1 * items;
				}
	
				position = current + distance;
				revert = ((position - minimum) % items + items) % items + minimum;
	
				if (revert !== position && revert - distance <= maximum && revert - distance > 0) {
					current = revert - distance;
					position = revert;
					this.reset(current);
				}
			} else if (this.settings.rewind) {
				maximum += 1;
				position = (position % maximum + maximum) % maximum;
			} else {
				position = Math.max(minimum, Math.min(maximum, position));
			}
	
			this.speed(this.duration(current, position, speed));
			this.current(position);
	
			if (this.isVisible()) {
				this.update();
			}
		};
	
		/**
		 * Slides to the next item.
		 * @public
		 * @param {Number} [speed] - The time in milliseconds for the transition.
		 */
		Owl.prototype.next = function(speed) {
			speed = speed || false;
			this.to(this.relative(this.current()) + 1, speed);
		};
	
		/**
		 * Slides to the previous item.
		 * @public
		 * @param {Number} [speed] - The time in milliseconds for the transition.
		 */
		Owl.prototype.prev = function(speed) {
			speed = speed || false;
			this.to(this.relative(this.current()) - 1, speed);
		};
	
		/**
		 * Handles the end of an animation.
		 * @protected
		 * @param {Event} event - The event arguments.
		 */
		Owl.prototype.onTransitionEnd = function(event) {
	
			// if css2 animation then event object is undefined
			if (event !== undefined) {
				event.stopPropagation();
	
				// Catch only owl-stage transitionEnd event
				if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
					return false;
				}
			}
	
			this.leave('animating');
			this.trigger('translated');
		};
	
		/**
		 * Gets viewport width.
		 * @protected
		 * @return {Number} - The width in pixel.
		 */
		Owl.prototype.viewport = function() {
			var width;
			if (this.options.responsiveBaseElement !== window) {
				width = $(this.options.responsiveBaseElement).width();
			} else if (window.innerWidth) {
				width = window.innerWidth;
			} else if (document.documentElement && document.documentElement.clientWidth) {
				width = document.documentElement.clientWidth;
			} else {
				console.warn('Can not detect viewport width.');
			}
			return width;
		};
	
		/**
		 * Replaces the current content.
		 * @public
		 * @param {HTMLElement|jQuery|String} content - The new content.
		 */
		Owl.prototype.replace = function(content) {
			this.$stage.empty();
			this._items = [];
	
			if (content) {
				content = (content instanceof jQuery) ? content : $(content);
			}
	
			if (this.settings.nestedItemSelector) {
				content = content.find('.' + this.settings.nestedItemSelector);
			}
	
			content.filter(function() {
				return this.nodeType === 1;
			}).each($.proxy(function(index, item) {
				item = this.prepare(item);
				this.$stage.append(item);
				this._items.push(item);
				this._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
			}, this));
	
			this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);
	
			this.invalidate('items');
		};
	
		/**
		 * Adds an item.
		 * @todo Use `item` instead of `content` for the event arguments.
		 * @public
		 * @param {HTMLElement|jQuery|String} content - The item content to add.
		 * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
		 */
		Owl.prototype.add = function(content, position) {
			var current = this.relative(this._current);
	
			position = position === undefined ? this._items.length : this.normalize(position, true);
			content = content instanceof jQuery ? content : $(content);
	
			this.trigger('add', { content: content, position: position });
	
			content = this.prepare(content);
	
			if (this._items.length === 0 || position === this._items.length) {
				this._items.length === 0 && this.$stage.append(content);
				this._items.length !== 0 && this._items[position - 1].after(content);
				this._items.push(content);
				this._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
			} else {
				this._items[position].before(content);
				this._items.splice(position, 0, content);
				this._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
			}
	
			this._items[current] && this.reset(this._items[current].index());
	
			this.invalidate('items');
	
			this.trigger('added', { content: content, position: position });
		};
	
		/**
		 * Removes an item by its position.
		 * @todo Use `item` instead of `content` for the event arguments.
		 * @public
		 * @param {Number} position - The relative position of the item to remove.
		 */
		Owl.prototype.remove = function(position) {
			position = this.normalize(position, true);
	
			if (position === undefined) {
				return;
			}
	
			this.trigger('remove', { content: this._items[position], position: position });
	
			this._items[position].remove();
			this._items.splice(position, 1);
			this._mergers.splice(position, 1);
	
			this.invalidate('items');
	
			this.trigger('removed', { content: null, position: position });
		};
	
		/**
		 * Preloads images with auto width.
		 * @todo Replace by a more generic approach
		 * @protected
		 */
		Owl.prototype.preloadAutoWidthImages = function(images) {
			images.each($.proxy(function(i, element) {
				this.enter('pre-loading');
				element = $(element);
				$(new Image()).one('load', $.proxy(function(e) {
					element.attr('src', e.target.src);
					element.css('opacity', 1);
					this.leave('pre-loading');
					!this.is('pre-loading') && !this.is('initializing') && this.refresh();
				}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));
			}, this));
		};
	
		/**
		 * Destroys the carousel.
		 * @public
		 */
		Owl.prototype.destroy = function() {
	
			this.$element.off('.owl.core');
			this.$stage.off('.owl.core');
			$(document).off('.owl.core');
	
			if (this.settings.responsive !== false) {
				window.clearTimeout(this.resizeTimer);
				this.off(window, 'resize', this._handlers.onThrottledResize);
			}
	
			for (var i in this._plugins) {
				this._plugins[i].destroy();
			}
	
			this.$stage.children('.cloned').remove();
	
			this.$stage.unwrap();
			this.$stage.children().contents().unwrap();
			this.$stage.children().unwrap();
			this.$stage.remove();
			this.$element
				.removeClass(this.options.refreshClass)
				.removeClass(this.options.loadingClass)
				.removeClass(this.options.loadedClass)
				.removeClass(this.options.rtlClass)
				.removeClass(this.options.dragClass)
				.removeClass(this.options.grabClass)
				.attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'), ''))
				.removeData('owl.carousel');
		};
	
		/**
		 * Operators to calculate right-to-left and left-to-right.
		 * @protected
		 * @param {Number} [a] - The left side operand.
		 * @param {String} [o] - The operator.
		 * @param {Number} [b] - The right side operand.
		 */
		Owl.prototype.op = function(a, o, b) {
			var rtl = this.settings.rtl;
			switch (o) {
				case '<':
					return rtl ? a > b : a < b;
				case '>':
					return rtl ? a < b : a > b;
				case '>=':
					return rtl ? a <= b : a >= b;
				case '<=':
					return rtl ? a >= b : a <= b;
				default:
					break;
			}
		};
	
		/**
		 * Attaches to an internal event.
		 * @protected
		 * @param {HTMLElement} element - The event source.
		 * @param {String} event - The event name.
		 * @param {Function} listener - The event handler to attach.
		 * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
		 */
		Owl.prototype.on = function(element, event, listener, capture) {
			if (element.addEventListener) {
				element.addEventListener(event, listener, capture);
			} else if (element.attachEvent) {
				element.attachEvent('on' + event, listener);
			}
		};
	
		/**
		 * Detaches from an internal event.
		 * @protected
		 * @param {HTMLElement} element - The event source.
		 * @param {String} event - The event name.
		 * @param {Function} listener - The attached event handler to detach.
		 * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
		 */
		Owl.prototype.off = function(element, event, listener, capture) {
			if (element.removeEventListener) {
				element.removeEventListener(event, listener, capture);
			} else if (element.detachEvent) {
				element.detachEvent('on' + event, listener);
			}
		};
	
		/**
		 * Triggers a public event.
		 * @todo Remove `status`, `relatedTarget` should be used instead.
		 * @protected
		 * @param {String} name - The event name.
		 * @param {*} [data=null] - The event data.
		 * @param {String} [namespace=carousel] - The event namespace.
		 * @param {String} [state] - The state which is associated with the event.
		 * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.
		 * @returns {Event} - The event arguments.
		 */
		Owl.prototype.trigger = function(name, data, namespace, state, enter) {
			var status = {
				item: { count: this._items.length, index: this.current() }
			}, handler = $.camelCase(
				$.grep([ 'on', name, namespace ], function(v) { return v })
					.join('-').toLowerCase()
			), event = $.Event(
				[ name, 'owl', namespace || 'carousel' ].join('.').toLowerCase(),
				$.extend({ relatedTarget: this }, status, data)
			);
	
			if (!this._supress[name]) {
				$.each(this._plugins, function(name, plugin) {
					if (plugin.onTrigger) {
						plugin.onTrigger(event);
					}
				});
	
				this.register({ type: Owl.Type.Event, name: name });
				this.$element.trigger(event);
	
				if (this.settings && typeof this.settings[handler] === 'function') {
					this.settings[handler].call(this, event);
				}
			}
	
			return event;
		};
	
		/**
		 * Enters a state.
		 * @param name - The state name.
		 */
		Owl.prototype.enter = function(name) {
			$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
				if (this._states.current[name] === undefined) {
					this._states.current[name] = 0;
				}
	
				this._states.current[name]++;
			}, this));
		};
	
		/**
		 * Leaves a state.
		 * @param name - The state name.
		 */
		Owl.prototype.leave = function(name) {
			$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
				this._states.current[name]--;
			}, this));
		};
	
		/**
		 * Registers an event or state.
		 * @public
		 * @param {Object} object - The event or state to register.
		 */
		Owl.prototype.register = function(object) {
			if (object.type === Owl.Type.Event) {
				if (!$.event.special[object.name]) {
					$.event.special[object.name] = {};
				}
	
				if (!$.event.special[object.name].owl) {
					var _default = $.event.special[object.name]._default;
					$.event.special[object.name]._default = function(e) {
						if (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {
							return _default.apply(this, arguments);
						}
						return e.namespace && e.namespace.indexOf('owl') > -1;
					};
					$.event.special[object.name].owl = true;
				}
			} else if (object.type === Owl.Type.State) {
				if (!this._states.tags[object.name]) {
					this._states.tags[object.name] = object.tags;
				} else {
					this._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);
				}
	
				this._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function(tag, i) {
					return $.inArray(tag, this._states.tags[object.name]) === i;
				}, this));
			}
		};
	
		/**
		 * Suppresses events.
		 * @protected
		 * @param {Array.<String>} events - The events to suppress.
		 */
		Owl.prototype.suppress = function(events) {
			$.each(events, $.proxy(function(index, event) {
				this._supress[event] = true;
			}, this));
		};
	
		/**
		 * Releases suppressed events.
		 * @protected
		 * @param {Array.<String>} events - The events to release.
		 */
		Owl.prototype.release = function(events) {
			$.each(events, $.proxy(function(index, event) {
				delete this._supress[event];
			}, this));
		};
	
		/**
		 * Gets unified pointer coordinates from event.
		 * @todo #261
		 * @protected
		 * @param {Event} - The `mousedown` or `touchstart` event.
		 * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.
		 */
		Owl.prototype.pointer = function(event) {
			var result = { x: null, y: null };
	
			event = event.originalEvent || event || window.event;
	
			event = event.touches && event.touches.length ?
				event.touches[0] : event.changedTouches && event.changedTouches.length ?
					event.changedTouches[0] : event;
	
			if (event.pageX) {
				result.x = event.pageX;
				result.y = event.pageY;
			} else {
				result.x = event.clientX;
				result.y = event.clientY;
			}
	
			return result;
		};
	
		/**
		 * Determines if the input is a Number or something that can be coerced to a Number
		 * @protected
		 * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested
		 * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number
		 */
		Owl.prototype.isNumeric = function(number) {
			return !isNaN(parseFloat(number));
		};
	
		/**
		 * Gets the difference of two vectors.
		 * @todo #261
		 * @protected
		 * @param {Object} - The first vector.
		 * @param {Object} - The second vector.
		 * @returns {Object} - The difference.
		 */
		Owl.prototype.difference = function(first, second) {
			return {
				x: first.x - second.x,
				y: first.y - second.y
			};
		};
	
		/**
		 * The jQuery Plugin for the Owl Carousel
		 * @todo Navigation plugin `next` and `prev`
		 * @public
		 */
		$.fn.owlCarousel = function(option) {
			var args = Array.prototype.slice.call(arguments, 1);
	
			return this.each(function() {
				var $this = $(this),
					data = $this.data('owl.carousel');
	
				if (!data) {
					data = new Owl(this, typeof option == 'object' && option);
					$this.data('owl.carousel', data);
	
					$.each([
						'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'
					], function(i, event) {
						data.register({ type: Owl.Type.Event, name: event });
						data.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {
							if (e.namespace && e.relatedTarget !== this) {
								this.suppress([ event ]);
								data[event].apply(this, [].slice.call(arguments, 1));
								this.release([ event ]);
							}
						}, data));
					});
				}
	
				if (typeof option == 'string' && option.charAt(0) !== '_') {
					data[option].apply(data, args);
				}
			});
		};
	
		/**
		 * The constructor for the jQuery Plugin
		 * @public
		 */
		$.fn.owlCarousel.Constructor = Owl;
	
	})(window.Zepto || window.jQuery, window, document);
	
	/**
	 * AutoRefresh Plugin
	 * @version 2.3.4
	 * @author Artus Kolanowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the auto refresh plugin.
		 * @class The Auto Refresh Plugin
		 * @param {Owl} carousel - The Owl Carousel
		 */
		var AutoRefresh = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * Refresh interval.
			 * @protected
			 * @type {number}
			 */
			this._interval = null;
	
			/**
			 * Whether the element is currently visible or not.
			 * @protected
			 * @type {Boolean}
			 */
			this._visible = null;
	
			/**
			 * All event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'initialized.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.autoRefresh) {
						this.watch();
					}
				}, this)
			};
	
			// set default options
			this._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);
	
			// register event handlers
			this._core.$element.on(this._handlers);
		};
	
		/**
		 * Default options.
		 * @public
		 */
		AutoRefresh.Defaults = {
			autoRefresh: true,
			autoRefreshInterval: 500
		};
	
		/**
		 * Watches the element.
		 */
		AutoRefresh.prototype.watch = function() {
			if (this._interval) {
				return;
			}
	
			this._visible = this._core.isVisible();
			this._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);
		};
	
		/**
		 * Refreshes the element.
		 */
		AutoRefresh.prototype.refresh = function() {
			if (this._core.isVisible() === this._visible) {
				return;
			}
	
			this._visible = !this._visible;
	
			this._core.$element.toggleClass('owl-hidden', !this._visible);
	
			this._visible && (this._core.invalidate('width') && this._core.refresh());
		};
	
		/**
		 * Destroys the plugin.
		 */
		AutoRefresh.prototype.destroy = function() {
			var handler, property;
	
			window.clearInterval(this._interval);
	
			for (handler in this._handlers) {
				this._core.$element.off(handler, this._handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;
	
	})(window.Zepto || window.jQuery, window, document);
	
	/**
	 * Lazy Plugin
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the lazy plugin.
		 * @class The Lazy Plugin
		 * @param {Owl} carousel - The Owl Carousel
		 */
		var Lazy = function(carousel) {
	
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * Already loaded items.
			 * @protected
			 * @type {Array.<jQuery>}
			 */
			this._loaded = [];
	
			/**
			 * Event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function(e) {
					if (!e.namespace) {
						return;
					}
	
					if (!this._core.settings || !this._core.settings.lazyLoad) {
						return;
					}
	
					if ((e.property && e.property.name == 'position') || e.type == 'initialized') {
						var settings = this._core.settings,
							n = (settings.center && Math.ceil(settings.items / 2) || settings.items),
							i = ((settings.center && n * -1) || 0),
							position = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,
							clones = this._core.clones().length,
							load = $.proxy(function(i, v) { this.load(v) }, this);
						//TODO: Need documentation for this new option
						if (settings.lazyLoadEager > 0) {
							n += settings.lazyLoadEager;
							// If the carousel is looping also preload images that are to the "left"
							if (settings.loop) {
	              position -= settings.lazyLoadEager;
	              n++;
	            }
						}
	
						while (i++ < n) {
							this.load(clones / 2 + this._core.relative(position));
							clones && $.each(this._core.clones(this._core.relative(position)), load);
							position++;
						}
					}
				}, this)
			};
	
			// set the default options
			this._core.options = $.extend({}, Lazy.Defaults, this._core.options);
	
			// register event handler
			this._core.$element.on(this._handlers);
		};
	
		/**
		 * Default options.
		 * @public
		 */
		Lazy.Defaults = {
			lazyLoad: false,
			lazyLoadEager: 0
		};
	
		/**
		 * Loads all resources of an item at the specified position.
		 * @param {Number} position - The absolute position of the item.
		 * @protected
		 */
		Lazy.prototype.load = function(position) {
			var $item = this._core.$stage.children().eq(position),
				$elements = $item && $item.find('.owl-lazy');
	
			if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
				return;
			}
	
			$elements.each($.proxy(function(index, element) {
				var $element = $(element), image,
	                url = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src') || $element.attr('data-srcset');
	
				this._core.trigger('load', { element: $element, url: url }, 'lazy');
	
				if ($element.is('img')) {
					$element.one('load.owl.lazy', $.proxy(function() {
						$element.css('opacity', 1);
						this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
					}, this)).attr('src', url);
	            } else if ($element.is('source')) {
	                $element.one('load.owl.lazy', $.proxy(function() {
	                    this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
	                }, this)).attr('srcset', url);
				} else {
					image = new Image();
					image.onload = $.proxy(function() {
						$element.css({
							'background-image': 'url("' + url + '")',
							'opacity': '1'
						});
						this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
					}, this);
					image.src = url;
				}
			}, this));
	
			this._loaded.push($item.get(0));
		};
	
		/**
		 * Destroys the plugin.
		 * @public
		 */
		Lazy.prototype.destroy = function() {
			var handler, property;
	
			for (handler in this.handlers) {
				this._core.$element.off(handler, this.handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;
	
	})(window.Zepto || window.jQuery, window, document);
	
	/**
	 * AutoHeight Plugin
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the auto height plugin.
		 * @class The Auto Height Plugin
		 * @param {Owl} carousel - The Owl Carousel
		 */
		var AutoHeight = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			this._previousHeight = null;
	
			/**
			 * All event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.autoHeight) {
						this.update();
					}
				}, this),
				'changed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.autoHeight && e.property.name === 'position'){
						this.update();
					}
				}, this),
				'loaded.owl.lazy': $.proxy(function(e) {
					if (e.namespace && this._core.settings.autoHeight
						&& e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {
						this.update();
					}
				}, this)
			};
	
			// set default options
			this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);
	
			// register event handlers
			this._core.$element.on(this._handlers);
			this._intervalId = null;
			var refThis = this;
	
			// These changes have been taken from a PR by gavrochelegnou proposed in #1575
			// and have been made compatible with the latest jQuery version
			$(window).on('load', function() {
				if (refThis._core.settings.autoHeight) {
					refThis.update();
				}
			});
	
			// Autoresize the height of the carousel when window is resized
			// When carousel has images, the height is dependent on the width
			// and should also change on resize
			$(window).resize(function() {
				if (refThis._core.settings.autoHeight) {
					if (refThis._intervalId != null) {
						clearTimeout(refThis._intervalId);
					}
	
					refThis._intervalId = setTimeout(function() {
						refThis.update();
					}, 250);
				}
			});
	
		};
	
		/**
		 * Default options.
		 * @public
		 */
		AutoHeight.Defaults = {
			autoHeight: false,
			autoHeightClass: 'owl-height'
		};
	
		/**
		 * Updates the view.
		 */
		AutoHeight.prototype.update = function() {
			var start = this._core._current,
				end = start + this._core.settings.items,
				lazyLoadEnabled = this._core.settings.lazyLoad,
				visible = this._core.$stage.children().toArray().slice(start, end),
				heights = [],
				maxheight = 0;
	
			$.each(visible, function(index, item) {
				heights.push($(item).height());
			});
	
			maxheight = Math.max.apply(null, heights);
	
			if (maxheight <= 1 && lazyLoadEnabled && this._previousHeight) {
				maxheight = this._previousHeight;
			}
	
			this._previousHeight = maxheight;
	
			this._core.$stage.parent()
				.height(maxheight)
				.addClass(this._core.settings.autoHeightClass);
		};
	
		AutoHeight.prototype.destroy = function() {
			var handler, property;
	
			for (handler in this._handlers) {
				this._core.$element.off(handler, this._handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] !== 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;
	
	})(window.Zepto || window.jQuery, window, document);
	
	/**
	 * Video Plugin
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the video plugin.
		 * @class The Video Plugin
		 * @param {Owl} carousel - The Owl Carousel
		 */
		var Video = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * Cache all video URLs.
			 * @protected
			 * @type {Object}
			 */
			this._videos = {};
	
			/**
			 * Current playing item.
			 * @protected
			 * @type {jQuery}
			 */
			this._playing = null;
	
			/**
			 * All event handlers.
			 * @todo The cloned content removale is too late
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'initialized.owl.carousel': $.proxy(function(e) {
					if (e.namespace) {
						this._core.register({ type: 'state', name: 'playing', tags: [ 'interacting' ] });
					}
				}, this),
				'resize.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.video && this.isInFullScreen()) {
						e.preventDefault();
					}
				}, this),
				'refreshed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.is('resizing')) {
						this._core.$stage.find('.cloned .owl-video-frame').remove();
					}
				}, this),
				'changed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && e.property.name === 'position' && this._playing) {
						this.stop();
					}
				}, this),
				'prepared.owl.carousel': $.proxy(function(e) {
					if (!e.namespace) {
						return;
					}
	
					var $element = $(e.content).find('.owl-video');
	
					if ($element.length) {
						$element.css('display', 'none');
						this.fetch($element, $(e.content));
					}
				}, this)
			};
	
			// set default options
			this._core.options = $.extend({}, Video.Defaults, this._core.options);
	
			// register event handlers
			this._core.$element.on(this._handlers);
	
			this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {
				this.play(e);
			}, this));
		};
	
		/**
		 * Default options.
		 * @public
		 */
		Video.Defaults = {
			video: false,
			videoHeight: false,
			videoWidth: false
		};
	
		/**
		 * Gets the video ID and the type (YouTube/Vimeo/vzaar only).
		 * @protected
		 * @param {jQuery} target - The target containing the video data.
		 * @param {jQuery} item - The item containing the video.
		 */
		Video.prototype.fetch = function(target, item) {
				var type = (function() {
						if (target.attr('data-vimeo-id')) {
							return 'vimeo';
						} else if (target.attr('data-vzaar-id')) {
							return 'vzaar'
						} else {
							return 'youtube';
						}
					})(),
					id = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),
					width = target.attr('data-width') || this._core.settings.videoWidth,
					height = target.attr('data-height') || this._core.settings.videoHeight,
					url = target.attr('href');
	
			if (url) {
	
				/*
						Parses the id's out of the following urls (and probably more):
						https://www.youtube.com/watch?v=:id
						https://youtu.be/:id
						https://vimeo.com/:id
						https://vimeo.com/channels/:channel/:id
						https://vimeo.com/groups/:group/videos/:id
						https://app.vzaar.com/videos/:id
	
						Visual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F
				*/
	
				id = url.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
	
				if (id[3].indexOf('youtu') > -1) {
					type = 'youtube';
				} else if (id[3].indexOf('vimeo') > -1) {
					type = 'vimeo';
				} else if (id[3].indexOf('vzaar') > -1) {
					type = 'vzaar';
				} else {
					throw new Error('Video URL not supported.');
				}
				id = id[6];
			} else {
				throw new Error('Missing video URL.');
			}
	
			this._videos[url] = {
				type: type,
				id: id,
				width: width,
				height: height
			};
	
			item.attr('data-video', url);
	
			this.thumbnail(target, this._videos[url]);
		};
	
		/**
		 * Creates video thumbnail.
		 * @protected
		 * @param {jQuery} target - The target containing the video data.
		 * @param {Object} info - The video info object.
		 * @see `fetch`
		 */
		Video.prototype.thumbnail = function(target, video) {
			var tnLink,
				icon,
				path,
				dimensions = video.width && video.height ? 'width:' + video.width + 'px;height:' + video.height + 'px;' : '',
				customTn = target.find('img'),
				srcType = 'src',
				lazyClass = '',
				settings = this._core.settings,
				create = function(path) {
					icon = '<div class="owl-video-play-icon"></div>';
	
					if (settings.lazyLoad) {
						tnLink = $('<div/>',{
							"class": 'owl-video-tn ' + lazyClass,
							"srcType": path
						});
					} else {
						tnLink = $( '<div/>', {
							"class": "owl-video-tn",
							"style": 'opacity:1;background-image:url(' + path + ')'
						});
					}
					target.after(tnLink);
					target.after(icon);
				};
	
			// wrap video content into owl-video-wrapper div
			target.wrap( $( '<div/>', {
				"class": "owl-video-wrapper",
				"style": dimensions
			}));
	
			if (this._core.settings.lazyLoad) {
				srcType = 'data-src';
				lazyClass = 'owl-lazy';
			}
	
			// custom thumbnail
			if (customTn.length) {
				create(customTn.attr(srcType));
				customTn.remove();
				return false;
			}
	
			if (video.type === 'youtube') {
				path = "//img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
				create(path);
			} else if (video.type === 'vimeo') {
				$.ajax({
					type: 'GET',
					url: '//vimeo.com/api/v2/video/' + video.id + '.json',
					jsonp: 'callback',
					dataType: 'jsonp',
					success: function(data) {
						path = data[0].thumbnail_large;
						create(path);
					}
				});
			} else if (video.type === 'vzaar') {
				$.ajax({
					type: 'GET',
					url: '//vzaar.com/api/videos/' + video.id + '.json',
					jsonp: 'callback',
					dataType: 'jsonp',
					success: function(data) {
						path = data.framegrab_url;
						create(path);
					}
				});
			}
		};
	
		/**
		 * Stops the current video.
		 * @public
		 */
		Video.prototype.stop = function() {
			this._core.trigger('stop', null, 'video');
			this._playing.find('.owl-video-frame').remove();
			this._playing.removeClass('owl-video-playing');
			this._playing = null;
			this._core.leave('playing');
			this._core.trigger('stopped', null, 'video');
		};
	
		/**
		 * Starts the current video.
		 * @public
		 * @param {Event} event - The event arguments.
		 */
		Video.prototype.play = function(event) {
			var target = $(event.target),
				item = target.closest('.' + this._core.settings.itemClass),
				video = this._videos[item.attr('data-video')],
				width = video.width || '100%',
				height = video.height || this._core.$stage.height(),
				html,
				iframe;
	
			if (this._playing) {
				return;
			}
	
			this._core.enter('playing');
			this._core.trigger('play', null, 'video');
	
			item = this._core.items(this._core.relative(item.index()));
	
			this._core.reset(item.index());
	
			html = $( '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>' );
			html.attr( 'height', height );
			html.attr( 'width', width );
			if (video.type === 'youtube') {
				html.attr( 'src', '//www.youtube.com/embed/' + video.id + '?autoplay=1&rel=0&v=' + video.id );
			} else if (video.type === 'vimeo') {
				html.attr( 'src', '//player.vimeo.com/video/' + video.id + '?autoplay=1' );
			} else if (video.type === 'vzaar') {
				html.attr( 'src', '//view.vzaar.com/' + video.id + '/player?autoplay=true' );
			}
	
			iframe = $(html).wrap( '<div class="owl-video-frame" />' ).insertAfter(item.find('.owl-video'));
	
			this._playing = item.addClass('owl-video-playing');
		};
	
		/**
		 * Checks whether an video is currently in full screen mode or not.
		 * @todo Bad style because looks like a readonly method but changes members.
		 * @protected
		 * @returns {Boolean}
		 */
		Video.prototype.isInFullScreen = function() {
			var element = document.fullscreenElement || document.mozFullScreenElement ||
					document.webkitFullscreenElement;
	
			return element && $(element).parent().hasClass('owl-video-frame');
		};
	
		/**
		 * Destroys the plugin.
		 */
		Video.prototype.destroy = function() {
			var handler, property;
	
			this._core.$element.off('click.owl.video');
	
			for (handler in this._handlers) {
				this._core.$element.off(handler, this._handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.Video = Video;
	
	})(window.Zepto || window.jQuery, window, document);
	
	/**
	 * Animate Plugin
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the animate plugin.
		 * @class The Navigation Plugin
		 * @param {Owl} scope - The Owl Carousel
		 */
		var Animate = function(scope) {
			this.core = scope;
			this.core.options = $.extend({}, Animate.Defaults, this.core.options);
			this.swapping = true;
			this.previous = undefined;
			this.next = undefined;
	
			this.handlers = {
				'change.owl.carousel': $.proxy(function(e) {
					if (e.namespace && e.property.name == 'position') {
						this.previous = this.core.current();
						this.next = e.property.value;
					}
				}, this),
				'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {
					if (e.namespace) {
						this.swapping = e.type == 'translated';
					}
				}, this),
				'translate.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
						this.swap();
					}
				}, this)
			};
	
			this.core.$element.on(this.handlers);
		};
	
		/**
		 * Default options.
		 * @public
		 */
		Animate.Defaults = {
			animateOut: false,
			animateIn: false
		};
	
		/**
		 * Toggles the animation classes whenever an translations starts.
		 * @protected
		 * @returns {Boolean|undefined}
		 */
		Animate.prototype.swap = function() {
	
			if (this.core.settings.items !== 1) {
				return;
			}
	
			if (!$.support.animation || !$.support.transition) {
				return;
			}
	
			this.core.speed(0);
	
			var left,
				clear = $.proxy(this.clear, this),
				previous = this.core.$stage.children().eq(this.previous),
				next = this.core.$stage.children().eq(this.next),
				incoming = this.core.settings.animateIn,
				outgoing = this.core.settings.animateOut;
	
			if (this.core.current() === this.previous) {
				return;
			}
	
			if (outgoing) {
				left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
				previous.one($.support.animation.end, clear)
					.css( { 'left': left + 'px' } )
					.addClass('animated owl-animated-out')
					.addClass(outgoing);
			}
	
			if (incoming) {
				next.one($.support.animation.end, clear)
					.addClass('animated owl-animated-in')
					.addClass(incoming);
			}
		};
	
		Animate.prototype.clear = function(e) {
			$(e.target).css( { 'left': '' } )
				.removeClass('animated owl-animated-out owl-animated-in')
				.removeClass(this.core.settings.animateIn)
				.removeClass(this.core.settings.animateOut);
			this.core.onTransitionEnd();
		};
	
		/**
		 * Destroys the plugin.
		 * @public
		 */
		Animate.prototype.destroy = function() {
			var handler, property;
	
			for (handler in this.handlers) {
				this.core.$element.off(handler, this.handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;
	
	})(window.Zepto || window.jQuery, window, document);
	
	/**
	 * Autoplay Plugin
	 * @version 2.3.4
	 * @author Bartosz Wojciechowski
	 * @author Artus Kolanowski
	 * @author David Deutsch
	 * @author Tom De Caluwé
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		/**
		 * Creates the autoplay plugin.
		 * @class The Autoplay Plugin
		 * @param {Owl} scope - The Owl Carousel
		 */
		var Autoplay = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * The autoplay timeout id.
			 * @type {Number}
			 */
			this._call = null;
	
			/**
			 * Depending on the state of the plugin, this variable contains either
			 * the start time of the timer or the current timer value if it's
			 * paused. Since we start in a paused state we initialize the timer
			 * value.
			 * @type {Number}
			 */
			this._time = 0;
	
			/**
			 * Stores the timeout currently used.
			 * @type {Number}
			 */
			this._timeout = 0;
	
			/**
			 * Indicates whenever the autoplay is paused.
			 * @type {Boolean}
			 */
			this._paused = true;
	
			/**
			 * All event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'changed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && e.property.name === 'settings') {
						if (this._core.settings.autoplay) {
							this.play();
						} else {
							this.stop();
						}
					} else if (e.namespace && e.property.name === 'position' && this._paused) {
						// Reset the timer. This code is triggered when the position
						// of the carousel was changed through user interaction.
						this._time = 0;
					}
				}, this),
				'initialized.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.autoplay) {
						this.play();
					}
				}, this),
				'play.owl.autoplay': $.proxy(function(e, t, s) {
					if (e.namespace) {
						this.play(t, s);
					}
				}, this),
				'stop.owl.autoplay': $.proxy(function(e) {
					if (e.namespace) {
						this.stop();
					}
				}, this),
				'mouseover.owl.autoplay': $.proxy(function() {
					if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
						this.pause();
					}
				}, this),
				'mouseleave.owl.autoplay': $.proxy(function() {
					if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
						this.play();
					}
				}, this),
				'touchstart.owl.core': $.proxy(function() {
					if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
						this.pause();
					}
				}, this),
				'touchend.owl.core': $.proxy(function() {
					if (this._core.settings.autoplayHoverPause) {
						this.play();
					}
				}, this)
			};
	
			// register event handlers
			this._core.$element.on(this._handlers);
	
			// set default options
			this._core.options = $.extend({}, Autoplay.Defaults, this._core.options);
		};
	
		/**
		 * Default options.
		 * @public
		 */
		Autoplay.Defaults = {
			autoplay: false,
			autoplayTimeout: 5000,
			autoplayHoverPause: false,
			autoplaySpeed: false
		};
	
		/**
		 * Transition to the next slide and set a timeout for the next transition.
		 * @private
		 * @param {Number} [speed] - The animation speed for the animations.
		 */
		Autoplay.prototype._next = function(speed) {
			this._call = window.setTimeout(
				$.proxy(this._next, this, speed),
				this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()
			);
	
			if (this._core.is('interacting') || document.hidden) {
				return;
			}
			this._core.next(speed || this._core.settings.autoplaySpeed);
		}
	
		/**
		 * Reads the current timer value when the timer is playing.
		 * @public
		 */
		Autoplay.prototype.read = function() {
			return new Date().getTime() - this._time;
		};
	
		/**
		 * Starts the autoplay.
		 * @public
		 * @param {Number} [timeout] - The interval before the next animation starts.
		 * @param {Number} [speed] - The animation speed for the animations.
		 */
		Autoplay.prototype.play = function(timeout, speed) {
			var elapsed;
	
			if (!this._core.is('rotating')) {
				this._core.enter('rotating');
			}
	
			timeout = timeout || this._core.settings.autoplayTimeout;
	
			// Calculate the elapsed time since the last transition. If the carousel
			// wasn't playing this calculation will yield zero.
			elapsed = Math.min(this._time % (this._timeout || timeout), timeout);
	
			if (this._paused) {
				// Start the clock.
				this._time = this.read();
				this._paused = false;
			} else {
				// Clear the active timeout to allow replacement.
				window.clearTimeout(this._call);
			}
	
			// Adjust the origin of the timer to match the new timeout value.
			this._time += this.read() % timeout - elapsed;
	
			this._timeout = timeout;
			this._call = window.setTimeout($.proxy(this._next, this, speed), timeout - elapsed);
		};
	
		/**
		 * Stops the autoplay.
		 * @public
		 */
		Autoplay.prototype.stop = function() {
			if (this._core.is('rotating')) {
				// Reset the clock.
				this._time = 0;
				this._paused = true;
	
				window.clearTimeout(this._call);
				this._core.leave('rotating');
			}
		};
	
		/**
		 * Pauses the autoplay.
		 * @public
		 */
		Autoplay.prototype.pause = function() {
			if (this._core.is('rotating') && !this._paused) {
				// Pause the clock.
				this._time = this.read();
				this._paused = true;
	
				window.clearTimeout(this._call);
			}
		};
	
		/**
		 * Destroys the plugin.
		 */
		Autoplay.prototype.destroy = function() {
			var handler, property;
	
			this.stop();
	
			for (handler in this._handlers) {
				this._core.$element.off(handler, this._handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;
	
	})(window.Zepto || window.jQuery, window, document);
	
	/**
	 * Navigation Plugin
	 * @version 2.3.4
	 * @author Artus Kolanowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
		'use strict';
	
		/**
		 * Creates the navigation plugin.
		 * @class The Navigation Plugin
		 * @param {Owl} carousel - The Owl Carousel.
		 */
		var Navigation = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * Indicates whether the plugin is initialized or not.
			 * @protected
			 * @type {Boolean}
			 */
			this._initialized = false;
	
			/**
			 * The current paging indexes.
			 * @protected
			 * @type {Array}
			 */
			this._pages = [];
	
			/**
			 * All DOM elements of the user interface.
			 * @protected
			 * @type {Object}
			 */
			this._controls = {};
	
			/**
			 * Markup for an indicator.
			 * @protected
			 * @type {Array.<String>}
			 */
			this._templates = [];
	
			/**
			 * The carousel element.
			 * @type {jQuery}
			 */
			this.$element = this._core.$element;
	
			/**
			 * Overridden methods of the carousel.
			 * @protected
			 * @type {Object}
			 */
			this._overrides = {
				next: this._core.next,
				prev: this._core.prev,
				to: this._core.to
			};
	
			/**
			 * All event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'prepared.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.dotsData) {
						this._templates.push('<div class="' + this._core.settings.dotClass + '">' +
							$(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');
					}
				}, this),
				'added.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.dotsData) {
						this._templates.splice(e.position, 0, this._templates.pop());
					}
				}, this),
				'remove.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.dotsData) {
						this._templates.splice(e.position, 1);
					}
				}, this),
				'changed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && e.property.name == 'position') {
						this.draw();
					}
				}, this),
				'initialized.owl.carousel': $.proxy(function(e) {
					if (e.namespace && !this._initialized) {
						this._core.trigger('initialize', null, 'navigation');
						this.initialize();
						this.update();
						this.draw();
						this._initialized = true;
						this._core.trigger('initialized', null, 'navigation');
					}
				}, this),
				'refreshed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._initialized) {
						this._core.trigger('refresh', null, 'navigation');
						this.update();
						this.draw();
						this._core.trigger('refreshed', null, 'navigation');
					}
				}, this)
			};
	
			// set default options
			this._core.options = $.extend({}, Navigation.Defaults, this._core.options);
	
			// register event handlers
			this.$element.on(this._handlers);
		};
	
		/**
		 * Default options.
		 * @public
		 * @todo Rename `slideBy` to `navBy`
		 */
		Navigation.Defaults = {
			nav: false,
			navText: [
				'<span aria-label="' + 'Previous' + '">&#x2039;</span>',
				'<span aria-label="' + 'Next' + '">&#x203a;</span>'
			],
			navSpeed: false,
			navElement: 'button type="button" role="presentation"',
			navContainer: false,
			navContainerClass: 'owl-nav',
			navClass: [
				'owl-prev',
				'owl-next'
			],
			slideBy: 1,
			dotClass: 'owl-dot',
			dotsClass: 'owl-dots',
			dots: true,
			dotsEach: false,
			dotsData: false,
			dotsSpeed: false,
			dotsContainer: false
		};
	
		/**
		 * Initializes the layout of the plugin and extends the carousel.
		 * @protected
		 */
		Navigation.prototype.initialize = function() {
			var override,
				settings = this._core.settings;
	
			// create DOM structure for relative navigation
			this._controls.$relative = (settings.navContainer ? $(settings.navContainer)
				: $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');
	
			this._controls.$previous = $('<' + settings.navElement + '>')
				.addClass(settings.navClass[0])
				.html(settings.navText[0])
				.prependTo(this._controls.$relative)
				.on('click', $.proxy(function(e) {
					this.prev(settings.navSpeed);
				}, this));
			this._controls.$next = $('<' + settings.navElement + '>')
				.addClass(settings.navClass[1])
				.html(settings.navText[1])
				.appendTo(this._controls.$relative)
				.on('click', $.proxy(function(e) {
					this.next(settings.navSpeed);
				}, this));
	
			// create DOM structure for absolute navigation
			if (!settings.dotsData) {
				this._templates = [ $('<button role="button">')
					.addClass(settings.dotClass)
					.append($('<span>'))
					.prop('outerHTML') ];
			}
	
			this._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer)
				: $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');
	
			this._controls.$absolute.on('click', 'button', $.proxy(function(e) {
				var index = $(e.target).parent().is(this._controls.$absolute)
					? $(e.target).index() : $(e.target).parent().index();
	
				e.preventDefault();
	
				this.to(index, settings.dotsSpeed);
			}, this));
	
			/*$el.on('focusin', function() {
				$(document).off(".carousel");
	
				$(document).on('keydown.carousel', function(e) {
					if(e.keyCode == 37) {
						$el.trigger('prev.owl')
					}
					if(e.keyCode == 39) {
						$el.trigger('next.owl')
					}
				});
			});*/
	
			// override public methods of the carousel
			for (override in this._overrides) {
				this._core[override] = $.proxy(this[override], this);
			}
		};
	
		/**
		 * Destroys the plugin.
		 * @protected
		 */
		Navigation.prototype.destroy = function() {
			var handler, control, property, override, settings;
			settings = this._core.settings;
	
			for (handler in this._handlers) {
				this.$element.off(handler, this._handlers[handler]);
			}
			for (control in this._controls) {
				if (control === '$relative' && settings.navContainer) {
					this._controls[control].html('');
				} else {
					this._controls[control].remove();
				}
			}
			for (override in this.overides) {
				this._core[override] = this._overrides[override];
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		/**
		 * Updates the internal state.
		 * @protected
		 */
		Navigation.prototype.update = function() {
			var i, j, k,
				lower = this._core.clones().length / 2,
				upper = lower + this._core.items().length,
				maximum = this._core.maximum(true),
				settings = this._core.settings,
				size = settings.center || settings.autoWidth || settings.dotsData
					? 1 : settings.dotsEach || settings.items;
	
			if (settings.slideBy !== 'page') {
				settings.slideBy = Math.min(settings.slideBy, settings.items);
			}
	
			if (settings.dots || settings.slideBy == 'page') {
				this._pages = [];
	
				for (i = lower, j = 0, k = 0; i < upper; i++) {
					if (j >= size || j === 0) {
						this._pages.push({
							start: Math.min(maximum, i - lower),
							end: i - lower + size - 1
						});
						if (Math.min(maximum, i - lower) === maximum) {
							break;
						}
						j = 0, ++k;
					}
					j += this._core.mergers(this._core.relative(i));
				}
			}
		};
	
		/**
		 * Draws the user interface.
		 * @todo The option `dotsData` wont work.
		 * @protected
		 */
		Navigation.prototype.draw = function() {
			var difference,
				settings = this._core.settings,
				disabled = this._core.items().length <= settings.items,
				index = this._core.relative(this._core.current()),
				loop = settings.loop || settings.rewind;
	
			this._controls.$relative.toggleClass('disabled', !settings.nav || disabled);
	
			if (settings.nav) {
				this._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));
				this._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));
			}
	
			this._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);
	
			if (settings.dots) {
				difference = this._pages.length - this._controls.$absolute.children().length;
	
				if (settings.dotsData && difference !== 0) {
					this._controls.$absolute.html(this._templates.join(''));
				} else if (difference > 0) {
					this._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));
				} else if (difference < 0) {
					this._controls.$absolute.children().slice(difference).remove();
				}
	
				this._controls.$absolute.find('.active').removeClass('active');
				this._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');
			}
		};
	
		/**
		 * Extends event data.
		 * @protected
		 * @param {Event} event - The event object which gets thrown.
		 */
		Navigation.prototype.onTrigger = function(event) {
			var settings = this._core.settings;
	
			event.page = {
				index: $.inArray(this.current(), this._pages),
				count: this._pages.length,
				size: settings && (settings.center || settings.autoWidth || settings.dotsData
					? 1 : settings.dotsEach || settings.items)
			};
		};
	
		/**
		 * Gets the current page position of the carousel.
		 * @protected
		 * @returns {Number}
		 */
		Navigation.prototype.current = function() {
			var current = this._core.relative(this._core.current());
			return $.grep(this._pages, $.proxy(function(page, index) {
				return page.start <= current && page.end >= current;
			}, this)).pop();
		};
	
		/**
		 * Gets the current succesor/predecessor position.
		 * @protected
		 * @returns {Number}
		 */
		Navigation.prototype.getPosition = function(successor) {
			var position, length,
				settings = this._core.settings;
	
			if (settings.slideBy == 'page') {
				position = $.inArray(this.current(), this._pages);
				length = this._pages.length;
				successor ? ++position : --position;
				position = this._pages[((position % length) + length) % length].start;
			} else {
				position = this._core.relative(this._core.current());
				length = this._core.items().length;
				successor ? position += settings.slideBy : position -= settings.slideBy;
			}
	
			return position;
		};
	
		/**
		 * Slides to the next item or page.
		 * @public
		 * @param {Number} [speed=false] - The time in milliseconds for the transition.
		 */
		Navigation.prototype.next = function(speed) {
			$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
		};
	
		/**
		 * Slides to the previous item or page.
		 * @public
		 * @param {Number} [speed=false] - The time in milliseconds for the transition.
		 */
		Navigation.prototype.prev = function(speed) {
			$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
		};
	
		/**
		 * Slides to the specified item or page.
		 * @public
		 * @param {Number} position - The position of the item or page.
		 * @param {Number} [speed] - The time in milliseconds for the transition.
		 * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
		 */
		Navigation.prototype.to = function(position, speed, standard) {
			var length;
	
			if (!standard && this._pages.length) {
				length = this._pages.length;
				$.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);
			} else {
				$.proxy(this._overrides.to, this._core)(position, speed);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;
	
	})(window.Zepto || window.jQuery, window, document);
	
	/**
	 * Hash Plugin
	 * @version 2.3.4
	 * @author Artus Kolanowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
		'use strict';
	
		/**
		 * Creates the hash plugin.
		 * @class The Hash Plugin
		 * @param {Owl} carousel - The Owl Carousel
		 */
		var Hash = function(carousel) {
			/**
			 * Reference to the core.
			 * @protected
			 * @type {Owl}
			 */
			this._core = carousel;
	
			/**
			 * Hash index for the items.
			 * @protected
			 * @type {Object}
			 */
			this._hashes = {};
	
			/**
			 * The carousel element.
			 * @type {jQuery}
			 */
			this.$element = this._core.$element;
	
			/**
			 * All event handlers.
			 * @protected
			 * @type {Object}
			 */
			this._handlers = {
				'initialized.owl.carousel': $.proxy(function(e) {
					if (e.namespace && this._core.settings.startPosition === 'URLHash') {
						$(window).trigger('hashchange.owl.navigation');
					}
				}, this),
				'prepared.owl.carousel': $.proxy(function(e) {
					if (e.namespace) {
						var hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');
	
						if (!hash) {
							return;
						}
	
						this._hashes[hash] = e.content;
					}
				}, this),
				'changed.owl.carousel': $.proxy(function(e) {
					if (e.namespace && e.property.name === 'position') {
						var current = this._core.items(this._core.relative(this._core.current())),
							hash = $.map(this._hashes, function(item, hash) {
								return item === current ? hash : null;
							}).join();
	
						if (!hash || window.location.hash.slice(1) === hash) {
							return;
						}
	
						window.location.hash = hash;
					}
				}, this)
			};
	
			// set default options
			this._core.options = $.extend({}, Hash.Defaults, this._core.options);
	
			// register the event handlers
			this.$element.on(this._handlers);
	
			// register event listener for hash navigation
			$(window).on('hashchange.owl.navigation', $.proxy(function(e) {
				var hash = window.location.hash.substring(1),
					items = this._core.$stage.children(),
					position = this._hashes[hash] && items.index(this._hashes[hash]);
	
				if (position === undefined || position === this._core.current()) {
					return;
				}
	
				this._core.to(this._core.relative(position), false, true);
			}, this));
		};
	
		/**
		 * Default options.
		 * @public
		 */
		Hash.Defaults = {
			URLhashListener: false
		};
	
		/**
		 * Destroys the plugin.
		 * @public
		 */
		Hash.prototype.destroy = function() {
			var handler, property;
	
			$(window).off('hashchange.owl.navigation');
	
			for (handler in this._handlers) {
				this._core.$element.off(handler, this._handlers[handler]);
			}
			for (property in Object.getOwnPropertyNames(this)) {
				typeof this[property] != 'function' && (this[property] = null);
			}
		};
	
		$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;
	
	})(window.Zepto || window.jQuery, window, document);
	
	/**
	 * Support Plugin
	 *
	 * @version 2.3.4
	 * @author Vivid Planet Software GmbH
	 * @author Artus Kolanowski
	 * @author David Deutsch
	 * @license The MIT License (MIT)
	 */
	;(function($, window, document, undefined) {
	
		var style = $('<support>').get(0).style,
			prefixes = 'Webkit Moz O ms'.split(' '),
			events = {
				transition: {
					end: {
						WebkitTransition: 'webkitTransitionEnd',
						MozTransition: 'transitionend',
						OTransition: 'oTransitionEnd',
						transition: 'transitionend'
					}
				},
				animation: {
					end: {
						WebkitAnimation: 'webkitAnimationEnd',
						MozAnimation: 'animationend',
						OAnimation: 'oAnimationEnd',
						animation: 'animationend'
					}
				}
			},
			tests = {
				csstransforms: function() {
					return !!test('transform');
				},
				csstransforms3d: function() {
					return !!test('perspective');
				},
				csstransitions: function() {
					return !!test('transition');
				},
				cssanimations: function() {
					return !!test('animation');
				}
			};
	
		function test(property, prefixed) {
			var result = false,
				upper = property.charAt(0).toUpperCase() + property.slice(1);
	
			$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function(i, property) {
				if (style[property] !== undefined) {
					result = prefixed ? property : true;
					return false;
				}
			});
	
			return result;
		}
	
		function prefixed(property) {
			return test(property, true);
		}
	
		if (tests.csstransitions()) {
			/* jshint -W053 */
			$.support.transition = new String(prefixed('transition'))
			$.support.transition.end = events.transition.end[ $.support.transition ];
		}
	
		if (tests.cssanimations()) {
			/* jshint -W053 */
			$.support.animation = new String(prefixed('animation'))
			$.support.animation.end = events.animation.end[ $.support.animation ];
		}
	
		if (tests.csstransforms()) {
			/* jshint -W053 */
			$.support.transform = new String(prefixed('transform'));
			$.support.transform3d = tests.csstransforms3d();
		}
	
	})(window.Zepto || window.jQuery, window, document);


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(496);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(47)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!./owl.carousel.css", function() {
				var newContent = require("!!../../../css-loader/index.js!./owl.carousel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".owl-carousel{display:none;width:100%;-webkit-tap-highlight-color:transparent;position:relative;z-index:1}.owl-carousel .owl-stage{position:relative;-ms-touch-action:pan-Y;touch-action:manipulation;-moz-backface-visibility:hidden}.owl-carousel .owl-stage:after{content:\".\";display:block;clear:both;visibility:hidden;line-height:0;height:0}.owl-carousel .owl-stage-outer{position:relative;overflow:hidden;-webkit-transform:translateZ(0)}.owl-carousel .owl-item,.owl-carousel .owl-wrapper{-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;-ms-backface-visibility:hidden;-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0)}.owl-carousel .owl-item{position:relative;min-height:1px;float:left;-webkit-backface-visibility:hidden;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none}.owl-carousel .owl-item img{display:block;width:100%}.owl-carousel .owl-dots.disabled,.owl-carousel .owl-nav.disabled{display:none}.owl-carousel .owl-dot,.owl-carousel .owl-nav .owl-next,.owl-carousel .owl-nav .owl-prev{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.owl-carousel .owl-nav button.owl-next,.owl-carousel .owl-nav button.owl-prev,.owl-carousel button.owl-dot{background:none;color:inherit;border:none;padding:0!important;font:inherit}.owl-carousel.owl-loaded{display:block}.owl-carousel.owl-loading{opacity:0;display:block}.owl-carousel.owl-hidden{opacity:0}.owl-carousel.owl-refresh .owl-item{visibility:hidden}.owl-carousel.owl-drag .owl-item{-ms-touch-action:pan-y;touch-action:pan-y;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.owl-carousel.owl-grab{cursor:move;cursor:grab}.owl-carousel.owl-rtl{direction:rtl}.owl-carousel.owl-rtl .owl-item{float:right}.no-js .owl-carousel{display:block}.owl-carousel .animated{animation-duration:1s;animation-fill-mode:both}.owl-carousel .owl-animated-in{z-index:0}.owl-carousel .owl-animated-out{z-index:1}.owl-carousel .fadeOut{animation-name:fadeOut}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.owl-height{transition:height .5s ease-in-out}.owl-carousel .owl-item .owl-lazy{opacity:0;transition:opacity .4s ease}.owl-carousel .owl-item .owl-lazy:not([src]),.owl-carousel .owl-item .owl-lazy[src^=\"\"]{max-height:0}.owl-carousel .owl-item img.owl-lazy{transform-style:preserve-3d}.owl-carousel .owl-video-wrapper{position:relative;height:100%;background:#000}.owl-carousel .owl-video-play-icon{position:absolute;height:80px;width:80px;left:50%;top:50%;margin-left:-40px;margin-top:-40px;background:url(" + __webpack_require__(497) + ") no-repeat;cursor:pointer;z-index:1;-webkit-backface-visibility:hidden;transition:transform .1s ease}.owl-carousel .owl-video-play-icon:hover{transform:scale(1.3)}.owl-carousel .owl-video-playing .owl-video-play-icon,.owl-carousel .owl-video-playing .owl-video-tn{display:none}.owl-carousel .owl-video-tn{opacity:0;height:100%;background-position:50%;background-repeat:no-repeat;background-size:contain;transition:opacity .4s ease}.owl-carousel .owl-video-frame{position:relative;z-index:1;height:100%;width:100%}", ""]);
	
	// exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "external/owl.carousel/dist/assets/owl.video.play.png.png";

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mindboxCarousel = __webpack_require__(493);
	
	var MindboxCategoryRecommendations = (function () {
	    function MindboxCategoryRecommendations() {
	        _classCallCheck(this, MindboxCategoryRecommendations);
	
	        this.container = (0, _jquery2['default'])('[data-mindbox-product="category"]');
	    }
	
	    _createClass(MindboxCategoryRecommendations, [{
	        key: 'init',
	        value: function init() {
	            if (this.container.length === 0) {
	                return;
	            }
	            var sectionId = this.container.attr('data-section-id');
	            var _self = this;
	            _jquery2['default'].ajax({
	                url: '/ajax/action/widget_mindbox_products/get_category_products/',
	                data: {
	                    sectionId: sectionId
	                },
	                type: 'GET',
	                success: function success(result) {
	                    console.log(result);
	                    if (result.data.status !== 'ok') {
	                        console.log('mindbox box not render');
	                        return;
	                    }
	
	                    _self.container.html(result.html);
	                    _mindboxCarousel.MindboxCarousel.init(_self.responsiveOptions());
	                }
	            });
	        }
	    }, {
	        key: 'responsiveOptions',
	        value: function responsiveOptions() {
	            return {
	                0: {
	                    items: 2,
	                    dots: true
	                },
	                481: {
	                    items: 2,
	                    dots: true
	                },
	                768: {
	                    items: 3,
	                    nav: true
	                },
	                992: {
	                    items: 3,
	                    nav: true
	                },
	                1200: {
	                    items: 5,
	                    nav: true
	                }
	            };
	        }
	    }]);
	
	    return MindboxCategoryRecommendations;
	})();
	
	exports.MindboxCategoryRecommendations = MindboxCategoryRecommendations;
	
	jQuery(function () {
	    new MindboxCategoryRecommendations().init();
	});

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mindboxCarousel = __webpack_require__(493);
	
	var MindboxRelatedRecommendations = (function () {
	    function MindboxRelatedRecommendations() {
	        _classCallCheck(this, MindboxRelatedRecommendations);
	
	        this.container = (0, _jquery2['default'])('[data-mindbox-product="related"]');
	    }
	
	    _createClass(MindboxRelatedRecommendations, [{
	        key: 'init',
	        value: function init() {
	            if (this.container.length === 0) {
	                return;
	            }
	
	            var productArticle = this.container.attr('data-product-article');
	            var _self = this;
	            _jquery2['default'].ajax({
	                url: '/ajax/action/widget_mindbox_products/get_related_products/',
	                data: {
	                    productArticle: productArticle
	                },
	                type: 'GET',
	                success: function success(result) {
	                    if (result.data.status !== 'ok') {
	                        console.log('mindbox box not render');
	                        return;
	                    }
	
	                    _self.container.html(result.html);
	                    _mindboxCarousel.MindboxCarousel.init(_self.responsiveOptions());
	                }
	            });
	        }
	    }, {
	        key: 'responsiveOptions',
	        value: function responsiveOptions() {
	            return {
	                0: {
	                    items: 2,
	                    dots: true
	                },
	                481: {
	                    items: 2,
	                    dots: true
	                },
	                768: {
	                    items: 3,
	                    nav: true
	                },
	                992: {
	                    items: 3,
	                    nav: true
	                },
	                1200: {
	                    items: 5,
	                    nav: true
	                }
	            };
	        }
	    }]);
	
	    return MindboxRelatedRecommendations;
	})();
	
	exports.MindboxRelatedRecommendations = MindboxRelatedRecommendations;
	
	jQuery(function () {
	    new MindboxRelatedRecommendations().init();
	});

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mindboxCarousel = __webpack_require__(493);
	
	var MindboxPopularRecommendations = (function () {
	    function MindboxPopularRecommendations() {
	        _classCallCheck(this, MindboxPopularRecommendations);
	
	        this.container = (0, _jquery2['default'])('[data-mindbox-product="popular"]');
	    }
	
	    _createClass(MindboxPopularRecommendations, [{
	        key: 'init',
	        value: function init() {
	            if (this.container.length === 0) {
	                return;
	            }
	
	            var _self = this;
	            _jquery2['default'].ajax({
	                url: '/ajax/action/widget_mindbox_products/get_popular_products/',
	                data: {},
	                type: 'GET',
	                success: function success(result) {
	                    if (result.data.status !== 'ok') {
	                        console.log('mindbox box not render');
	                        return;
	                    }
	
	                    _self.container.html(result.html);
	                    _mindboxCarousel.MindboxCarousel.init();
	                }
	            });
	        }
	    }]);
	
	    return MindboxPopularRecommendations;
	})();
	
	exports.MindboxPopularRecommendations = MindboxPopularRecommendations;
	
	jQuery(function () {
	    new MindboxPopularRecommendations().init();
	});

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mindboxCarousel = __webpack_require__(493);
	
	var MindboxSimilarRecommendations = (function () {
	    function MindboxSimilarRecommendations() {
	        _classCallCheck(this, MindboxSimilarRecommendations);
	
	        this.container = (0, _jquery2['default'])('[data-mindbox-product="similar"]');
	    }
	
	    _createClass(MindboxSimilarRecommendations, [{
	        key: 'init',
	        value: function init() {
	            if (this.container.length === 0) {
	                return;
	            }
	
	            var productArticle = this.container.attr('data-product-article');
	            var _self = this;
	            _jquery2['default'].ajax({
	                url: '/ajax/action/widget_mindbox_products/get_similar_products/',
	                data: {
	                    productArticle: productArticle
	                },
	                type: 'GET',
	                success: function success(result) {
	                    console.log(result);
	                    if (result.data.status !== 'ok') {
	                        console.log('mindbox box not render');
	                        return;
	                    }
	
	                    _self.container.html(result.html);
	                    _mindboxCarousel.MindboxCarousel.init(_self.responsiveOptions());
	                }
	            });
	        }
	    }, {
	        key: 'responsiveOptions',
	        value: function responsiveOptions() {
	            return {
	                0: {
	                    items: 2,
	                    dots: true
	                },
	                481: {
	                    items: 2,
	                    dots: true
	                },
	                768: {
	                    items: 3,
	                    nav: true
	                },
	                992: {
	                    items: 3,
	                    nav: true
	                },
	                1200: {
	                    items: 5,
	                    nav: true
	                }
	            };
	        }
	    }]);
	
	    return MindboxSimilarRecommendations;
	})();
	
	exports.MindboxSimilarRecommendations = MindboxSimilarRecommendations;
	
	jQuery(function () {
	    new MindboxSimilarRecommendations().init();
	});

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mindboxCarousel = __webpack_require__(493);
	
	var MindboxCartRelatedRecommendations = (function () {
	    function MindboxCartRelatedRecommendations() {
	        _classCallCheck(this, MindboxCartRelatedRecommendations);
	
	        this.container = (0, _jquery2['default'])('[data-mindbox-product="cart-related"]');
	    }
	
	    _createClass(MindboxCartRelatedRecommendations, [{
	        key: 'init',
	        value: function init() {
	            if (this.container.length === 0) {
	                return;
	            }
	
	            var _self = this;
	            _jquery2['default'].ajax({
	                url: '/ajax/action/widget_mindbox_products/get_cart_related_products/',
	                data: {},
	                type: 'GET',
	                success: function success(result) {
	                    if (result.data.status !== 'ok') {
	                        console.log('mindbox box not render');
	                        return;
	                    }
	
	                    _self.container.html(result.html);
	                    _mindboxCarousel.MindboxCarousel.init(_self.responsiveOptions());
	                }
	            });
	        }
	    }, {
	        key: 'responsiveOptions',
	        value: function responsiveOptions() {
	            return {
	                0: {
	                    items: 2,
	                    dots: true
	                },
	                481: {
	                    items: 2,
	                    dots: true
	                },
	                768: {
	                    items: 3,
	                    nav: true
	                },
	                992: {
	                    items: 3,
	                    nav: true
	                },
	                1200: {
	                    items: 5,
	                    nav: true
	                }
	            };
	        }
	    }]);
	
	    return MindboxCartRelatedRecommendations;
	})();
	
	exports.MindboxCartRelatedRecommendations = MindboxCartRelatedRecommendations;
	
	jQuery(function () {
	    new MindboxCartRelatedRecommendations().init();
	});

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mindboxCarousel = __webpack_require__(493);
	
	var MindboxCartEventRecommendations = (function () {
	    function MindboxCartEventRecommendations() {
	        _classCallCheck(this, MindboxCartEventRecommendations);
	
	        this.container = (0, _jquery2['default'])('[data-mindbox-product="cart-event"]');
	    }
	
	    _createClass(MindboxCartEventRecommendations, [{
	        key: 'init',
	        value: function init() {
	            if (this.container.length === 0) {
	                return;
	            }
	
	            var _self = this;
	            _jquery2['default'].ajax({
	                url: '/ajax/action/widget_mindbox_products/get_cart_event_products/',
	                data: {},
	                type: 'GET',
	                success: function success(result) {
	                    if (result.data.status !== 'ok') {
	                        console.log('mindbox box not render');
	                        return;
	                    }
	
	                    _self.container.html(result.html);
	                    _mindboxCarousel.MindboxCarousel.init(_self.responsiveOptions());
	                }
	            });
	        }
	    }, {
	        key: 'responsiveOptions',
	        value: function responsiveOptions() {
	            return {
	                0: {
	                    items: 2,
	                    dots: true
	                },
	                481: {
	                    items: 2,
	                    dots: true
	                },
	                768: {
	                    items: 3,
	                    nav: true
	                },
	                992: {
	                    items: 3,
	                    nav: true
	                },
	                1200: {
	                    items: 5,
	                    nav: true
	                }
	            };
	        }
	    }]);
	
	    return MindboxCartEventRecommendations;
	})();
	
	exports.MindboxCartEventRecommendations = MindboxCartEventRecommendations;
	
	jQuery(function () {
	    new MindboxCartEventRecommendations().init();
	});

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */,
/* 506 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */,
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! picturefill - v3.0.2 - 2016-02-12
	 * https://scottjehl.github.io/picturefill/
	 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
	 */
	/*! Gecko-Picture - v1.0
	 * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
	 * Firefox's early picture implementation (prior to FF41) is static and does
	 * not react to viewport changes. This tiny module fixes this.
	 */
	(function(window) {
		/*jshint eqnull:true */
		var ua = navigator.userAgent;
	
		if ( window.HTMLPictureElement && ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 < 45) ) {
			addEventListener("resize", (function() {
				var timer;
	
				var dummySrc = document.createElement("source");
	
				var fixRespimg = function(img) {
					var source, sizes;
					var picture = img.parentNode;
	
					if (picture.nodeName.toUpperCase() === "PICTURE") {
						source = dummySrc.cloneNode();
	
						picture.insertBefore(source, picture.firstElementChild);
						setTimeout(function() {
							picture.removeChild(source);
						});
					} else if (!img._pfLastSize || img.offsetWidth > img._pfLastSize) {
						img._pfLastSize = img.offsetWidth;
						sizes = img.sizes;
						img.sizes += ",100vw";
						setTimeout(function() {
							img.sizes = sizes;
						});
					}
				};
	
				var findPictureImgs = function() {
					var i;
					var imgs = document.querySelectorAll("picture > img, img[srcset][sizes]");
					for (i = 0; i < imgs.length; i++) {
						fixRespimg(imgs[i]);
					}
				};
				var onResize = function() {
					clearTimeout(timer);
					timer = setTimeout(findPictureImgs, 99);
				};
				var mq = window.matchMedia && matchMedia("(orientation: landscape)");
				var init = function() {
					onResize();
	
					if (mq && mq.addListener) {
						mq.addListener(onResize);
					}
				};
	
				dummySrc.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
	
				if (/^[c|i]|d$/.test(document.readyState || "")) {
					init();
				} else {
					document.addEventListener("DOMContentLoaded", init);
				}
	
				return onResize;
			})());
		}
	})(window);
	
	/*! Picturefill - v3.0.2
	 * http://scottjehl.github.io/picturefill
	 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
	 *  License: MIT
	 */
	
	(function( window, document, undefined ) {
		// Enable strict mode
		"use strict";
	
		// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
		document.createElement( "picture" );
	
		var warn, eminpx, alwaysCheckWDescriptor, evalId;
		// local object for method references and testing exposure
		var pf = {};
		var isSupportTestReady = false;
		var noop = function() {};
		var image = document.createElement( "img" );
		var getImgAttr = image.getAttribute;
		var setImgAttr = image.setAttribute;
		var removeImgAttr = image.removeAttribute;
		var docElem = document.documentElement;
		var types = {};
		var cfg = {
			//resource selection:
			algorithm: ""
		};
		var srcAttr = "data-pfsrc";
		var srcsetAttr = srcAttr + "set";
		// ua sniffing is done for undetectable img loading features,
		// to do some non crucial perf optimizations
		var ua = navigator.userAgent;
		var supportAbort = (/rident/).test(ua) || ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35 );
		var curSrcProp = "currentSrc";
		var regWDesc = /\s+\+?\d+(e\d+)?w/;
		var regSize = /(\([^)]+\))?\s*(.+)/;
		var setOptions = window.picturefillCFG;
		/**
		 * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
		 */
		// baseStyle also used by getEmValue (i.e.: width: 1em is important)
		var baseStyle = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
		var fsCss = "font-size:100%!important;";
		var isVwDirty = true;
	
		var cssCache = {};
		var sizeLengthCache = {};
		var DPR = window.devicePixelRatio;
		var units = {
			px: 1,
			"in": 96
		};
		var anchor = document.createElement( "a" );
		/**
		 * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
		 * @type {boolean}
		 */
		var alreadyRun = false;
	
		// Reusable, non-"g" Regexes
	
		// (Don't use \s, to avoid matching non-breaking space.)
		var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
		    regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
		    regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
		    regexTrailingCommas = /[,]+$/,
		    regexNonNegativeInteger = /^\d+$/,
	
		    // ( Positive or negative or unsigned integers or decimals, without or without exponents.
		    // Must include at least one digit.
		    // According to spec tests any decimal point must be followed by a digit.
		    // No leading plus sign is allowed.)
		    // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
		    regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;
	
		var on = function(obj, evt, fn, capture) {
			if ( obj.addEventListener ) {
				obj.addEventListener(evt, fn, capture || false);
			} else if ( obj.attachEvent ) {
				obj.attachEvent( "on" + evt, fn);
			}
		};
	
		/**
		 * simple memoize function:
		 */
	
		var memoize = function(fn) {
			var cache = {};
			return function(input) {
				if ( !(input in cache) ) {
					cache[ input ] = fn(input);
				}
				return cache[ input ];
			};
		};
	
		// UTILITY FUNCTIONS
	
		// Manual is faster than RegEx
		// http://jsperf.com/whitespace-character/5
		function isSpace(c) {
			return (c === "\u0020" || // space
			        c === "\u0009" || // horizontal tab
			        c === "\u000A" || // new line
			        c === "\u000C" || // form feed
			        c === "\u000D");  // carriage return
		}
	
		/**
		 * gets a mediaquery and returns a boolean or gets a css length and returns a number
		 * @param css mediaqueries or css length
		 * @returns {boolean|number}
		 *
		 * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
		 */
		var evalCSS = (function() {
	
			var regLength = /^([\d\.]+)(em|vw|px)$/;
			var replace = function() {
				var args = arguments, index = 0, string = args[0];
				while (++index in args) {
					string = string.replace(args[index], args[++index]);
				}
				return string;
			};
	
			var buildStr = memoize(function(css) {
	
				return "return " + replace((css || "").toLowerCase(),
					// interpret `and`
					/\band\b/g, "&&",
	
					// interpret `,`
					/,/g, "||",
	
					// interpret `min-` as >=
					/min-([a-z-\s]+):/g, "e.$1>=",
	
					// interpret `max-` as <=
					/max-([a-z-\s]+):/g, "e.$1<=",
	
					//calc value
					/calc([^)]+)/g, "($1)",
	
					// interpret css values
					/(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)",
					//make eval less evil
					/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/ig, ""
				) + ";";
			});
	
			return function(css, length) {
				var parsedLength;
				if (!(css in cssCache)) {
					cssCache[css] = false;
					if (length && (parsedLength = css.match( regLength ))) {
						cssCache[css] = parsedLength[ 1 ] * units[parsedLength[ 2 ]];
					} else {
						/*jshint evil:true */
						try{
							cssCache[css] = new Function("e", buildStr(css))(units);
						} catch(e) {}
						/*jshint evil:false */
					}
				}
				return cssCache[css];
			};
		})();
	
		var setResolution = function( candidate, sizesattr ) {
			if ( candidate.w ) { // h = means height: || descriptor.type === 'h' do not handle yet...
				candidate.cWidth = pf.calcListLength( sizesattr || "100vw" );
				candidate.res = candidate.w / candidate.cWidth ;
			} else {
				candidate.res = candidate.d;
			}
			return candidate;
		};
	
		/**
		 *
		 * @param opt
		 */
		var picturefill = function( opt ) {
	
			if (!isSupportTestReady) {return;}
	
			var elements, i, plen;
	
			var options = opt || {};
	
			if ( options.elements && options.elements.nodeType === 1 ) {
				if ( options.elements.nodeName.toUpperCase() === "IMG" ) {
					options.elements =  [ options.elements ];
				} else {
					options.context = options.elements;
					options.elements =  null;
				}
			}
	
			elements = options.elements || pf.qsa( (options.context || document), ( options.reevaluate || options.reselect ) ? pf.sel : pf.selShort );
	
			if ( (plen = elements.length) ) {
	
				pf.setupRun( options );
				alreadyRun = true;
	
				// Loop through all elements
				for ( i = 0; i < plen; i++ ) {
					pf.fillImg(elements[ i ], options);
				}
	
				pf.teardownRun( options );
			}
		};
	
		/**
		 * outputs a warning for the developer
		 * @param {message}
		 * @type {Function}
		 */
		warn = ( window.console && console.warn ) ?
			function( message ) {
				console.warn( message );
			} :
			noop
		;
	
		if ( !(curSrcProp in image) ) {
			curSrcProp = "src";
		}
	
		// Add support for standard mime types.
		types[ "image/jpeg" ] = true;
		types[ "image/gif" ] = true;
		types[ "image/png" ] = true;
	
		function detectTypeSupport( type, typeUri ) {
			// based on Modernizr's lossless img-webp test
			// note: asynchronous
			var image = new window.Image();
			image.onerror = function() {
				types[ type ] = false;
				picturefill();
			};
			image.onload = function() {
				types[ type ] = image.width === 1;
				picturefill();
			};
			image.src = typeUri;
			return "pending";
		}
	
		// test svg support
		types[ "image/svg+xml" ] = document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );
	
		/**
		 * updates the internal vW property with the current viewport width in px
		 */
		function updateMetrics() {
	
			isVwDirty = false;
			DPR = window.devicePixelRatio;
			cssCache = {};
			sizeLengthCache = {};
	
			pf.DPR = DPR || 1;
	
			units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
			units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);
	
			units.vw = units.width / 100;
			units.vh = units.height / 100;
	
			evalId = [ units.height, units.width, DPR ].join("-");
	
			units.em = pf.getEmValue();
			units.rem = units.em;
		}
	
		function chooseLowRes( lowerValue, higherValue, dprValue, isCached ) {
			var bonusFactor, tooMuch, bonus, meanDensity;
	
			//experimental
			if (cfg.algorithm === "saveData" ){
				if ( lowerValue > 2.7 ) {
					meanDensity = dprValue + 1;
				} else {
					tooMuch = higherValue - dprValue;
					bonusFactor = Math.pow(lowerValue - 0.6, 1.5);
	
					bonus = tooMuch * bonusFactor;
	
					if (isCached) {
						bonus += 0.1 * bonusFactor;
					}
	
					meanDensity = lowerValue + bonus;
				}
			} else {
				meanDensity = (dprValue > 1) ?
					Math.sqrt(lowerValue * higherValue) :
					lowerValue;
			}
	
			return meanDensity > dprValue;
		}
	
		function applyBestCandidate( img ) {
			var srcSetCandidates;
			var matchingSet = pf.getSet( img );
			var evaluated = false;
			if ( matchingSet !== "pending" ) {
				evaluated = evalId;
				if ( matchingSet ) {
					srcSetCandidates = pf.setRes( matchingSet );
					pf.applySetCandidate( srcSetCandidates, img );
				}
			}
			img[ pf.ns ].evaled = evaluated;
		}
	
		function ascendingSort( a, b ) {
			return a.res - b.res;
		}
	
		function setSrcToCur( img, src, set ) {
			var candidate;
			if ( !set && src ) {
				set = img[ pf.ns ].sets;
				set = set && set[set.length - 1];
			}
	
			candidate = getCandidateForSrc(src, set);
	
			if ( candidate ) {
				src = pf.makeUrl(src);
				img[ pf.ns ].curSrc = src;
				img[ pf.ns ].curCan = candidate;
	
				if ( !candidate.res ) {
					setResolution( candidate, candidate.set.sizes );
				}
			}
			return candidate;
		}
	
		function getCandidateForSrc( src, set ) {
			var i, candidate, candidates;
			if ( src && set ) {
				candidates = pf.parseSet( set );
				src = pf.makeUrl(src);
				for ( i = 0; i < candidates.length; i++ ) {
					if ( src === pf.makeUrl(candidates[ i ].url) ) {
						candidate = candidates[ i ];
						break;
					}
				}
			}
			return candidate;
		}
	
		function getAllSourceElements( picture, candidates ) {
			var i, len, source, srcset;
	
			// SPEC mismatch intended for size and perf:
			// actually only source elements preceding the img should be used
			// also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
			var sources = picture.getElementsByTagName( "source" );
	
			for ( i = 0, len = sources.length; i < len; i++ ) {
				source = sources[ i ];
				source[ pf.ns ] = true;
				srcset = source.getAttribute( "srcset" );
	
				// if source does not have a srcset attribute, skip
				if ( srcset ) {
					candidates.push( {
						srcset: srcset,
						media: source.getAttribute( "media" ),
						type: source.getAttribute( "type" ),
						sizes: source.getAttribute( "sizes" )
					} );
				}
			}
		}
	
		/**
		 * Srcset Parser
		 * By Alex Bell |  MIT License
		 *
		 * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
		 *
		 * Based super duper closely on the reference algorithm at:
		 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
		 */
	
		// 1. Let input be the value passed to this algorithm.
		// (TO-DO : Explain what "set" argument is here. Maybe choose a more
		// descriptive & more searchable name.  Since passing the "set" in really has
		// nothing to do with parsing proper, I would prefer this assignment eventually
		// go in an external fn.)
		function parseSrcset(input, set) {
	
			function collectCharacters(regEx) {
				var chars,
				    match = regEx.exec(input.substring(pos));
				if (match) {
					chars = match[ 0 ];
					pos += chars.length;
					return chars;
				}
			}
	
			var inputLength = input.length,
			    url,
			    descriptors,
			    currentDescriptor,
			    state,
			    c,
	
			    // 2. Let position be a pointer into input, initially pointing at the start
			    //    of the string.
			    pos = 0,
	
			    // 3. Let candidates be an initially empty source set.
			    candidates = [];
	
			/**
			* Adds descriptor properties to a candidate, pushes to the candidates array
			* @return undefined
			*/
			// (Declared outside of the while loop so that it's only created once.
			// (This fn is defined before it is used, in order to pass JSHINT.
			// Unfortunately this breaks the sequencing of the spec comments. :/ )
			function parseDescriptors() {
	
				// 9. Descriptor parser: Let error be no.
				var pError = false,
	
				// 10. Let width be absent.
				// 11. Let density be absent.
				// 12. Let future-compat-h be absent. (We're implementing it now as h)
				    w, d, h, i,
				    candidate = {},
				    desc, lastChar, value, intVal, floatVal;
	
				// 13. For each descriptor in descriptors, run the appropriate set of steps
				// from the following list:
				for (i = 0 ; i < descriptors.length; i++) {
					desc = descriptors[ i ];
	
					lastChar = desc[ desc.length - 1 ];
					value = desc.substring(0, desc.length - 1);
					intVal = parseInt(value, 10);
					floatVal = parseFloat(value);
	
					// If the descriptor consists of a valid non-negative integer followed by
					// a U+0077 LATIN SMALL LETTER W character
					if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {
	
						// If width and density are not both absent, then let error be yes.
						if (w || d) {pError = true;}
	
						// Apply the rules for parsing non-negative integers to the descriptor.
						// If the result is zero, let error be yes.
						// Otherwise, let width be the result.
						if (intVal === 0) {pError = true;} else {w = intVal;}
	
					// If the descriptor consists of a valid floating-point number followed by
					// a U+0078 LATIN SMALL LETTER X character
					} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {
	
						// If width, density and future-compat-h are not all absent, then let error
						// be yes.
						if (w || d || h) {pError = true;}
	
						// Apply the rules for parsing floating-point number values to the descriptor.
						// If the result is less than zero, let error be yes. Otherwise, let density
						// be the result.
						if (floatVal < 0) {pError = true;} else {d = floatVal;}
	
					// If the descriptor consists of a valid non-negative integer followed by
					// a U+0068 LATIN SMALL LETTER H character
					} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {
	
						// If height and density are not both absent, then let error be yes.
						if (h || d) {pError = true;}
	
						// Apply the rules for parsing non-negative integers to the descriptor.
						// If the result is zero, let error be yes. Otherwise, let future-compat-h
						// be the result.
						if (intVal === 0) {pError = true;} else {h = intVal;}
	
					// Anything else, Let error be yes.
					} else {pError = true;}
				} // (close step 13 for loop)
	
				// 15. If error is still no, then append a new image source to candidates whose
				// URL is url, associated with a width width if not absent and a pixel
				// density density if not absent. Otherwise, there is a parse error.
				if (!pError) {
					candidate.url = url;
	
					if (w) { candidate.w = w;}
					if (d) { candidate.d = d;}
					if (h) { candidate.h = h;}
					if (!h && !d && !w) {candidate.d = 1;}
					if (candidate.d === 1) {set.has1x = true;}
					candidate.set = set;
	
					candidates.push(candidate);
				}
			} // (close parseDescriptors fn)
	
			/**
			* Tokenizes descriptor properties prior to parsing
			* Returns undefined.
			* (Again, this fn is defined before it is used, in order to pass JSHINT.
			* Unfortunately this breaks the logical sequencing of the spec comments. :/ )
			*/
			function tokenize() {
	
				// 8.1. Descriptor tokeniser: Skip whitespace
				collectCharacters(regexLeadingSpaces);
	
				// 8.2. Let current descriptor be the empty string.
				currentDescriptor = "";
	
				// 8.3. Let state be in descriptor.
				state = "in descriptor";
	
				while (true) {
	
					// 8.4. Let c be the character at position.
					c = input.charAt(pos);
	
					//  Do the following depending on the value of state.
					//  For the purpose of this step, "EOF" is a special character representing
					//  that position is past the end of input.
	
					// In descriptor
					if (state === "in descriptor") {
						// Do the following, depending on the value of c:
	
					  // Space character
					  // If current descriptor is not empty, append current descriptor to
					  // descriptors and let current descriptor be the empty string.
					  // Set state to after descriptor.
						if (isSpace(c)) {
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
								currentDescriptor = "";
								state = "after descriptor";
							}
	
						// U+002C COMMA (,)
						// Advance position to the next character in input. If current descriptor
						// is not empty, append current descriptor to descriptors. Jump to the step
						// labeled descriptor parser.
						} else if (c === ",") {
							pos += 1;
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
							}
							parseDescriptors();
							return;
	
						// U+0028 LEFT PARENTHESIS (()
						// Append c to current descriptor. Set state to in parens.
						} else if (c === "\u0028") {
							currentDescriptor = currentDescriptor + c;
							state = "in parens";
	
						// EOF
						// If current descriptor is not empty, append current descriptor to
						// descriptors. Jump to the step labeled descriptor parser.
						} else if (c === "") {
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
							}
							parseDescriptors();
							return;
	
						// Anything else
						// Append c to current descriptor.
						} else {
							currentDescriptor = currentDescriptor + c;
						}
					// (end "in descriptor"
	
					// In parens
					} else if (state === "in parens") {
	
						// U+0029 RIGHT PARENTHESIS ())
						// Append c to current descriptor. Set state to in descriptor.
						if (c === ")") {
							currentDescriptor = currentDescriptor + c;
							state = "in descriptor";
	
						// EOF
						// Append current descriptor to descriptors. Jump to the step labeled
						// descriptor parser.
						} else if (c === "") {
							descriptors.push(currentDescriptor);
							parseDescriptors();
							return;
	
						// Anything else
						// Append c to current descriptor.
						} else {
							currentDescriptor = currentDescriptor + c;
						}
	
					// After descriptor
					} else if (state === "after descriptor") {
	
						// Do the following, depending on the value of c:
						// Space character: Stay in this state.
						if (isSpace(c)) {
	
						// EOF: Jump to the step labeled descriptor parser.
						} else if (c === "") {
							parseDescriptors();
							return;
	
						// Anything else
						// Set state to in descriptor. Set position to the previous character in input.
						} else {
							state = "in descriptor";
							pos -= 1;
	
						}
					}
	
					// Advance position to the next character in input.
					pos += 1;
	
				// Repeat this step.
				} // (close while true loop)
			}
	
			// 4. Splitting loop: Collect a sequence of characters that are space
			//    characters or U+002C COMMA characters. If any U+002C COMMA characters
			//    were collected, that is a parse error.
			while (true) {
				collectCharacters(regexLeadingCommasOrSpaces);
	
				// 5. If position is past the end of input, return candidates and abort these steps.
				if (pos >= inputLength) {
					return candidates; // (we're done, this is the sole return path)
				}
	
				// 6. Collect a sequence of characters that are not space characters,
				//    and let that be url.
				url = collectCharacters(regexLeadingNotSpaces);
	
				// 7. Let descriptors be a new empty list.
				descriptors = [];
	
				// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
				//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
				//         more than one character, that is a parse error.
				if (url.slice(-1) === ",") {
					url = url.replace(regexTrailingCommas, "");
					// (Jump ahead to step 9 to skip tokenization and just push the candidate).
					parseDescriptors();
	
				//	Otherwise, follow these substeps:
				} else {
					tokenize();
				} // (close else of step 8)
	
			// 16. Return to the step labeled splitting loop.
			} // (Close of big while loop.)
		}
	
		/*
		 * Sizes Parser
		 *
		 * By Alex Bell |  MIT License
		 *
		 * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
		 *
		 * Reference algorithm at:
		 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
		 *
		 * Most comments are copied in directly from the spec
		 * (except for comments in parens).
		 *
		 * Grammar is:
		 * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
		 * <source-size> = <media-condition> <source-size-value>
		 * <source-size-value> = <length>
		 * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
		 *
		 * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
		 * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
		 *
		 * Returns the first valid <css-length> with a media condition that evaluates to true,
		 * or "100vw" if all valid media conditions evaluate to false.
		 *
		 */
	
		function parseSizes(strValue) {
	
			// (Percentage CSS lengths are not allowed in this case, to avoid confusion:
			// https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
			// CSS allows a single optional plus or minus sign:
			// http://www.w3.org/TR/CSS2/syndata.html#numbers
			// CSS is ASCII case-insensitive:
			// http://www.w3.org/TR/CSS2/syndata.html#characters )
			// Spec allows exponential notation for <number> type:
			// http://dev.w3.org/csswg/css-values/#numbers
			var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;
	
			// (This is a quick and lenient test. Because of optional unlimited-depth internal
			// grouping parens and strict spacing rules, this could get very complicated.)
			var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;
	
			var i;
			var unparsedSizesList;
			var unparsedSizesListLength;
			var unparsedSize;
			var lastComponentValue;
			var size;
	
			// UTILITY FUNCTIONS
	
			//  (Toy CSS parser. The goals here are:
			//  1) expansive test coverage without the weight of a full CSS parser.
			//  2) Avoiding regex wherever convenient.
			//  Quick tests: http://jsfiddle.net/gtntL4gr/3/
			//  Returns an array of arrays.)
			function parseComponentValues(str) {
				var chrctr;
				var component = "";
				var componentArray = [];
				var listArray = [];
				var parenDepth = 0;
				var pos = 0;
				var inComment = false;
	
				function pushComponent() {
					if (component) {
						componentArray.push(component);
						component = "";
					}
				}
	
				function pushComponentArray() {
					if (componentArray[0]) {
						listArray.push(componentArray);
						componentArray = [];
					}
				}
	
				// (Loop forwards from the beginning of the string.)
				while (true) {
					chrctr = str.charAt(pos);
	
					if (chrctr === "") { // ( End of string reached.)
						pushComponent();
						pushComponentArray();
						return listArray;
					} else if (inComment) {
						if ((chrctr === "*") && (str[pos + 1] === "/")) { // (At end of a comment.)
							inComment = false;
							pos += 2;
							pushComponent();
							continue;
						} else {
							pos += 1; // (Skip all characters inside comments.)
							continue;
						}
					} else if (isSpace(chrctr)) {
						// (If previous character in loop was also a space, or if
						// at the beginning of the string, do not add space char to
						// component.)
						if ( (str.charAt(pos - 1) && isSpace( str.charAt(pos - 1) ) ) || !component ) {
							pos += 1;
							continue;
						} else if (parenDepth === 0) {
							pushComponent();
							pos +=1;
							continue;
						} else {
							// (Replace any space character with a plain space for legibility.)
							chrctr = " ";
						}
					} else if (chrctr === "(") {
						parenDepth += 1;
					} else if (chrctr === ")") {
						parenDepth -= 1;
					} else if (chrctr === ",") {
						pushComponent();
						pushComponentArray();
						pos += 1;
						continue;
					} else if ( (chrctr === "/") && (str.charAt(pos + 1) === "*") ) {
						inComment = true;
						pos += 2;
						continue;
					}
	
					component = component + chrctr;
					pos += 1;
				}
			}
	
			function isValidNonNegativeSourceSizeValue(s) {
				if (regexCssLengthWithUnits.test(s) && (parseFloat(s) >= 0)) {return true;}
				if (regexCssCalc.test(s)) {return true;}
				// ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
				// "-0 is equivalent to 0 and is not a negative number." which means that
				// unitless zero and unitless negative zero must be accepted as special cases.)
				if ((s === "0") || (s === "-0") || (s === "+0")) {return true;}
				return false;
			}
	
			// When asked to parse a sizes attribute from an element, parse a
			// comma-separated list of component values from the value of the element's
			// sizes attribute (or the empty string, if the attribute is absent), and let
			// unparsed sizes list be the result.
			// http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values
	
			unparsedSizesList = parseComponentValues(strValue);
			unparsedSizesListLength = unparsedSizesList.length;
	
			// For each unparsed size in unparsed sizes list:
			for (i = 0; i < unparsedSizesListLength; i++) {
				unparsedSize = unparsedSizesList[i];
	
				// 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
				// ( parseComponentValues() already omits spaces outside of parens. )
	
				// If unparsed size is now empty, that is a parse error; continue to the next
				// iteration of this algorithm.
				// ( parseComponentValues() won't push an empty array. )
	
				// 2. If the last component value in unparsed size is a valid non-negative
				// <source-size-value>, let size be its value and remove the component value
				// from unparsed size. Any CSS function other than the calc() function is
				// invalid. Otherwise, there is a parse error; continue to the next iteration
				// of this algorithm.
				// http://dev.w3.org/csswg/css-syntax/#parse-component-value
				lastComponentValue = unparsedSize[unparsedSize.length - 1];
	
				if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
					size = lastComponentValue;
					unparsedSize.pop();
				} else {
					continue;
				}
	
				// 3. Remove all consecutive <whitespace-token>s from the end of unparsed
				// size. If unparsed size is now empty, return size and exit this algorithm.
				// If this was not the last item in unparsed sizes list, that is a parse error.
				if (unparsedSize.length === 0) {
					return size;
				}
	
				// 4. Parse the remaining component values in unparsed size as a
				// <media-condition>. If it does not parse correctly, or it does parse
				// correctly but the <media-condition> evaluates to false, continue to the
				// next iteration of this algorithm.
				// (Parsing all possible compound media conditions in JS is heavy, complicated,
				// and the payoff is unclear. Is there ever an situation where the
				// media condition parses incorrectly but still somehow evaluates to true?
				// Can we just rely on the browser/polyfill to do it?)
				unparsedSize = unparsedSize.join(" ");
				if (!(pf.matchesMedia( unparsedSize ) ) ) {
					continue;
				}
	
				// 5. Return size and exit this algorithm.
				return size;
			}
	
			// If the above algorithm exhausts unparsed sizes list without returning a
			// size value, return 100vw.
			return "100vw";
		}
	
		// namespace
		pf.ns = ("pf" + new Date().getTime()).substr(0, 9);
	
		// srcset support test
		pf.supSrcset = "srcset" in image;
		pf.supSizes = "sizes" in image;
		pf.supPicture = !!window.HTMLPictureElement;
	
		// UC browser does claim to support srcset and picture, but not sizes,
		// this extended test reveals the browser does support nothing
		if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
			(function(image2) {
				image.srcset = "data:,a";
				image2.src = "data:,a";
				pf.supSrcset = image.complete === image2.complete;
				pf.supPicture = pf.supSrcset && pf.supPicture;
			})(document.createElement("img"));
		}
	
		// Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
		if (pf.supSrcset && !pf.supSizes) {
	
			(function() {
				var width2 = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
				var width1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
				var img = document.createElement("img");
				var test = function() {
					var width = img.width;
	
					if (width === 2) {
						pf.supSizes = true;
					}
	
					alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;
	
					isSupportTestReady = true;
					// force async
					setTimeout(picturefill);
				};
	
				img.onload = test;
				img.onerror = test;
				img.setAttribute("sizes", "9px");
	
				img.srcset = width1 + " 1w," + width2 + " 9w";
				img.src = width1;
			})();
	
		} else {
			isSupportTestReady = true;
		}
	
		// using pf.qsa instead of dom traversing does scale much better,
		// especially on sites mixing responsive and non-responsive images
		pf.selShort = "picture>img,img[srcset]";
		pf.sel = pf.selShort;
		pf.cfg = cfg;
	
		/**
		 * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
		 */
		pf.DPR = (DPR  || 1 );
		pf.u = units;
	
		// container of supported mime types that one might need to qualify before using
		pf.types =  types;
	
		pf.setSize = noop;
	
		/**
		 * Gets a string and returns the absolute URL
		 * @param src
		 * @returns {String} absolute URL
		 */
	
		pf.makeUrl = memoize(function(src) {
			anchor.href = src;
			return anchor.href;
		});
	
		/**
		 * Gets a DOM element or document and a selctor and returns the found matches
		 * Can be extended with jQuery/Sizzle for IE7 support
		 * @param context
		 * @param sel
		 * @returns {NodeList|Array}
		 */
		pf.qsa = function(context, sel) {
			return ( "querySelector" in context ) ? context.querySelectorAll(sel) : [];
		};
	
		/**
		 * Shortcut method for matchMedia ( for easy overriding in tests )
		 * wether native or pf.mMQ is used will be decided lazy on first call
		 * @returns {boolean}
		 */
		pf.matchesMedia = function() {
			if ( window.matchMedia && (matchMedia( "(min-width: 0.1em)" ) || {}).matches ) {
				pf.matchesMedia = function( media ) {
					return !media || ( matchMedia( media ).matches );
				};
			} else {
				pf.matchesMedia = pf.mMQ;
			}
	
			return pf.matchesMedia.apply( this, arguments );
		};
	
		/**
		 * A simplified matchMedia implementation for IE8 and IE9
		 * handles only min-width/max-width with px or em values
		 * @param media
		 * @returns {boolean}
		 */
		pf.mMQ = function( media ) {
			return media ? evalCSS(media) : true;
		};
	
		/**
		 * Returns the calculated length in css pixel from the given sourceSizeValue
		 * http://dev.w3.org/csswg/css-values-3/#length-value
		 * intended Spec mismatches:
		 * * Does not check for invalid use of CSS functions
		 * * Does handle a computed length of 0 the same as a negative and therefore invalid value
		 * @param sourceSizeValue
		 * @returns {Number}
		 */
		pf.calcLength = function( sourceSizeValue ) {
	
			var value = evalCSS(sourceSizeValue, true) || false;
			if (value < 0) {
				value = false;
			}
	
			return value;
		};
	
		/**
		 * Takes a type string and checks if its supported
		 */
	
		pf.supportsType = function( type ) {
			return ( type ) ? types[ type ] : true;
		};
	
		/**
		 * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
		 * @param sourceSizeStr
		 * @returns {*}
		 */
		pf.parseSize = memoize(function( sourceSizeStr ) {
			var match = ( sourceSizeStr || "" ).match(regSize);
			return {
				media: match && match[1],
				length: match && match[2]
			};
		});
	
		pf.parseSet = function( set ) {
			if ( !set.cands ) {
				set.cands = parseSrcset(set.srcset, set);
			}
			return set.cands;
		};
	
		/**
		 * returns 1em in css px for html/body default size
		 * function taken from respondjs
		 * @returns {*|number}
		 */
		pf.getEmValue = function() {
			var body;
			if ( !eminpx && (body = document.body) ) {
				var div = document.createElement( "div" ),
					originalHTMLCSS = docElem.style.cssText,
					originalBodyCSS = body.style.cssText;
	
				div.style.cssText = baseStyle;
	
				// 1em in a media query is the value of the default font size of the browser
				// reset docElem and body to ensure the correct value is returned
				docElem.style.cssText = fsCss;
				body.style.cssText = fsCss;
	
				body.appendChild( div );
				eminpx = div.offsetWidth;
				body.removeChild( div );
	
				//also update eminpx before returning
				eminpx = parseFloat( eminpx, 10 );
	
				// restore the original values
				docElem.style.cssText = originalHTMLCSS;
				body.style.cssText = originalBodyCSS;
	
			}
			return eminpx || 16;
		};
	
		/**
		 * Takes a string of sizes and returns the width in pixels as a number
		 */
		pf.calcListLength = function( sourceSizeListStr ) {
			// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
			//
			//                           or (min-width:30em) calc(30% - 15px)
			if ( !(sourceSizeListStr in sizeLengthCache) || cfg.uT ) {
				var winningLength = pf.calcLength( parseSizes( sourceSizeListStr ) );
	
				sizeLengthCache[ sourceSizeListStr ] = !winningLength ? units.width : winningLength;
			}
	
			return sizeLengthCache[ sourceSizeListStr ];
		};
	
		/**
		 * Takes a candidate object with a srcset property in the form of url/
		 * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
		 *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
		 *     "images/pic-small.png"
		 * Get an array of image candidates in the form of
		 *      {url: "/foo/bar.png", resolution: 1}
		 * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
		 * If sizes is specified, res is calculated
		 */
		pf.setRes = function( set ) {
			var candidates;
			if ( set ) {
	
				candidates = pf.parseSet( set );
	
				for ( var i = 0, len = candidates.length; i < len; i++ ) {
					setResolution( candidates[ i ], set.sizes );
				}
			}
			return candidates;
		};
	
		pf.setRes.res = setResolution;
	
		pf.applySetCandidate = function( candidates, img ) {
			if ( !candidates.length ) {return;}
			var candidate,
				i,
				j,
				length,
				bestCandidate,
				curSrc,
				curCan,
				candidateSrc,
				abortCurSrc;
	
			var imageData = img[ pf.ns ];
			var dpr = pf.DPR;
	
			curSrc = imageData.curSrc || img[curSrcProp];
	
			curCan = imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);
	
			// if we have a current source, we might either become lazy or give this source some advantage
			if ( curCan && curCan.set === candidates[ 0 ].set ) {
	
				// if browser can abort image request and the image has a higher pixel density than needed
				// and this image isn't downloaded yet, we skip next part and try to save bandwidth
				abortCurSrc = (supportAbort && !img.complete && curCan.res - 0.1 > dpr);
	
				if ( !abortCurSrc ) {
					curCan.cached = true;
	
					// if current candidate is "best", "better" or "okay",
					// set it to bestCandidate
					if ( curCan.res >= dpr ) {
						bestCandidate = curCan;
					}
				}
			}
	
			if ( !bestCandidate ) {
	
				candidates.sort( ascendingSort );
	
				length = candidates.length;
				bestCandidate = candidates[ length - 1 ];
	
				for ( i = 0; i < length; i++ ) {
					candidate = candidates[ i ];
					if ( candidate.res >= dpr ) {
						j = i - 1;
	
						// we have found the perfect candidate,
						// but let's improve this a little bit with some assumptions ;-)
						if (candidates[ j ] &&
							(abortCurSrc || curSrc !== pf.makeUrl( candidate.url )) &&
							chooseLowRes(candidates[ j ].res, candidate.res, dpr, candidates[ j ].cached)) {
	
							bestCandidate = candidates[ j ];
	
						} else {
							bestCandidate = candidate;
						}
						break;
					}
				}
			}
	
			if ( bestCandidate ) {
	
				candidateSrc = pf.makeUrl( bestCandidate.url );
	
				imageData.curSrc = candidateSrc;
				imageData.curCan = bestCandidate;
	
				if ( candidateSrc !== curSrc ) {
					pf.setSrc( img, bestCandidate );
				}
				pf.setSize( img );
			}
		};
	
		pf.setSrc = function( img, bestCandidate ) {
			var origWidth;
			img.src = bestCandidate.url;
	
			// although this is a specific Safari issue, we don't want to take too much different code paths
			if ( bestCandidate.set.type === "image/svg+xml" ) {
				origWidth = img.style.width;
				img.style.width = (img.offsetWidth + 1) + "px";
	
				// next line only should trigger a repaint
				// if... is only done to trick dead code removal
				if ( img.offsetWidth + 1 ) {
					img.style.width = origWidth;
				}
			}
		};
	
		pf.getSet = function( img ) {
			var i, set, supportsType;
			var match = false;
			var sets = img [ pf.ns ].sets;
	
			for ( i = 0; i < sets.length && !match; i++ ) {
				set = sets[i];
	
				if ( !set.srcset || !pf.matchesMedia( set.media ) || !(supportsType = pf.supportsType( set.type )) ) {
					continue;
				}
	
				if ( supportsType === "pending" ) {
					set = supportsType;
				}
	
				match = set;
				break;
			}
	
			return match;
		};
	
		pf.parseSets = function( element, parent, options ) {
			var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;
	
			var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
			var imageData = element[ pf.ns ];
	
			if ( imageData.src === undefined || options.src ) {
				imageData.src = getImgAttr.call( element, "src" );
				if ( imageData.src ) {
					setImgAttr.call( element, srcAttr, imageData.src );
				} else {
					removeImgAttr.call( element, srcAttr );
				}
			}
	
			if ( imageData.srcset === undefined || options.srcset || !pf.supSrcset || element.srcset ) {
				srcsetAttribute = getImgAttr.call( element, "srcset" );
				imageData.srcset = srcsetAttribute;
				srcsetParsed = true;
			}
	
			imageData.sets = [];
	
			if ( hasPicture ) {
				imageData.pic = true;
				getAllSourceElements( parent, imageData.sets );
			}
	
			if ( imageData.srcset ) {
				imageSet = {
					srcset: imageData.srcset,
					sizes: getImgAttr.call( element, "sizes" )
				};
	
				imageData.sets.push( imageSet );
	
				isWDescripor = (alwaysCheckWDescriptor || imageData.src) && regWDesc.test(imageData.srcset || "");
	
				// add normal src as candidate, if source has no w descriptor
				if ( !isWDescripor && imageData.src && !getCandidateForSrc(imageData.src, imageSet) && !imageSet.has1x ) {
					imageSet.srcset += ", " + imageData.src;
					imageSet.cands.push({
						url: imageData.src,
						d: 1,
						set: imageSet
					});
				}
	
			} else if ( imageData.src ) {
				imageData.sets.push( {
					srcset: imageData.src,
					sizes: null
				} );
			}
	
			imageData.curCan = null;
			imageData.curSrc = undefined;
	
			// if img has picture or the srcset was removed or has a srcset and does not support srcset at all
			// or has a w descriptor (and does not support sizes) set support to false to evaluate
			imageData.supported = !( hasPicture || ( imageSet && !pf.supSrcset ) || (isWDescripor && !pf.supSizes) );
	
			if ( srcsetParsed && pf.supSrcset && !imageData.supported ) {
				if ( srcsetAttribute ) {
					setImgAttr.call( element, srcsetAttr, srcsetAttribute );
					element.srcset = "";
				} else {
					removeImgAttr.call( element, srcsetAttr );
				}
			}
	
			if (imageData.supported && !imageData.srcset && ((!imageData.src && element.src) ||  element.src !== pf.makeUrl(imageData.src))) {
				if (imageData.src === null) {
					element.removeAttribute("src");
				} else {
					element.src = imageData.src;
				}
			}
	
			imageData.parsed = true;
		};
	
		pf.fillImg = function(element, options) {
			var imageData;
			var extreme = options.reselect || options.reevaluate;
	
			// expando for caching data on the img
			if ( !element[ pf.ns ] ) {
				element[ pf.ns ] = {};
			}
	
			imageData = element[ pf.ns ];
	
			// if the element has already been evaluated, skip it
			// unless `options.reevaluate` is set to true ( this, for example,
			// is set to true when running `picturefill` on `resize` ).
			if ( !extreme && imageData.evaled === evalId ) {
				return;
			}
	
			if ( !imageData.parsed || options.reevaluate ) {
				pf.parseSets( element, element.parentNode, options );
			}
	
			if ( !imageData.supported ) {
				applyBestCandidate( element );
			} else {
				imageData.evaled = evalId;
			}
		};
	
		pf.setupRun = function() {
			if ( !alreadyRun || isVwDirty || (DPR !== window.devicePixelRatio) ) {
				updateMetrics();
			}
		};
	
		// If picture is supported, well, that's awesome.
		if ( pf.supPicture ) {
			picturefill = noop;
			pf.fillImg = noop;
		} else {
	
			 // Set up picture polyfill by polling the document
			(function() {
				var isDomReady;
				var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;
	
				var run = function() {
					var readyState = document.readyState || "";
	
					timerId = setTimeout(run, readyState === "loading" ? 200 :  999);
					if ( document.body ) {
						pf.fillImgs();
						isDomReady = isDomReady || regReady.test(readyState);
						if ( isDomReady ) {
							clearTimeout( timerId );
						}
	
					}
				};
	
				var timerId = setTimeout(run, document.body ? 9 : 99);
	
				// Also attach picturefill on resize and readystatechange
				// http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
				var debounce = function(func, wait) {
					var timeout, timestamp;
					var later = function() {
						var last = (new Date()) - timestamp;
	
						if (last < wait) {
							timeout = setTimeout(later, wait - last);
						} else {
							timeout = null;
							func();
						}
					};
	
					return function() {
						timestamp = new Date();
	
						if (!timeout) {
							timeout = setTimeout(later, wait);
						}
					};
				};
				var lastClientWidth = docElem.clientHeight;
				var onResize = function() {
					isVwDirty = Math.max(window.innerWidth || 0, docElem.clientWidth) !== units.width || docElem.clientHeight !== lastClientWidth;
					lastClientWidth = docElem.clientHeight;
					if ( isVwDirty ) {
						pf.fillImgs();
					}
				};
	
				on( window, "resize", debounce(onResize, 99 ) );
				on( document, "readystatechange", run );
			})();
		}
	
		pf.picturefill = picturefill;
		//use this internally for easy monkey patching/performance testing
		pf.fillImgs = picturefill;
		pf.teardownRun = noop;
	
		/* expose methods for testing */
		picturefill._ = pf;
	
		window.picturefillCFG = {
			pf: pf,
			push: function(args) {
				var name = args.shift();
				if (typeof pf[name] === "function") {
					pf[name].apply(pf, args);
				} else {
					cfg[name] = args[0];
					if (alreadyRun) {
						pf.fillImgs( { reselect: true } );
					}
				}
			}
		};
	
		while (setOptions && setOptions.length) {
			window.picturefillCFG.push(setOptions.shift());
		}
	
		/* expose picturefill */
		window.picturefill = picturefill;
	
		/* expose picturefill */
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// CommonJS, just export
			module.exports = picturefill;
		} else if ( true ) {
			// AMD support
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return picturefill; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
		// IE8 evals this sync, so it must be the last thing we do
		if ( !pf.supPicture ) {
			types[ "image/webp" ] = detectTypeSupport("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" );
		}
	
	} )( window, document );


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/common.c279abf3ef61e771ba2c.js